import { POST_TYPE } from '@dashhudson/dashing-ui/models';
import * as TOKENS from '@dashhudson/dashing-ui/tokens';
import Formatters from '@dashhudson/dashing-ui/utils/formatters';

import enumTypes from '@/app/library/constants';
import emptyCampaignAddAdCampaigns1x from '@/assets/images/campaigns/empty-campaign-add-ad-campaigns/1x.png';
import emptyCampaignAddAdCampaigns2x from '@/assets/images/campaigns/empty-campaign-add-ad-campaigns/2x.png';
import emptyCampaignAddAdCampaigns3x from '@/assets/images/campaigns/empty-campaign-add-ad-campaigns/3x.png';
import emptyCampaignAddBoards1x from '@/assets/images/campaigns/empty-campaign-add-boards/1x.png';
import emptyCampaignAddBoards2x from '@/assets/images/campaigns/empty-campaign-add-boards/2x.png';
import emptyCampaignAddBoards3x from '@/assets/images/campaigns/empty-campaign-add-boards/3x.png';
import emptyCampaignAddCreators1x from '@/assets/images/campaigns/empty-campaign-add-creators/1x.png';
import emptyCampaignAddCreators2x from '@/assets/images/campaigns/empty-campaign-add-creators/2x.png';
import emptyCampaignAddCreators3x from '@/assets/images/campaigns/empty-campaign-add-creators/3x.png';
import emptyCampaignAddMedia1x from '@/assets/images/campaigns/empty-campaign-add-media/1x.png';
import emptyCampaignAddMedia2x from '@/assets/images/campaigns/empty-campaign-add-media/2x.png';
import emptyCampaignAddMedia3x from '@/assets/images/campaigns/empty-campaign-add-media/3x.png';
import newEmptyCampaignAddAdCampaigns1x from '@/assets/images/campaigns-new/empty-campaign-add-ad-campaigns/1x.png';
import newEmptyCampaignAddAdCampaigns2x from '@/assets/images/campaigns-new/empty-campaign-add-ad-campaigns/2x.png';
import newEmptyCampaignAddAdCampaigns3x from '@/assets/images/campaigns-new/empty-campaign-add-ad-campaigns/3x.png';
import newEmptyCampaignAddBoards1x from '@/assets/images/campaigns-new/empty-campaign-add-boards/1x.png';
import newEmptyCampaignAddBoards2x from '@/assets/images/campaigns-new/empty-campaign-add-boards/2x.png';
import newEmptyCampaignAddBoards3x from '@/assets/images/campaigns-new/empty-campaign-add-boards/3x.png';
import newEmptyCampaignAddCreators1x from '@/assets/images/campaigns-new/empty-campaign-add-creators/1x.png';
import newEmptyCampaignAddCreators2x from '@/assets/images/campaigns-new/empty-campaign-add-creators/2x.png';
import newEmptyCampaignAddCreators3x from '@/assets/images/campaigns-new/empty-campaign-add-creators/3x.png';
import newEmptyCampaignAddMedia1x from '@/assets/images/campaigns-new/empty-campaign-add-media/1x.png';
import newEmptyCampaignAddMedia2x from '@/assets/images/campaigns-new/empty-campaign-add-media/2x.png';
import newEmptyCampaignAddMedia3x from '@/assets/images/campaigns-new/empty-campaign-add-media/3x.png';
import { toolTips } from '@/config';
import { DATA_TYPES as METRIC_DATA_TYPES } from '@/models/dashboards/metrics.constants';
import { PLATFORM_CONNECTION } from '@/models/platform/platform-connection.enum';
import { lastDateRange } from '@/utils/dateUtils';
import { srcSet } from '@/utils/srcset';
import { colours } from '@/ux/colours';

export const PDF_REPORT_WIDTH = 1440;

export const CHANNELS = Object.freeze({
  TIKTOK: 'TIKTOK',
  INSTAGRAM: 'INSTAGRAM',
  INSTAGRAM_STORY: 'INSTAGRAM_STORY',
  FACEBOOK: 'FACEBOOK',
  PINTEREST: 'PINTEREST',
  TWITTER: 'TWITTER',
  YOUTUBE: 'YOUTUBE',
  RELATIONSHIPS: 'RELATIONSHIPS',
  UGC: 'UGC',
});

export const DATA_SOURCES = Object.freeze({
  TIKTOK_LIKESHOP: 'TIKTOK_LIKESHOP',
  LIKESHOP: 'LIKESHOP',
  INSTAGRAM_CREATORS: 'INSTAGRAM_CREATORS',
  TIKTOK_CREATORS: 'TIKTOK_CREATORS',
  ...CHANNELS,
});

export const AD_SOURCES = Object.freeze({
  META_ADS: 'META_ADS',
  META_ADS_CAMPAIGNS_DETAIL: 'META_ADS_CAMPAIGN_DETAILS',
  TIKTOK_ADS: 'TIKTOK_ADS',
});

export const AD_SOURCE_NAMES = Object.freeze({
  [AD_SOURCES.META_ADS]: 'Meta',
  [AD_SOURCES.TIKTOK_ADS]: 'TikTok',
});

export const CHANNELS_FOR_POSTS_AND_BOARDS = Object.freeze([
  'instagram',
  'instagram-story',
  'tiktok',
  'facebook',
  'pinterest',
  'youtube',
  'x',
]);

export const CHANNELS_FOR_CREATORS = Object.freeze(['instagram', 'tiktok', 'youtube']);

export const CHANNELS_FOR_AD_CAMPAIGNS = Object.freeze(['tiktok', 'meta']);

export const SEARCH_DEBOUNCE_MS = 250;

export const CAMPAIGN_BOARD_GALLERY_TYPES =
  'TIKTOK,INSTAGRAM,INSTAGRAM_STORY,FACEBOOK,PINTEREST,TWITTER,YOUTUBE';

export const CAMPAIGN_LIST_SORT_OPTIONS_LEGACY = [
  {
    label: 'Recently Added',
    value: 'CREATED',
  },
  {
    label: 'Campaign Name',
    value: 'NAME',
  },
];

export const CAMPAIGN_LIST_SORT_OPTIONS = [
  {
    label: 'Date Added',
    value: 'CREATED',
  },
  {
    label: 'Name',
    value: 'NAME',
  },
];

// For users with access to premium analytics (specifically can_access_campaigns)
export const PREMIUM_ANALYTICS_ADDITIONAL_CAMPAIGN_SORT_OPTIONS = [
  {
    label: 'Avg. Eng. Rate',
    value: 'AVG_ENGAGEMENT_RATE',
  },
  {
    label: 'Video Views',
    value: 'TOTAL_VIDEO_VIEWS',
  },
  {
    label: 'Engagements',
    value: 'TOTAL_ENGAGEMENTS',
  },
  {
    label: 'Impressions',
    value: 'TOTAL_IMPRESSIONS',
  },
];

export const CAMPAIGN_LIST_DEFAULT_SORT_LEGACY = {
  sortOrder: 'ASC',
  selected: CAMPAIGN_LIST_SORT_OPTIONS_LEGACY[0],
};

export const CAMPAIGN_LIST_DEFAULT_SORT = {
  sortOrder: 'ASC',
  selected: CAMPAIGN_LIST_SORT_OPTIONS[0],
};

export const tooltips = {
  topStatNumberOfPosts: 'The number of posts published across all channels',
  topStatVideoViews: 'The number of video views on posts published across all channels',
  topStatVideoViewsV2: 'The total number of times your video posts were played',
  topStatTotalEngagements: 'The total engagements on posts published across all channels',
  topStatAvgEngagementRate:
    'The average engagement rate for your posts published across all channels',
  topStatImpressions: 'The number of impressions for your posts published across all channels',
  topStatImpressionsV2: 'The number of times your posts were viewed or displayed',
  topStatClicks: 'The number of clicks on posts published across all channels',
  noMediaOnBoard: 'There is no media in this board.',
  BarLineChartAvgEngagement: 'Your average engagement rate over the last 12 weeks from today.',
  engagementRateChart: {
    campaign: 'The average engagement rate for your posts on this channel within this Campaign',
    campaignAverage: 'The average engagement rate across all channels within this Campaign',
    channelAverage: 'The average engagement rate for this channel',
  },
  sentiment: {
    overall: 'The sentiment breakdown of comments on owned posts in this Campaign',
  },
  impressionsChart: 'The number of times your posts were viewed or displayed',
};

export const accessMessages = {
  noUserAccessTitle: "Looks like you don't have permission to use this feature!",
  noAccessMessage:
    'Dash Social brings you all of the insights you love, including Campaigns! Ask your Dash Social administrator to provide you access.',
};

export const chartColors = {
  blue: colours.CHART.SET.CHART_SET_01,
  green: colours.CHART.SET.CHART_SET_02,
  orange: colours.CHART.SET.CHART_SET_03,
};

export const channelList = {
  TIKTOK: 'TikTok',
  INSTAGRAM: 'Instagram',
  FACEBOOK: 'Facebook',
  PINTEREST: 'Pinterest',
  TWITTER: 'X',
  YOUTUBE: 'YouTube',
  INSTAGRAM_STORY: ['Instagram', 'Stories'],
};
const CAMPAIGN_STATS_METRICS = {
  NUMBER_OF_POSTS: {
    valueName: 'number_of_media',
    label: 'Number of Posts',
    isPercent: false,
  },
  VIDEO_VIEWS: {
    valueName: 'video_views',
    label: 'Video Views',
    isPercent: false,
  },
  PAID_VIDEO_VIEWS: {
    valueName: 'paid_video_views',
    label: 'Video Views (Promoted)',
    isPercent: false,
  },
  TOTAL_VIDEO_VIEWS: {
    valueName: 'total_video_views',
    label: 'Video Views',
    isPercent: false,
  },
  VIDEO_VIEWS_PROMOTED: {
    valueName: 'video_views_promoted',
    label: 'Video Views (Promoted)',
    isPercent: false,
  },
  VIDEO_VIEWS_ORGANIC: {
    valueName: 'video_views_organic',
    label: 'Video Views (Organic)',
    isPercent: false,
  },
  ENGAGEMENTS: {
    valueName: 'engagements',
    label: 'Total Engagements',
    isPercent: false,
  },
  ORGANIC_ENGAGEMENTS: {
    valueName: 'engagements',
    label: 'Engagements (Organic)',
    isPercent: false,
  },
  PAID_ENGAGEMENTS: {
    valueName: 'paid_engagements',
    label: 'Engagements (Paid)',
    isPercent: false,
  },
  ENGAGEMENTS_ORGANIC: {
    valueName: 'engagements_organic',
    label: 'Engagements (Organic)',
    isPercent: false,
  },
  ENGAGEMENTS_PROMOTED: {
    valueName: 'engagements_promoted',
    label: 'Engagements (Promoted)',
    isPercent: false,
  },
  TOTAL_ENGAGEMENTS: {
    valueName: 'total_engagements',
    label: 'Engagements',
    isPercent: false,
  },
  AVG_ENGAGEMENT_RATE: {
    valueName: 'avg_engagement_rate',
    label: 'Avg. Engagement Rate',
    isPercent: true,
  },
  AVG_ENGAGEMENT_RATE_VIEWS: {
    valueName: 'avg_engagement_rate_views',
    label: 'Avg. Eng. Rate (Video Views)',
    isPercent: true,
  },
  AVG_ENGAGEMENT_RATE_ORGANIC: {
    valueName: 'avg_engagement_rate_organic',
    label: 'Avg. Engagement Rate (Organic)',
    isPercent: true,
  },
  AVG_ENGAGEMENT_RATE_PROMOTED: {
    valueName: 'avg_engagement_rate_promoted',
    label: 'Avg. Engagement Rate (Promoted)',
    isPercent: true,
  },
  AVG_RETENTION_RATE: {
    valueName: 'avg_retention_rate',
    label: 'Avg. Retention Rate',
    isPercent: true,
  },
  AVG_REACH: {
    valueName: 'avg_reach',
    label: 'Avg. Reach',
    isPercent: false,
  },
  FYP_VIEWS: {
    valueName: 'fyp_views_percentage',
    label: 'Avg. FYP Views %',
    isPercent: true,
  },
  AVG_EFFECTIVENESS_RATE: {
    valueName: 'avg_effectiveness_rate',
    label: 'Avg. Effectiveness Rate',
    isPercent: true,
  },
  IMPRESSIONS: {
    valueName: 'impressions',
    label: 'Impressions',
    isPercent: false,
  },
  PAID_IMPRESSIONS: {
    valueName: 'paid_impressions',
    label: 'Impressions (Paid)',
    isPercent: false,
  },
  IMPRESSIONS_ORGANIC: {
    valueName: 'impressions_organic',
    label: 'Impressions (Organic)',
    isPercent: false,
  },
  IMPRESSIONS_PROMOTED: {
    valueName: 'impressions_promoted',
    label: 'Impressions (Promoted)',
    isPercent: false,
  },
  TOTAL_IMPRESSIONS: {
    valueName: 'total_impressions',
    label: 'Impressions',
    isPercent: false,
  },
  AVG_COMPLETION_RATE: {
    valueName: 'avg_completion_rate',
    label: 'Avg. Completion Rate',
    isPercent: true,
  },
  AVG_EXIT_RATE: {
    valueName: 'avg_exit_rate',
    label: 'Avg. Exit Rate',
    isPercent: true,
  },
  EXITS: {
    valueName: 'exits',
    label: 'Exits',
    isPercent: false,
  },
  LINK_CLICKS: {
    valueName: 'link_clicks',
    label: 'Link Clicks',
    isPercent: false,
  },
  LINK_CLICKS_ORGANIC: {
    valueName: 'link_clicks_organic',
    label: 'Link Clicks (Organic)',
    isPercent: false,
  },
  LINK_CLICKS_PROMOTED: {
    valueName: 'link_clicks_promoted',
    label: 'Link Clicks (Promoted)',
    isPercent: false,
  },
  OUTBOUND_CLICKS: {
    valueName: 'link_clicks',
    label: 'Outbound Clicks',
    isPercent: false,
  },
  SAVES: {
    valueName: 'saves',
    label: 'Saves',
    isPercent: false,
  },
  COMMENTS: {
    valueName: 'comments',
    label: 'Comments',
    isPercent: false,
  },
  MENTIONS: {
    valueName: 'mentions',
    label: 'Mentions',
    isPercent: false,
  },
  PEOPLE_TAGS: {
    valueName: 'people_tags',
    label: 'People Tags',
    isPercent: false,
  },
  AVG_ESTIMATED_REACH: {
    valueName: 'estimated_reach',
    label: 'Avg. Estimated Reach',
    tooltip:
      'The average of the estimated number of unique accounts who saw each post published during the reporting period',
    isPercent: false,
  },
  LIKES: {
    valueName: 'likes',
    label: 'Likes',
    isPercent: false,
  },
  LIKES_ORGANIC: {
    valueName: 'likes_organic',
    label: 'Likes (Organic)',
    isPercent: false,
  },
  LIKES_PROMOTED: {
    valueName: 'likes_promoted',
    label: 'Likes (Promoted)',
    isPercent: false,
  },
  WATCH_TIME: {
    valueName: 'watch_time',
    label: 'Watch Time',
    isPercent: false,
  },
  AVG_VIEW_DURATION: {
    valueName: 'avg_view_duration',
    label: 'Avg. View Duration',
    isPercent: false,
  },
  DISLIKES: {
    valueName: 'dislikes',
    label: 'Dislikes',
    isPercent: false,
  },
};

export const CAMPAIGN_TOP_LINE_STATS = {
  INSTAGRAM: [
    {
      title: 'Views',
      valueKey: 'views',
      organicKey: 'views',
      tooltip:
        "The number of times your posts in this Campaign were displayed on a person's screen. This includes repeat views.",
      format: 'number',
      postType: 'ORGANIC',
      metricTimeFrame: 'POSTS_THIS_PERIOD',
    },
    {
      title: 'Avg. Watch Time',
      valueKey: 'avg_avg_watch_time_sec',
      organicKey: 'avg_avg_watch_time_sec',
      tooltip:
        'The average amount of time users spent playing your Reels in this Campaign in a single viewing',
      format: 'duration',
      postType: 'ORGANIC',
      metricTimeFrame: 'POSTS_THIS_PERIOD',
    },
    {
      title: 'Engagements',
      valueKey: 'engagements',
      organicKey: 'engagements',
      tooltip: {
        content: 'The sum of engagements received on your posts in this Campaign',
        footer:
          'Engagements = (Likes + Saves + Comments + Shares + Reposts) - (Unlikes + Unsaves + Deleted comments)',
      },
      format: 'number',
      postType: 'ORGANIC',
      metricTimeFrame: 'POSTS_THIS_PERIOD',
    },
    {
      title: 'Avg. Eng. Rate (Followers)',
      valueKey: 'avg_engagement_rate',
      organicKey: 'avg_engagement_rate',
      format: 'percent',
      formatOptions: {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      },
      postType: 'ORGANIC',
      metricTimeFrame: 'POSTS_THIS_PERIOD',
      tooltip: {
        footer: 'Instagram Avg. Engagement Rate = (Engagements / Followers) / Number of Posts',
      },
    },
    {
      title: 'Avg. Eng. Rate (Views)',
      valueKey: 'avg_engagement_rate_views',
      organicKey: 'avg_engagement_rate_views',
      format: 'percent',
      formatOptions: {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      },
      postType: 'ORGANIC',
      metricTimeFrame: 'POSTS_THIS_PERIOD',
      tooltip: {
        footer: 'Instagram Avg. Engagement Rate = (Engagements / Views) / Number of Posts',
      },
      flag: 'campaignsOwnedMetricUpdates',
      includeWithFlag: true,
    },
    {
      title: 'Avg. Effectiveness Rate',
      valueKey: 'avg_effectiveness_engagements_rate',
      organicKey: 'avg_effectiveness_engagements_rate',
      format: 'percent',
      formatOptions: {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      },
      postType: 'ORGANIC',
      metricTimeFrame: 'POSTS_THIS_PERIOD',
      tooltip: {
        content:
          'The average percentage of users that saw your posts in this Campaign and engaged with them',
        footer: 'Avg. Effectiveness Rate = Engagements / Reach',
      },
    },
    {
      title: 'Avg. Reach',
      format: 'number',
      formatOptions: {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      },
      postType: 'ORGANIC',
      metricTimeFrame: 'POSTS_THIS_PERIOD',
      tooltip: 'The average number of unique accounts who saw your posts in this Campaign',
      valueKey: 'avg_reach',
      organicKey: 'avg_reach',
    },
  ],
  TIKTOK: [
    {
      title: 'Video Views',
      valueKey: 'video_views',
      tooltip: 'The number of times your posts in this Campaign were viewed',
      format: 'number',
      postType: 'ORGANIC_PROMOTED',
      metricTimeFrame: 'POSTS_THIS_PERIOD',
    },
    {
      title: 'Engagements',
      valueKey: 'engagements',
      tooltip: {
        content: 'The sum of engagements for your posts in this Campaign',
        footer: 'Engagements = Likes + Comments + Shares',
      },
      format: 'number',
      postType: 'ORGANIC_PROMOTED',
      metricTimeFrame: 'POSTS_THIS_PERIOD',
    },
    {
      title: 'Avg. Eng. Rate (Reach)',
      valueKey: 'avg_engagement_rate',
      tooltip: {
        footer: 'Avg. Engagement Rate = (Engagements / Reach) / Number of Posts',
      },
      postType: 'ORGANIC_PROMOTED',
      metricTimeFrame: 'POSTS_THIS_PERIOD',
      format: 'percent',
      formatOptions: {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      },
    },
    {
      title: 'Avg. Eng. Rate (Video Views)',
      valueKey: 'avg_engagement_rate_views',
      tooltip: {
        footer: 'Avg. Engagement Rate = (Engagements / Video Views) / Number of Posts',
      },
      postType: 'ORGANIC_PROMOTED',
      metricTimeFrame: 'POSTS_THIS_PERIOD',
      format: 'percent',
      formatOptions: {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      },
      flag: 'campaignsOwnedMetricUpdates',
      includeWithFlag: true,
    },
    {
      title: 'Avg. Retention Rate',
      valueKey: 'avg_retention_rate',
      tooltip: {
        content:
          'The average percentage of your videos in this Campaign that your audience watched',
        footer: 'Retention Rate = Average Time Watched / Video Duration',
      },
      format: 'percent',
      formatOptions: {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      },
      postType: 'ORGANIC_PROMOTED',
      metricTimeFrame: 'POSTS_THIS_PERIOD',
    },
    {
      title: 'Avg. Reach',
      valueKey: 'avg_reach',
      tooltip: 'The average number of unique accounts who saw your posts in this Campaign',
      format: 'number',
      formatOptions: {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      },
      postType: 'ORGANIC_PROMOTED',
      metricTimeFrame: 'POSTS_THIS_PERIOD',
    },
    {
      title: 'Avg. FYP Views %',
      valueKey: 'fyp_views_percentage',
      tooltip:
        'The average percentage of your videos in this Campaign that your audience watched on their For You Page',
      format: 'percent',
      formatOptions: {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      },
      postType: 'ORGANIC_PROMOTED',
      metricTimeFrame: 'POSTS_THIS_PERIOD',
    },
  ],
  INSTAGRAM_STORY: [
    {
      title: 'Avg. Reach',
      valueKey: 'avg_reach',
      tooltip: 'The average number of unique accounts who saw your story frames in this Campaign',
      format: 'number',
      formatOptions: {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      },
      postType: 'ORGANIC',
      metricTimeFrame: 'POSTS_THIS_PERIOD',
    },
    {
      title: 'Views',
      valueKey: 'views',
      tooltip:
        'The number of times your story frames in this Campaign were displayed.\n\nThis metric is only available for reporting after March 24, 2025.',
      format: 'number',
      formatOptions: {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      },
      postType: 'ORGANIC',
      metricTimeFrame: 'POSTS_THIS_PERIOD',
    },
    {
      title: 'Avg. Completion Rate',
      valueKey: 'avg_completion_rate_views',
      tooltip: {
        content:
          'The average completion rate of the story frames in this Campaign.\n\nThis metric is only available for reporting after March 24, 2025.',
        footer: 'Completion Rate = (Views - Exits) / Views',
      },
      format: 'percent',
      formatOptions: {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      },
      postType: 'ORGANIC',
      metricTimeFrame: 'POSTS_THIS_PERIOD',
    },
    {
      title: 'Avg. Exit Rate',
      valueKey: 'avg_exit_rate_views',
      tooltip: {
        content:
          'The average exit rate of the story frames in this Campaign.\n\nThis metric is only available for reporting after March 24, 2025.',
        footer: 'Exit Rate = Exits / Views',
      },
      format: 'percent',
      formatOptions: {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      },
      postType: 'ORGANIC',
      metricTimeFrame: 'POSTS_THIS_PERIOD',
    },
    {
      title: 'Exits',
      valueKey: 'exits',
      tooltip:
        'The amount of users who exited the stories view without clicking forward or watching the entire story. An exit is counted even if it occurs at the last millisecond.',
      format: 'number',
      postType: 'ORGANIC',
      metricTimeFrame: 'POSTS_THIS_PERIOD',
    },
    {
      title: 'Link Clicks',
      valueKey: 'link_clicks',
      tooltip:
        'The number of link clicks on story frames in this Campaign.\n\nOnly links scheduled through the Dash scheduler are trackable here.',
      format: 'number',
      postType: 'ORGANIC',
      metricTimeFrame: 'POSTS_THIS_PERIOD',
    },
  ],
  FACEBOOK: [
    {
      title: 'Views (Video Media)',
      valueKey: 'views_only_videos',
      tooltip: 'The number of times your videos were played for at least 1ms.',
      format: 'number',
      postType: 'ORGANIC_PROMOTED',
      metricTimeFrame: 'POSTS_THIS_PERIOD',
    },
    {
      title: 'Views',
      valueKey: 'views',
      tooltip:
        'The number of times your videos were played for at least 1ms plus the number of times your photos and text posts were on screen.',
      format: 'number',
      postType: 'ORGANIC_PROMOTED',
      metricTimeFrame: 'POSTS_THIS_PERIOD',
    },
    {
      title: 'Engagements',
      valueKey: 'engagements_v2',
      tooltip: {
        content: 'The sum of engagements on your posts',
        footer:
          'Engagements = Reactions + Shares + Comments\n\nReactions include Likes, Love, Haha, Wow, Sad, Angry and Care',
      },
      format: 'number',
      postType: 'ORGANIC_PROMOTED',
      metricTimeFrame: 'POSTS_THIS_PERIOD',
    },
    {
      title: 'Avg. Engagement Rate',
      valueKey: 'avg_engagement_rate_v2',
      tooltip: {
        content: 'The average engagement rate for your posts',
        footer: 'Engagement Rate = (Engagements / Views) / Number of Posts',
      },
      format: 'percent',
      formatOptions: {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      },
      postType: 'ORGANIC_PROMOTED',
      metricTimeFrame: 'POSTS_THIS_PERIOD',
    },
    {
      title: 'Avg. Effectiveness',
      valueKey: 'avg_effectiveness_rate_v2',
      tooltip: {
        content: 'The percentage of users that saw your post and engaged with it',
        footer: 'Effectiveness = (Engagements / Reach) / Number of Posts',
      },
      format: 'percent',
      formatOptions: {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      },
      postType: 'ORGANIC_PROMOTED',
      metricTimeFrame: 'POSTS_THIS_PERIOD',
    },
    {
      title: 'Avg. Reach',
      valueKey: 'avg_reach_v2',
      tooltip: {
        content: 'The average reach for your posts in this Campaign',
        footer: 'Average Reach = Reach / Number of Posts',
      },
      format: 'number',
      formatOptions: {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      },
      postType: 'ORGANIC_PROMOTED',
      metricTimeFrame: 'POSTS_THIS_PERIOD',
      flag: 'fbMetricsDeprecation2026',
      includeWithFlag: false,
    },
    {
      title: 'Avg. Viewers',
      valueKey: 'avg_reach_v2',
      tooltip: ({ startDate } = {}) => {
        const result = {
          content:
            'The average number of unique accounts that have viewed your posts in this Campaign at least once.',
          footer: 'Avg. Viewers = Viewers / Number of Posts',
        };
        if (startDate?.isBefore('2025-07-31', 'day')) {
          result.footer +=
            ' - Note: This campaign includes a mix of Viewers and legacy Reach values from posts published before July 31st 2025.';
        }
        return result;
      },
      format: 'number',
      formatOptions: {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      },
      postType: 'ORGANIC_PROMOTED',
      metricTimeFrame: 'POSTS_THIS_PERIOD',
      flag: 'fbMetricsDeprecation2026',
      includeWithFlag: true,
    },
  ],
  PINTEREST: [
    {
      title: 'Video Views',
      valueKey: 'video_views',
      tooltip: 'The number of views for at least two seconds with 50% of the video Pin in view',
      format: 'number',
      postType: 'ORGANIC',
      metricTimeFrame: 'POSTS_THIS_PERIOD',
    },
    {
      title: 'Impressions',
      valueKey: 'impressions',
      tooltip: 'The number of times your Pins in this Campaign were displayed ',
      format: 'number',
      postType: 'ORGANIC',
      metricTimeFrame: 'POSTS_THIS_PERIOD',
    },
    {
      title: 'Engagements',
      valueKey: 'engagements',
      tooltip: {
        content: 'The sum of engagements your Pins in this Campaign received',
        footer: 'Engagements = Pin Clicks + Outbound Clicks + Saves',
      },
      format: 'number',
      postType: 'ORGANIC',
      metricTimeFrame: 'POSTS_THIS_PERIOD',
    },
    {
      title: 'Avg. Engagement Rate',
      valueKey: 'avg_engagement_rate',
      tooltip: {
        content: 'The average engagement rate for your Pins in this Campaign',
        footer: 'Engagement Rate = (Pin Clicks + Outbound Clicks + Saves) / Impressions',
      },
      format: 'percent',
      formatOptions: {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      },
      postType: 'ORGANIC',
      metricTimeFrame: 'POSTS_THIS_PERIOD',
    },
    {
      title: 'Saves',
      valueKey: 'saves',
      tooltip: 'The number of times your Pins in this Campaign were saved',
      format: 'number',
      postType: 'ORGANIC',
      metricTimeFrame: 'POSTS_THIS_PERIOD',
    },
    {
      title: 'Outbound Clicks',
      valueKey: 'outbound_clicks',
      tooltip:
        'The total number of times people clicked and followed the links attached to your Pins to the destination URL',
      format: 'number',
      postType: 'ORGANIC',
      metricTimeFrame: 'POSTS_THIS_PERIOD',
    },
  ],
  TWITTER: [
    {
      title: 'Video Views',
      valueKey: 'video_views',
      tooltip: 'The number of times your videos in this Campaign were viewed',
      format: 'number',
      postType: 'ORGANIC_PROMOTED',
      metricTimeFrame: 'POSTS_THIS_PERIOD',
    },
    {
      title: 'Impressions',
      valueKey: 'impressions',
      tooltip: 'The number of times your posts in this Campaign were displayed',
      format: 'number',
      postType: 'ORGANIC_PROMOTED',
      metricTimeFrame: 'POSTS_THIS_PERIOD',
    },
    {
      title: 'Engagements',
      valueKey: 'engagements',
      tooltip: {
        content: 'The sum of engagements your posts in this Campaign received',
        footer: 'Engagements = Reposts + Replies + Likes + Link Clicks',
      },
      format: 'number',
      postType: 'ORGANIC_PROMOTED',
      metricTimeFrame: 'POSTS_THIS_PERIOD',
    },
    {
      title: 'Avg. Engagement Rate',
      valueKey: 'avg_engagement_rate',
      tooltip: {
        content: 'The average engagement rate for your posts in this Campaign',
        footer: 'Engagement Rate = Engagements / Impressions',
      },
      format: 'percent',
      formatOptions: {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      },
      postType: 'ORGANIC_PROMOTED',
      metricTimeFrame: 'POSTS_THIS_PERIOD',
    },
    {
      title: 'Likes',
      valueKey: 'likes',
      tooltip: 'The number of times your posts in this Campaign were liked',
      format: 'number',
      postType: 'ORGANIC_PROMOTED',
      metricTimeFrame: 'POSTS_THIS_PERIOD',
    },
    {
      title: 'Link Clicks',
      valueKey: 'link_clicks',
      tooltip: 'The number of times people clicked your links in this Campaign',
      format: 'number',
      postType: 'ORGANIC_PROMOTED',
      metricTimeFrame: 'POSTS_THIS_PERIOD',
    },
  ],
  UGC: [
    {
      title: 'Number of Posts',
      valueKey: 'number_of_media',
      tooltip: 'The number of posts that mentioned or tagged you',
      format: 'number',
      postType: 'ORGANIC',
      metricTimeFrame: 'POSTS_THIS_PERIOD',
    },
    {
      title: 'Mentions',
      valueKey: 'mentions',
      tooltip: `The number of times you were @mentioned by other accounts in post captions`,
      format: 'number',
      postType: 'ORGANIC',
      metricTimeFrame: 'POSTS_THIS_PERIOD',
    },
    {
      title: 'People Tags',
      valueKey: 'people_tags',
      tooltip: `The number of times you were tagged in posts by other accounts`,
      format: 'number',
      postType: 'ORGANIC',
      metricTimeFrame: 'POSTS_THIS_PERIOD',
    },
    {
      title: 'Avg. Estimated Reach',
      valueKey: 'estimated_reach',
      tooltip: {
        content:
          'The average number of unique accounts who saw UGC posts that @mentioned or tagged you',
        footer: 'Avg. Estimated Reach = Estimated Reach / Number of Posts',
      },
      format: 'number',
      formatOptions: {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      },
      postType: 'ORGANIC',
      metricTimeFrame: 'POSTS_THIS_PERIOD',
    },
    {
      title: 'Engagements',
      valueKey: 'engagements',
      tooltip: {
        content: 'The sum of engagements UGC posts that @mentioned or tagged you received',
        footer: 'Engagements = Likes + Comments',
      },
      format: 'number',
      postType: 'ORGANIC',
      metricTimeFrame: 'POSTS_THIS_PERIOD',
    },
  ],
  YOUTUBE: [
    {
      title: 'Video Views',
      valueKey: 'video_views',
      tooltip: 'The number of times your videos in this Campaign were viewed',
      format: 'number',
      postType: 'ORGANIC_PROMOTED',
      metricTimeFrame: 'POSTS_THIS_PERIOD',
    },
    {
      title: 'Engagements',
      valueKey: 'engagements',
      tooltip: 'The total number of engagements your videos in this Campaign received',
      format: 'number',
      postType: 'ORGANIC_PROMOTED',
      metricTimeFrame: 'POSTS_THIS_PERIOD',
    },
    {
      title: 'Watch Time',
      valueKey: 'watch_time',
      tooltip: 'The total amount of time that users watched your videos in this Campaign',
      format: 'duration',
      postType: 'ORGANIC_PROMOTED',
      metricTimeFrame: 'POSTS_THIS_PERIOD',
    },
    {
      title: 'Avg. View Duration',
      valueKey: 'avg_view_duration',
      tooltip: 'The average amount of time that viewers watched per video view ',
      format: 'duration',
      postType: 'ORGANIC_PROMOTED',
      metricTimeFrame: 'POSTS_THIS_PERIOD',
    },
    {
      title: 'Likes',
      valueKey: 'likes',
      tooltip: 'The number of times your videos in this Campaign were liked',
      format: 'number',
      postType: 'ORGANIC_PROMOTED',
      metricTimeFrame: 'POSTS_THIS_PERIOD',
    },
    {
      title: 'Dislikes',
      valueKey: 'dislikes',
      tooltip: 'The number of dislikes on your videos in this Campaign',
      format: 'number',
      postType: 'ORGANIC_PROMOTED',
      metricTimeFrame: 'POSTS_THIS_PERIOD',
    },
  ],
  RELATIONSHIPS: [
    {
      title: 'Number of Posts',
      valueKey: 'number_of_media',
      tooltip: 'The number of posts that mentioned or tagged you',
      format: 'number',
      postType: 'ORGANIC',
      metricTimeFrame: 'POSTS_THIS_PERIOD',
    },
    {
      title: 'Views',
      valueKey: 'video_views',
      tooltip: 'The number of views on your posts in this Campaign for connected accounts',
      format: 'number',
      postType: 'ORGANIC',
      metricTimeFrame: 'POSTS_THIS_PERIOD',
    },
    {
      title: 'Avg. Engagement Rate',
      valueKey: 'avg_engagement_rate',
      tooltip: {
        content: "The average percentage of the creators' audiences that engaged",
        footer: 'Engagement Rate = (Likes + Comments) / Followers',
      },
      format: 'percent',
      formatOptions: {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      },
      postType: 'ORGANIC',
      metricTimeFrame: 'POSTS_THIS_PERIOD',
    },
    {
      title: 'Engagements',
      valueKey: 'engagements',
      tooltip: {
        content: 'The total number of engagements on posts in this Campaign',
        footer: 'Engagements = Likes + Comments + (Saves + Shares + Reposts if connected)',
      },
      format: 'number',
      postType: 'ORGANIC',
      metricTimeFrame: 'POSTS_THIS_PERIOD',
    },
    {
      title: 'Likes',
      valueKey: 'likes',
      tooltip: 'The number of likes on posts in this Campaign',
      format: 'number',
      postType: 'ORGANIC',
      metricTimeFrame: 'POSTS_THIS_PERIOD',
    },
    {
      title: 'Comments',
      valueKey: 'comments',
      tooltip: 'The number of comments on posts in this Campaign',
      format: 'number',
      postType: 'ORGANIC',
      metricTimeFrame: 'POSTS_THIS_PERIOD',
    },
  ],
};

export const CAMPAIGN_ADS_TOP_LINE_STATS = Object.freeze({
  [AD_SOURCES.META_ADS]: [
    { metric: 'TOTAL_SPENT' },
    { metric: 'IMPRESSIONS' },
    { metric: 'LINK_CLICKS' },
    { metric: 'VIDEO_VIEWS' },
    { metric: 'CLICK_THROUGH_RATE' },
    { metric: 'COST_PER_MILE' },
    { metric: 'COST_PER_CLICK' },
    { metric: 'ENGAGEMENT_RATE' },
  ],
  [AD_SOURCES.TIKTOK_ADS]: [
    { metric: 'TOTAL_SPENT' },
    { metric: 'IMPRESSIONS' },
    { metric: 'ENGAGEMENTS' },
    { metric: 'CLICK_THROUGH_RATE_DESTINATION' },
    { metric: 'ENGAGED_VIEW' },
    { metric: 'COST_PER_MILE' },
    { metric: 'COST_PER_CLICK' },
    { metric: 'REAL_TIME_CONVERSION_RATE' },
  ],
  MULTI_CHANNEL: [
    { metric: 'TOTAL_SPENT' },
    { metric: 'AVG_COST_PER_CLICK' },
    { metric: 'AVG_COST_PER_MILE' },
    { metric: 'CLICKS_ALL_ADS' },
    { metric: 'IMPRESSIONS_ADS' },
    { metric: 'CLICKS_ADS' },
  ],
});

export const CAMPAIGN_SOURCE_TO_DASHING_UI_CHANNEL = Object.freeze({
  [CHANNELS.INSTAGRAM]: 'instagram',
  [CHANNELS.INSTAGRAM_STORY]: 'instagram_story',
  [CHANNELS.TIKTOK]: 'tiktok',
  [CHANNELS.FACEBOOK]: 'facebook',
  [CHANNELS.PINTEREST]: 'pinterest',
  [CHANNELS.TWITTER]: 'x',
  [CHANNELS.YOUTUBE]: 'youtube',
  [AD_SOURCES.META_ADS]: 'meta',
  [AD_SOURCES.TIKTOK_ADS]: 'tiktok',
  [CHANNELS.UGC]: 'instagram',
  [DATA_SOURCES.LIKESHOP]: 'instagram',
  [DATA_SOURCES.TIKTOK_LIKESHOP]: 'tiktok',
});

export const AD_SOURCE_PLATFORM_MEDIA_TYPE_MAPPING = Object.freeze({
  [AD_SOURCES.META_ADS]: {
    photo: 'ads-image',
    image: 'ads-image',
    video: 'ads-video',
    reel: 'ads-video',
    carousel: 'ads-carousel',
    link: 'ads-link',
    event: 'ads-event',
  },
  [AD_SOURCES.TIKTOK_ADS]: {
    SINGLE_IMAGE: 'ads-image',
    SINGLE_VIDEO: 'ads-video',
    CAROUSEL_ADS: 'ads-carousel',
    CATALOG_CAROUSEL: 'ads-catalog-carousel',
    LIVE_CONTENT: 'ads-live',
  },
});

export const AD_SOURCE_PLATFORM_CONNECTIONS = Object.freeze({
  [AD_SOURCES.META_ADS]: PLATFORM_CONNECTION.FACEBOOK_ADS_NEW,
  [AD_SOURCES.TIKTOK_ADS]: PLATFORM_CONNECTION.TIKTOK_ADS,
});

export const META_ADS_MEDIA_POST_TYPE_PRIORITY = Object.freeze({
  photo: 0,
  image: 0,
  video: 0,
  reel: 0,
  link: 1, // We should only choose link posts if there are no other ad placements
  event: 0,
});

export const AD_METRIC_TO_AD_POST_VALUE_KEY = Object.freeze({
  [AD_SOURCES.META_ADS]: {
    TOTAL_SPENT: 'spend',
    CLICKS: 'clicks',
    CONVERSION_RATE: 'conversion_rate',
    COST_PER_CLICK: 'cpc',
    COST_PER_MILE: 'cpm',
    CLICK_THROUGH_RATE: 'ctr',
    ENGAGEMENT_RATE: 'engagement_rate',
    ENGAGEMENTS: 'engagements',
    FREQUENCY: 'frequency',
    IMPRESSIONS: 'impressions',
    LINK_CLICKS: 'link_clicks',
    PAGE_ENGAGEMENTS: 'page_engagements',
    REACH: 'reach',
    RETURN_ON_AD_SPEND: 'purchase_roas',
    VIDEO_VIEWS: 'video_views',
    WEB_CONVERSIONS: 'web_conversions',
  },
  [AD_SOURCES.TIKTOK_ADS]: {
    CLICKS: 'clicks',
    COST_PER_CLICK: 'cpc',
    COST_PER_MILE: 'cpm',
    CLICK_THROUGH_RATE_DESTINATION: 'ctr',
    ENGAGED_VIEW: 'engaged_view',
    ENGAGEMENTS: 'engagements',
    FOLLOWS: 'follows',
    FREQUENCY: 'frequency',
    IMPRESSIONS: 'impressions',
    REACH: 'reach',
    REAL_TIME_CONVERSIONS: 'real_time_conversion',
    REAL_TIME_CONVERSION_RATE: 'real_time_conversion_rate_v2',
    TOTAL_SPENT: 'spend',
    VIDEO_VIEWS_P50: 'video_views_p50',
    VIDEO_VIEWS_P100: 'video_views_p100',
    VIDEO_WATCHED_6S: 'video_watched_6s',
  },
});

export const AD_SOURCE_CARD_METRICS = Object.freeze({
  [AD_SOURCES.META_ADS]: [
    {
      metric: 'COST_PER_CLICK',
      formatOptions: {
        formatOptions: { notation: 'standard' },
      },
    },
    {
      metric: 'COST_PER_MILE',
      formatOptions: {
        formatOptions: { notation: 'standard' },
      },
    },
    {
      metric: 'CLICK_THROUGH_RATE',
      normalizePercent: true,
    },
    {
      metric: 'FREQUENCY',
    },
  ],
  [AD_SOURCES.TIKTOK_ADS]: [
    {
      metric: 'COST_PER_CLICK',
      formatOptions: {
        formatOptions: { notation: 'standard' },
      },
    },
    {
      metric: 'COST_PER_MILE',
      formatOptions: {
        formatOptions: { notation: 'standard' },
      },
    },
    {
      metric: 'CLICK_THROUGH_RATE_DESTINATION',
      normalizePercent: true,
    },
    {
      metric: 'FREQUENCY',
    },
  ],
});

export const AD_STATUS = Object.freeze({
  ACTIVE: {
    label: 'Active',
    severity: 'success',
  },
  PAUSED: {
    label: 'Paused',
    severity: 'warning',
  },
  DELETED: {
    label: 'Deleted',
    severity: 'statusNeutral',
  },
  COMPLETED: {
    label: 'Completed',
    severity: 'statusNeutral',
  },
  PENDING: {
    label: 'Pending',
    severity: 'warning',
  },
  ARCHIVED: {
    label: 'Archived',
    severity: 'statusNeutral',
  },
  WITH_ISSUES: {
    label: 'With Issues',
    severity: 'danger',
  },
  OVER_BUDGET: {
    label: 'Over Budget',
    severity: 'danger',
  },
  UNKNOWN: {
    label: 'Unknown',
    severity: 'statusNeutral',
  },
});

export const AD_SOURCE_STATUS_MAPPING = Object.freeze({
  [AD_SOURCES.META_ADS]: {
    ACTIVE: AD_STATUS.ACTIVE,
    PAUSED: AD_STATUS.PAUSED,
    DELETED: AD_STATUS.DELETED,
    PENDING_REVIEW: AD_STATUS.PENDING,
    DISAPPROVED: AD_STATUS.PENDING,
    PREAPPROVED: AD_STATUS.PENDING,
    PENDING_BILLING_INFO: AD_STATUS.PENDING,
    CAMPAIGN_PAUSED: AD_STATUS.PAUSED,
    ARCHIVED: AD_STATUS.ARCHIVED,
    ADSET_PAUSED: AD_STATUS.PAUSED,
    IN_PROCESS: AD_STATUS.PENDING,
    WITH_ISSUES: AD_STATUS.WITH_ISSUES,
  },
  [AD_SOURCES.TIKTOK_ADS]: {
    AD_STATUS_ALL: AD_STATUS.PENDING,
    AD_STATUS_NOT_DELETE: AD_STATUS.PENDING,
    AD_STATUS_CAMPAIGN_DELETE: AD_STATUS.DELETED,
    AD_STATUS_ADGROUP_DELETE: AD_STATUS.DELETED,
    AD_STATUS_DELETE: AD_STATUS.DELETED,
    AD_STATUS_ADVERTISER_AUDIT_DENY: AD_STATUS.WITH_ISSUES,
    AD_STATUS_ADVERTISER_AUDIT: AD_STATUS.WITH_ISSUES,
    ADVERTISER_CONTRACT_PENDING: AD_STATUS.WITH_ISSUES,
    ADVERTISER_ACCOUNT_PUNISH: AD_STATUS.WITH_ISSUES,
    AD_STATUS_BALANCE_EXCEED: AD_STATUS.OVER_BUDGET,
    AD_STATUS_CAMPAIGN_EXCEED: AD_STATUS.OVER_BUDGET,
    AD_STATUS_BUDGET_EXCEED: AD_STATUS.OVER_BUDGET,
    AD_STATUS_AD_PRE_ONLINE: AD_STATUS.PENDING,
    AD_STATUS_AUDIT: AD_STATUS.PENDING,
    AD_STATUS_REAUDIT: AD_STATUS.PENDING,
    AD_STATUS_AUDIT_DENY: AD_STATUS.WITH_ISSUES,
    AD_STATUS_ADGROUP_AUDIT_DENY: AD_STATUS.WITH_ISSUES,
    AD_STATUS_ADGROUP_PARTIAL_AUDIT_NO_DELIVERY: AD_STATUS.PENDING,
    AD_STATUS_REVIEW_PARTIALLY_APPROVED: AD_STATUS.PENDING,
    AD_STATUS_PARTIAL_AUDIT_DELIVERY_OK: AD_STATUS.PENDING,
    AD_STATUS_PARTIAL_AUDIT_NO_DELIVERY: AD_STATUS.WITH_ISSUES,
    AD_STATUS_ADGROUP_INDUSTRY_QUALIFICATION_MISSING: AD_STATUS.WITH_ISSUES,
    AD_STATUS_ADGROUP_INDUSTRY_QUALIFICATION_EXPIRED: AD_STATUS.WITH_ISSUES,
    AD_STATUS_ADGROUP_INDUSTRY_QUALIFICATION_DENY: AD_STATUS.WITH_ISSUES,
    AD_STATUS_MUSIC_AUTHORIZATION_MISSING: AD_STATUS.WITH_ISSUES,
    AD_STAUS_PIXEL_UNBIND: AD_STATUS.WITH_ISSUES,
    AD_STATUS_LIVE_OFFLINE: AD_STATUS.PENDING,
    AD_STATUS_NOT_START: AD_STATUS.PENDING,
    AD_STATUS_DONE: AD_STATUS.COMPLETED,
    AD_STATUS_CAMPAIGN_DISABLE: AD_STATUS.WITH_ISSUES,
    AD_STATUS_ADGROUP_DISABLE: AD_STATUS.PENDING,
    ADGROUP_STATUS_FROZEN: AD_STATUS.PAUSED,
    AD_STATUS_DISABLE: AD_STATUS.WITH_ISSUES,
    AD_STATUS_DELIVERY_OK: AD_STATUS.ACTIVE,
    AD_STATUS_PROCESS_AUDIO: AD_STATUS.WITH_ISSUES,
    AD_STATUS_TRANSCODING_FAIL: AD_STATUS.WITH_ISSUES,
    AD_STATUS_ADGROUP_ASSET_AUTHORIZATION_LOST: AD_STATUS.WITH_ISSUES,
    AD_STATUS_ASSET_AUTHORIZATION_LOST: AD_STATUS.WITH_ISSUES,
    AD_STATUS_AD_QUOTA_LIMIT: AD_STATUS.PAUSED,
    AD_STATUS_PRODUCT_UNAVAILABLE: AD_STATUS.WITH_ISSUES,
    AD_STATUS_ANCHOR_UNAVAILABLE: AD_STATUS.WITH_ISSUES,
    AD_STATUS_NO_AUTHORIZATION_OF_SHOWCASE: AD_STATUS.WITH_ISSUES,
    AD_STATUS_RF_ADGROUP_CLOSED: AD_STATUS.WITH_ISSUES,
    AD_STATUS_PROMOTE_AD_OFFLINE_AUDIT: AD_STATUS.WITH_ISSUES,
    AD_STATUS_PROMOTE_ADGROUP_CLOSED: AD_STATUS.WITH_ISSUES,
  },
});

export const ADS_STATUS_UNKNOWN = Object.freeze({
  label: 'Unknown',
  severity: 'statusNeutral',
});

export const META_ADS_STATUS_FILTER_OPTIONS = Object.freeze([
  { value: 'ACTIVE', label: 'Active' },
  { value: 'PAUSED', label: 'Paused' },
  { value: 'DELETED', label: 'Deleted' },
  { value: 'ARCHIVED', label: 'Archived' },
  { value: 'WITH_ISSUES', label: 'With Issues' },
]);

export const META_ADS_EMPTY_STATE = Object.freeze({
  NO_FILTERED_ADS: Object.freeze({
    value: 'NO_FILTERED_ADS',
    variant: 'pageEmpty',
    icon: 'search',
    title: 'No Ads Match Your Filters',
    message: 'Adjust your filters to view more ads',
  }),
});

export const topLineValues = {
  tiktok: [
    CAMPAIGN_STATS_METRICS.VIDEO_VIEWS,
    CAMPAIGN_STATS_METRICS.ENGAGEMENTS,
    {
      ...CAMPAIGN_STATS_METRICS.AVG_ENGAGEMENT_RATE,
      label: 'Avg. Eng. Rate (Reach)',
      tooltip:
        'The average engagement rate of posts published during the reporting period. Engagement Rate = Total Engagements / Reach',
    },
    {
      ...CAMPAIGN_STATS_METRICS.AVG_ENGAGEMENT_RATE_VIEWS,
      tooltip:
        'The average engagement rate of posts published during the reporting period. Engagement Rate = Total Engagements / Video Views',
    },
    CAMPAIGN_STATS_METRICS.AVG_RETENTION_RATE,
    CAMPAIGN_STATS_METRICS.AVG_REACH,
    CAMPAIGN_STATS_METRICS.FYP_VIEWS,
  ],
  instagram: [
    {
      ...CAMPAIGN_STATS_METRICS.TOTAL_VIDEO_VIEWS,
      organic: {
        ...CAMPAIGN_STATS_METRICS.VIDEO_VIEWS,
        label: 'Organic',
      },
      promoted: {
        ...CAMPAIGN_STATS_METRICS.PAID_VIDEO_VIEWS,
        label: 'Promoted',
      },
    },
    {
      ...CAMPAIGN_STATS_METRICS.TOTAL_IMPRESSIONS,
      organic: {
        ...CAMPAIGN_STATS_METRICS.IMPRESSIONS,
        label: 'Organic',
      },
      promoted: {
        ...CAMPAIGN_STATS_METRICS.PAID_IMPRESSIONS,
        label: 'Promoted',
      },
    },
    {
      ...CAMPAIGN_STATS_METRICS.TOTAL_ENGAGEMENTS,
      valueName: 'engagements',
      tooltip: toolTips.instagramOverview.metrics.TOTAL_ENGAGEMENTS,
      organic: {
        ...CAMPAIGN_STATS_METRICS.ENGAGEMENTS,
        label: 'Organic',
      },
    },
    {
      ...CAMPAIGN_STATS_METRICS.AVG_ENGAGEMENT_RATE,
      label: 'Avg. Engagement Rate (Followers)',
      tooltip: toolTips.instagramOverview.averageEngagementRate,
      organic: {
        ...CAMPAIGN_STATS_METRICS.AVG_ENGAGEMENT_RATE,
        label: 'Organic',
      },
    },
    {
      ...CAMPAIGN_STATS_METRICS.AVG_EFFECTIVENESS_RATE,
      tooltip: toolTips.instagramOverview.averageEffectiveness,
      organic: {
        ...CAMPAIGN_STATS_METRICS.AVG_EFFECTIVENESS_RATE,
        label: 'Organic',
      },
    },
    {
      ...CAMPAIGN_STATS_METRICS.AVG_REACH,
      organic: {
        ...CAMPAIGN_STATS_METRICS.AVG_REACH,
        label: 'Organic',
      },
    },
  ],
  'instagram-stories': [
    CAMPAIGN_STATS_METRICS.AVG_REACH,
    CAMPAIGN_STATS_METRICS.IMPRESSIONS,
    CAMPAIGN_STATS_METRICS.AVG_COMPLETION_RATE,
    CAMPAIGN_STATS_METRICS.AVG_EXIT_RATE,
    CAMPAIGN_STATS_METRICS.EXITS,
    CAMPAIGN_STATS_METRICS.LINK_CLICKS,
  ],
  facebook: [
    CAMPAIGN_STATS_METRICS.VIDEO_VIEWS,
    CAMPAIGN_STATS_METRICS.IMPRESSIONS,
    { ...CAMPAIGN_STATS_METRICS.ENGAGEMENTS, tooltip: toolTips.facebook.engagements },
    {
      ...CAMPAIGN_STATS_METRICS.AVG_ENGAGEMENT_RATE,
      tooltip: toolTips.facebook.averageEngagementRate,
    },
    {
      ...CAMPAIGN_STATS_METRICS.AVG_EFFECTIVENESS_RATE,
      tooltip: toolTips.facebook.averageEffectiveness,
    },
    CAMPAIGN_STATS_METRICS.AVG_REACH,
  ],
  pinterest: [
    CAMPAIGN_STATS_METRICS.VIDEO_VIEWS,
    CAMPAIGN_STATS_METRICS.IMPRESSIONS,
    CAMPAIGN_STATS_METRICS.ENGAGEMENTS,
    {
      ...CAMPAIGN_STATS_METRICS.AVG_ENGAGEMENT_RATE,
      tooltip:
        'The average engagement rate of the posts published during the reporting period. Engagement Rate = (Total Engagements / Impressions)',
    },
    CAMPAIGN_STATS_METRICS.SAVES,
    CAMPAIGN_STATS_METRICS.OUTBOUND_CLICKS,
  ],
  twitter: [
    {
      ...CAMPAIGN_STATS_METRICS.VIDEO_VIEWS,
      organic: {
        ...CAMPAIGN_STATS_METRICS.VIDEO_VIEWS_ORGANIC,
        label: 'Organic',
      },
      promoted: {
        ...CAMPAIGN_STATS_METRICS.VIDEO_VIEWS_PROMOTED,
        label: 'Promoted',
      },
    },
    {
      ...CAMPAIGN_STATS_METRICS.IMPRESSIONS,
      organic: {
        ...CAMPAIGN_STATS_METRICS.IMPRESSIONS_ORGANIC,
        label: 'Organic',
      },
      promoted: {
        ...CAMPAIGN_STATS_METRICS.IMPRESSIONS_PROMOTED,
        label: 'Promoted',
      },
    },
    {
      ...CAMPAIGN_STATS_METRICS.ENGAGEMENTS,
      organic: {
        ...CAMPAIGN_STATS_METRICS.ENGAGEMENTS_ORGANIC,
        label: 'Organic',
      },
      promoted: {
        ...CAMPAIGN_STATS_METRICS.ENGAGEMENTS_PROMOTED,
        label: 'Promoted',
      },
    },
    {
      ...CAMPAIGN_STATS_METRICS.AVG_ENGAGEMENT_RATE,
      tooltip:
        'The average engagement rate of the posts published during the reporting period. Engagement Rate = (Total Engagements / Impressions)',
      organic: {
        ...CAMPAIGN_STATS_METRICS.AVG_ENGAGEMENT_RATE_ORGANIC,
        label: 'Organic',
      },
      promoted: {
        ...CAMPAIGN_STATS_METRICS.AVG_ENGAGEMENT_RATE_PROMOTED,
        label: 'Promoted',
      },
    },
    {
      ...CAMPAIGN_STATS_METRICS.LIKES,
      organic: {
        ...CAMPAIGN_STATS_METRICS.LIKES_ORGANIC,
        label: 'Organic',
      },
      promoted: {
        ...CAMPAIGN_STATS_METRICS.LIKES_PROMOTED,
        label: 'Promoted',
      },
    },
    {
      ...CAMPAIGN_STATS_METRICS.LINK_CLICKS,
      organic: {
        ...CAMPAIGN_STATS_METRICS.LINK_CLICKS_ORGANIC,
        label: 'Organic',
      },
      promoted: {
        ...CAMPAIGN_STATS_METRICS.LINK_CLICKS_PROMOTED,
        label: 'Promoted',
      },
    },
  ],
  youtube: [
    CAMPAIGN_STATS_METRICS.VIDEO_VIEWS,
    CAMPAIGN_STATS_METRICS.ENGAGEMENTS,
    CAMPAIGN_STATS_METRICS.WATCH_TIME,
    CAMPAIGN_STATS_METRICS.AVG_VIEW_DURATION,
    CAMPAIGN_STATS_METRICS.LIKES,
    CAMPAIGN_STATS_METRICS.DISLIKES,
  ],
  relationships: [
    CAMPAIGN_STATS_METRICS.NUMBER_OF_POSTS,
    CAMPAIGN_STATS_METRICS.VIDEO_VIEWS,
    {
      ...CAMPAIGN_STATS_METRICS.AVG_ENGAGEMENT_RATE,
      tooltip: 'The average engagement rate for the posts published during the reporting period',
    },
    CAMPAIGN_STATS_METRICS.ENGAGEMENTS,
    CAMPAIGN_STATS_METRICS.LIKES,
    CAMPAIGN_STATS_METRICS.COMMENTS,
  ],
  ugc: [
    CAMPAIGN_STATS_METRICS.NUMBER_OF_POSTS,
    CAMPAIGN_STATS_METRICS.MENTIONS,
    CAMPAIGN_STATS_METRICS.PEOPLE_TAGS,
    CAMPAIGN_STATS_METRICS.AVG_ESTIMATED_REACH,
    CAMPAIGN_STATS_METRICS.ENGAGEMENTS,
  ],
  'creator-insights': [],
  'creator-deliverables': [],
  ecomm: [],
};

export const postMetricKeys = {
  TIKTOK: {
    VIDEO_VIEWS: 'TIKTOK_VIEWS',
    TOTAL_ENGAGEMENTS: 'TIKTOK_TOTAL_ENGAGEMENTS',
    EFFECTIVENESS: 'TIKTOK_EFFECTIVENESS',
    ENGAGEMENT_RATE: 'TIKTOK_ENGAGEMENT_RATE',
    VIEWS_BASED_ENGAGEMENT_RATE: 'TIKTOK_VIEWS_BASED_ENGAGEMENT_RATE',
    RETENTION_RATE: 'TIKTOK_AVERAGE_COMPLETION_RATE',
    FYP_VIEWS: 'TIKTOK_IMPRESSIONS_FOR_YOU_RATE',
    DATE: 'DATE',
    IMPRESSIONS_PERSONAL_PROFILE_RATE: 'TIKTOK_IMPRESSIONS_PERSONAL_PROFILE_RATE',
    AVERAGE_TIME_WATCHED: 'TIKTOK_AVERAGE_TIME_WATCHED',
    REACH: 'TIKTOK_REACH',
    COMMENTS: 'TIKTOK_COMMENTS',
    FULL_VIDEO_WATCHED_RATE: 'TIKTOK_FULL_VIDEO_WATCHED_RATE',
    IMPRESSIONS_SEARCH_RATE: 'TIKTOK_IMPRESSIONS_SEARCH_RATE',
    SHARES: 'TIKTOK_SHARES',
    IMPRESSIONS_SOUND_RATE: 'TIKTOK_IMPRESSIONS_SOUND_RATE',
    IMPRESSIONS_FOLLOW_RATE: 'TIKTOK_IMPRESSIONS_FOLLOW_RATE',
    TOTAL_TIME_WATCHED: 'TIKTOK_TOTAL_TIME_WATCHED',
    IMPRESSIONS_HASHTAG_RATE: 'TIKTOK_IMPRESSIONS_HASHTAG_RATE',
    DURATION: 'TIKTOK_DURATION',
    LIKES: 'TIKTOK_LIKES',
    ENTERTAINMENT_SCORE: 'TIKTOK_ENTERTAINMENT_SCORE',
  },
  FACEBOOK: {
    POST_CLICKS: 'FACEBOOK_POST_CLICKS',
    COMMENTS: 'FACEBOOK_COMMENTS',
    REACH: 'FACEBOOK_REACH',
    EFFECTIVENESS: 'FACEBOOK_EFFECTIVENESS',
    REACTIONS: 'FACEBOOK_REACTIONS',
    ENGAGEMENT_RATE: 'FACEBOOK_ENGAGEMENT_RATE',
    DATE: 'DATE',
    SHARES: 'FACEBOOK_SHARES',
    IMPRESSIONS: 'FACEBOOK_IMPRESSIONS',
    TOTAL_ENGAGEMENTS: 'FACEBOOK_TOTAL_ENGAGEMENTS',
    LINK_CLICKS: 'FACEBOOK_LINK_CLICKS',
    VIDEO_COMPLETE_VIEWS: 'FACEBOOK_VIDEO_COMPLETE_VIEWS',
    OTHER_CLICKS: 'FACEBOOK_OTHER_CLICKS',
    VIDEO_VIEWS: 'FACEBOOK_VIDEO_VIEWS',
    PHOTO_VIEW_CLICKS: 'FACEBOOK_PHOTO_VIEW_CLICKS',
    ORGANIC_COMMENTS: 'FACEBOOK_ORGANIC_COMMENTS',
    ORGANIC_EFFECTIVENESS: 'FACEBOOK_ORGANIC_EFFECTIVENESS',
    ORGANIC_EFFECTIVENESS_V2: 'FACEBOOK_ORGANIC_EFFECTIVENESS_V2',
    ORGANIC_ENGAGEMENT_RATE: 'FACEBOOK_ORGANIC_ENGAGEMENT_RATE',
    ORGANIC_ENGAGEMENT_RATE_V2: 'FACEBOOK_ORGANIC_ENGAGEMENT_RATE_V2',
    ORGANIC_ENGAGEMENTS: 'FACEBOOK_ORGANIC_ENGAGEMENTS',
    ORGANIC_ENGAGEMENTS_V2: 'FACEBOOK_ORGANIC_ENGAGEMENTS_V2',
    ORGANIC_REACH: 'FACEBOOK_ORGANIC_REACH',
    ORGANIC_REACTIONS: 'FACEBOOK_ORGANIC_REACTIONS',
    ORGANIC_SHARES: 'FACEBOOK_ORGANIC_SHARES',
    ORGANIC_VIEWS: 'FACEBOOK_ORGANIC_VIEWS',
    ORGANIC_VIDEO_VIEWS: 'FACEBOOK_ORGANIC_VIDEO_VIEWS',
    ORGANIC_VIDEO_COMPLETE_VIEWS: 'FACEBOOK_ORGANIC_VIDEO_COMPLETE_VIEWS',
    PAID_COMMENTS: 'FACEBOOK_PAID_COMMENTS',
    PAID_EFFECTIVENESS: 'FACEBOOK_PAID_EFFECTIVENESS',
    PAID_EFFECTIVENESS_V2: 'FACEBOOK_PAID_EFFECTIVENESS_V2',
    PAID_ENGAGEMENT_RATE: 'FACEBOOK_PAID_ENGAGEMENT_RATE',
    PAID_ENGAGEMENT_RATE_V2: 'FACEBOOK_PAID_ENGAGEMENT_RATE_V2',
    PAID_ENGAGEMENTS: 'FACEBOOK_PAID_ENGAGEMENTS',
    PAID_REACH: 'FACEBOOK_PAID_REACH',
    PAID_REACH_V2: 'FACEBOOK_PAID_REACH_V2',
    PAID_VIEWERS: 'FACEBOOK_PAID_VIEWERS',
    PAID_REACTIONS: 'FACEBOOK_PAID_REACTIONS',
    PAID_SHARES: 'FACEBOOK_PAID_SHARES',
    PAID_VIEWS: 'FACEBOOK_PAID_VIEWS',
    PAID_VIDEO_VIEWS: 'FACEBOOK_PAID_VIDEO_VIEWS',
    PAID_VIDEO_COMPLETE_VIEWS: 'FACEBOOK_PAID_VIDEO_COMPLETE_VIEWS',
    PAID_LINK_CLICKS: 'FACEBOOK_PAID_LINK_CLICKS',
    PAID_AND_ORGANIC_COMMENTS: 'FACEBOOK_PAID_AND_ORGANIC_COMMENTS',
    PAID_AND_ORGANIC_EFFECTIVENESS: 'FACEBOOK_PAID_AND_ORGANIC_EFFECTIVENESS',
    PAID_AND_ORGANIC_ENGAGEMENT_RATE: 'FACEBOOK_PAID_AND_ORGANIC_ENGAGEMENT_RATE',
    PAID_AND_ORGANIC_ENGAGEMENTS: 'FACEBOOK_PAID_AND_ORGANIC_ENGAGEMENTS',
    PAID_AND_ORGANIC_OTHER_CLICKS: 'FACEBOOK_PAID_AND_ORGANIC_OTHER_CLICKS',
    PAID_AND_ORGANIC_PHOTO_VIEW_CLICKS: 'FACEBOOK_PAID_AND_ORGANIC_PHOTO_VIEW_CLICKS',
    PAID_AND_ORGANIC_POST_CLICKS: 'FACEBOOK_PAID_AND_ORGANIC_POST_CLICKS',
    PAID_AND_ORGANIC_REACH: 'FACEBOOK_PAID_AND_ORGANIC_REACH',
    PAID_AND_ORGANIC_REACTIONS: 'FACEBOOK_PAID_AND_ORGANIC_REACTIONS',
    PAID_AND_ORGANIC_SHARES: 'FACEBOOK_PAID_AND_ORGANIC_SHARES',
    PAID_AND_ORGANIC_VIEWS: 'FACEBOOK_PAID_AND_ORGANIC_VIEWS',
    PAID_AND_ORGANIC_VIDEO_COMPLETE_VIEWS: 'FACEBOOK_PAID_AND_ORGANIC_VIDEO_COMPLETE_VIEWS',
    PAID_AND_ORGANIC_EFFECTIVENESS_V2: 'FACEBOOK_PAID_AND_ORGANIC_EFFECTIVENESS_V2',
    PAID_AND_ORGANIC_ENGAGEMENTS_V2: 'FACEBOOK_PAID_AND_ORGANIC_ENGAGEMENTS_V2',
    PAID_AND_ORGANIC_ENGAGEMENT_RATE_V2: 'FACEBOOK_PAID_AND_ORGANIC_ENGAGEMENT_RATE_V2',
    PAID_AND_ORGANIC_REACH_V2: 'FACEBOOK_PAID_AND_ORGANIC_REACH_V2',
    PAID_AND_ORGANIC_VIDEO_VIEWS: 'FACEBOOK_PAID_AND_ORGANIC_VIDEO_VIEWS',
    PAID_AND_ORGANIC_LINK_CLICKS: 'FACEBOOK_PAID_AND_ORGANIC_LINK_CLICKS',
    PAID_AND_ORGANIC_VIEWERS: 'FACEBOOK_PAID_AND_ORGANIC_VIEWERS',
  },
  TWITTER: {
    DATE: 'DATE',
    ENGAGEMENT_RATE: 'TWITTER_ENGAGEMENT_RATE',
    TOTAL_ENGAGEMENTS: 'TWITTER_TOTAL_ENGAGEMENTS',
    IMPRESSIONS: 'TWITTER_IMPRESSIONS',
    LIKES: 'TWITTER_LIKES',
    VIDEO_VIEWS: 'TWITTER_VIDEO_VIEWS',
    RETWEETS: 'TWITTER_RETWEETS',
    REPLIES: 'TWITTER_REPLIES',
    TOTAL_RETWEETS: 'TWITTER_TOTAL_RETWEETS',
    URL_CLICKS: 'TWITTER_URL_CLICKS',
    FOLLOWS: 'TWITTER_FOLLOWS',
    PROFILE_CLICKS: 'TWITTER_USER_PROFILE_CLICKS',
    QUOTE_TWEETS: 'TWITTER_QUOTE_TWEETS',
  },
  INSTAGRAM_STORY: {
    DATE: 'DATE',
    REACH: 'INSTAGRAM_STORY_FRAME_REACH',
    IMPRESSIONS: 'INSTAGRAM_STORY_FRAME_IMPRESSIONS',
    COMPLETION_RATE: 'INSTAGRAM_STORY_FRAME_COMPLETION_RATE',
    EXIT_RATE: 'INSTAGRAM_STORY_FRAME_EXIT_RATE',
    VIEWS: 'INSTAGRAM_STORY_FRAME_VIEWS_V2',
    COMPLETION_RATE_VIEWS: 'INSTAGRAM_STORY_FRAME_COMPLETION_RATE_VIEWS',
    EXIT_RATE_VIEWS: 'INSTAGRAM_STORY_FRAME_EXIT_RATE_VIEWS',
    EXITS: 'INSTAGRAM_STORY_FRAME_EXITS',
    LINK_CLICKS: 'INSTAGRAM_STORY_FRAME_SWIPE_UPS',
    REPLIES: 'INSTAGRAM_STORY_FRAME_REPLIES',
  },
  YOUTUBE: {
    DATE: 'DATE',
    VIDEO_VIEWS: 'YOUTUBE_VIEWS',
    WATCH_TIME: 'YOUTUBE_EST_SECONDS_WATCHED',
    AVERAGE_VIEW_DURATION: 'YOUTUBE_AVG_VIEW_DURATION',
    AVERAGE_PERCENTAGE_VIEWED: 'YOUTUBE_AVG_VIEW_PERCENTAGE',
    SUBSCRIBERS: 'YOUTUBE_SUBSCRIBERS',
    CARD_CLICKS: 'YOUTUBE_CARD_CLICKS',
    CARD_CLICK_RATE: 'YOUTUBE_CARD_CLICK_RATE',
    CARD_TEASER_CLICKS: 'YOUTUBE_CARD_TEASER_CLICKS',
    CARD_TEASER_CLICK_RATE: 'YOUTUBE_CARD_TEASER_CLICK_RATE',
    CARD_TEASER_IMPRESSIONS: 'YOUTUBE_CARD_TEASER_IMPRESSIONS',
    TOTAL_ENGAGEMENTS: 'YOUTUBE_ENGAGEMENTS',
    LIKES: 'YOUTUBE_LIKES',
    DISLIKES: 'YOUTUBE_DISLIKES',
    COMMENTS: 'YOUTUBE_COMMENTS',
    PREMIUM_VIEWS: 'YOUTUBE_PREMIUM_VIEWS',
    PREMIUM_WATCH_TIME: 'YOUTUBE_EST_PREMIUM_SECONDS_WATCHED',
    SHARES: 'YOUTUBE_SHARES',
    ADDED_TO_PLAYLIST: 'YOUTUBE_VIDEOS_ADDED_TO_PLAYLIST',
  },
  PINTEREST: {
    DATE: 'DATE',
    ENGAGEMENT_RATE: 'PINTEREST_ENGAGEMENT_RATE',
    IMPRESSIONS: 'PINTEREST_TOTAL_IMPRESSIONS',
    OUTBOUND_CLICKS: 'PINTEREST_TOTAL_CLICKS',
    SAVES: 'PINTEREST_TOTAL_SAVES',
    PIN_CLICKS: 'PINTEREST_TOTAL_CLOSEUPS',
    VIDEO_VIEWS: 'PINTEREST_TOTAL_VIDEO_VIEWS',
    AVERAGE_VIDEO_WATCH_TIME: 'PINTEREST_AVERAGE_VIDEO_WATCH_TIME',
  },
  INSTAGRAM: {
    DATE: 'DATE',
    ORGANIC_COMMENTS: 'INSTAGRAM_ORGANIC_COMMENTS',
    PAID_COMMENTS: 'INSTAGRAM_PAID_COMMENTS',
    TOTAL_COMMENTS: 'INSTAGRAM_TOTAL_COMMENTS',
    ORGANIC_EFFECTIVENESS_ENGAGEMENTS: 'INSTAGRAM_EFFECTIVENESS_ENGAGEMENTS',
    ENGAGEMENT_RATE: 'INSTAGRAM_ENGAGEMENT_RATE',
    ENGAGEMENT_RATE_VIEWS: 'INSTAGRAM_ENGAGEMENT_RATE_VIEWS',
    PAID_IMPRESSIONS: 'INSTAGRAM_PAID_IMPRESSIONS',
    ORGANIC_LIKES: 'INSTAGRAM_ORGANIC_LIKES',
    PAID_LIKES: 'INSTAGRAM_PAID_LIKES',
    TOTAL_LIKES: 'INSTAGRAM_TOTAL_LIKES',
    LIKESHOP_CLICKS: 'LIKESHOP_CLICKS',
    REACH: 'INSTAGRAM_REACH',
    SAVES: 'INSTAGRAM_SAVES',
    TOTAL_ENGAGEMENTS: 'INSTAGRAM_TOTAL_ENGAGEMENTS',
    PAID_TOTAL_ENGAGEMENTS: 'INSTAGRAM_PAID_TOTAL_ENGAGEMENTS',
    SUM_TOTAL_ENGAGEMENTS: 'INSTAGRAM_SUM_TOTAL_ENGAGEMENTS',
    PAID_VIDEO_VIEWS: 'INSTAGRAM_PAID_VIDEO_VIEWS',
    ORGANIC_VIEWS: 'INSTAGRAM_VIEWS',
    // Discontinued metrics
    EFFECTIVENESS_DISCONTINUED: 'INSTAGRAM_EFFECTIVENESS',
    ORGANIC_IMPRESSIONS_DISCONTINUED: 'INSTAGRAM_ORGANIC_IMPRESSIONS',
    VIDEO_VIEWS_DISCONTINUED: 'INSTAGRAM_VIDEO_VIEWS',
    TOTAL_IMPRESSIONS_DISCONTINUED: 'INSTAGRAM_TOTAL_IMPRESSIONS',
    TOTAL_VIDEO_VIEWS_DISCONTINUED: 'INSTAGRAM_TOTAL_VIDEO_VIEWS',
  },
  UGC: {
    DATE: 'DATE',
    ESTIMATED_REACH: 'INSTAGRAM_REACH',
    ENGAGEMENT_RATE: 'INSTAGRAM_ENGAGEMENT_RATE',
    ENGAGEMENTS: 'INSTAGRAM_TOTAL_ENGAGEMENTS',
    LIKES: 'INSTAGRAM_TOTAL_LIKES',
    MENTIONED_YOU: 'MENTIONED_YOU',
    REACH: 'INSTAGRAM_STORY_FRAME_REACH',
    IMPRESSIONS: 'INSTAGRAM_STORY_FRAME_IMPRESSIONS',
    COMPLETION_RATE: 'INSTAGRAM_STORY_FRAME_COMPLETION_RATE',
    EXIT_RATE: 'INSTAGRAM_STORY_FRAME_EXIT_RATE',
    COMPLETION_RATE_VIEWS: 'INSTAGRAM_STORY_FRAME_COMPLETION_RATE_VIEWS',
    EXIT_RATE_VIEWS: 'INSTAGRAM_STORY_FRAME_EXIT_RATE_VIEWS',
    EXITS: 'INSTAGRAM_STORY_FRAME_EXITS',
    VIEWS: 'INSTAGRAM_VIEWS',
    STORY_VIEWS: 'INSTAGRAM_STORY_FRAME_VIEWS_V2',
  },
  RELATIONSHIPS: {
    ENGAGEMENT_RATE: 'ENGAGEMENT_RATE',
    FOLLOWERS_GAINED: 'FOLLOWERS_GAINED',
    EFFECTIVENESS: 'EFFECTIVENESS',
    EMV: 'EMV',
    REACH: 'REACH',
    IMPRESSIONS: 'IMPRESSIONS',
    COMPLETION_RATE: 'COMPLETION_RATE',
    EXIT_RATE: 'EXIT_RATE',
    EFFECTIVENESS_ENGAGEMENTS: 'EFFECTIVENESS_ENGAGEMENTS',
    VIEWS: 'VIEWS',
    COMPLETION_RATE_VIEWS: 'COMPLETION_RATE_VIEWS',
    EXIT_RATE_VIEWS: 'EXIT_RATE_VIEWS',
  },
};

export const defaultChannelMetrics = {
  TIKTOK: [
    postMetricKeys.TIKTOK.ENTERTAINMENT_SCORE,
    postMetricKeys.TIKTOK.VIDEO_VIEWS,
    postMetricKeys.TIKTOK.TOTAL_ENGAGEMENTS,
    postMetricKeys.TIKTOK.AVERAGE_TIME_WATCHED,
  ],
  FACEBOOK: [
    postMetricKeys.FACEBOOK.PAID_AND_ORGANIC_ENGAGEMENT_RATE_V2,
    postMetricKeys.FACEBOOK.PAID_AND_ORGANIC_VIEWS,
    postMetricKeys.FACEBOOK.PAID_AND_ORGANIC_ENGAGEMENTS_V2,
    postMetricKeys.FACEBOOK.PAID_AND_ORGANIC_REACH_V2,
    postMetricKeys.FACEBOOK.PAID_AND_ORGANIC_VIEWERS,
  ],
  TWITTER: [
    postMetricKeys.TWITTER.ENGAGEMENT_RATE,
    postMetricKeys.TWITTER.TOTAL_ENGAGEMENTS,
    postMetricKeys.TWITTER.IMPRESSIONS,
    postMetricKeys.TWITTER.LIKES,
  ],
  INSTAGRAM_STORY: [
    postMetricKeys.INSTAGRAM_STORY.REACH,
    postMetricKeys.INSTAGRAM_STORY.VIEWS,
    postMetricKeys.INSTAGRAM_STORY.COMPLETION_RATE_VIEWS,
    postMetricKeys.INSTAGRAM_STORY.EXIT_RATE_VIEWS,
    postMetricKeys.INSTAGRAM_STORY.EXITS,
    postMetricKeys.INSTAGRAM_STORY.LINK_CLICKS,
  ],
  YOUTUBE: [
    postMetricKeys.YOUTUBE.VIDEO_VIEWS,
    postMetricKeys.YOUTUBE.WATCH_TIME,
    postMetricKeys.YOUTUBE.AVERAGE_VIEW_DURATION,
    postMetricKeys.YOUTUBE.TOTAL_ENGAGEMENTS,
    postMetricKeys.YOUTUBE.AVERAGE_PERCENTAGE_VIEWED,
  ],
  PINTEREST: [
    postMetricKeys.PINTEREST.ENGAGEMENT_RATE,
    postMetricKeys.PINTEREST.SAVES,
    postMetricKeys.PINTEREST.IMPRESSIONS,
    postMetricKeys.PINTEREST.PIN_CLICKS,
  ],
  INSTAGRAM: [
    postMetricKeys.INSTAGRAM.ENGAGEMENT_RATE,
    postMetricKeys.INSTAGRAM.ORGANIC_EFFECTIVENESS_ENGAGEMENTS,
    postMetricKeys.INSTAGRAM.TOTAL_ENGAGEMENTS,
    postMetricKeys.INSTAGRAM.REACH,
  ],
  UGC: [
    postMetricKeys.UGC.ESTIMATED_REACH,
    postMetricKeys.UGC.ENGAGEMENT_RATE,
    postMetricKeys.UGC.ENGAGEMENTS,
    postMetricKeys.UGC.LIKES,
  ],
  UGC_STORY: [
    postMetricKeys.UGC.ESTIMATED_REACH,
    postMetricKeys.UGC.IMPRESSIONS,
    postMetricKeys.UGC.COMPLETION_RATE,
    postMetricKeys.UGC.EXIT_RATE,
  ],
  RELATIONSHIP_INSTAGRAM: [
    postMetricKeys.RELATIONSHIPS.ENGAGEMENT_RATE,
    postMetricKeys.RELATIONSHIPS.EFFECTIVENESS,
    postMetricKeys.RELATIONSHIPS.EFFECTIVENESS_ENGAGEMENTS,
    postMetricKeys.RELATIONSHIPS.FOLLOWERS_GAINED,
    postMetricKeys.RELATIONSHIPS.EMV,
  ],
  RELATIONSHIP_STORY: [
    postMetricKeys.RELATIONSHIPS.REACH,
    postMetricKeys.RELATIONSHIPS.IMPRESSIONS,
    postMetricKeys.RELATIONSHIPS.COMPLETION_RATE,
    postMetricKeys.RELATIONSHIPS.EXIT_RATE,
    postMetricKeys.RELATIONSHIPS.VIEWS,
    postMetricKeys.RELATIONSHIPS.COMPLETION_RATE_VIEWS,
    postMetricKeys.RELATIONSHIPS.EXIT_RATE_VIEWS,
  ],
  RELATIONSHIPS: [
    postMetricKeys.RELATIONSHIPS.ENGAGEMENT_RATE,
    postMetricKeys.RELATIONSHIPS.EFFECTIVENESS,
    postMetricKeys.RELATIONSHIPS.EFFECTIVENESS_ENGAGEMENTS,
    postMetricKeys.RELATIONSHIPS.FOLLOWERS_GAINED,
    postMetricKeys.RELATIONSHIPS.EMV,
  ],
};

export const FACEBOOK_SORT_OPTIONS_WITH_AD_ACCOUNT = [
  {
    value: 'DATE',
    label: 'Recently Published',
  },
  {
    title: 'Organic',
    children: [
      {
        value: 'FACEBOOK_ORGANIC_COMMENTS',
        label: 'Comments',
        field: 'organic_comments',
      },
      {
        value: 'FACEBOOK_ORGANIC_EFFECTIVENESS_V2',
        label: 'Effectiveness',
        field: 'organic_effectiveness_v2',
      },
      {
        value: 'FACEBOOK_ORGANIC_ENGAGEMENT_RATE_V2',
        label: 'Engagement Rate',
        field: 'organic_engagement_rate_v2',
      },
      {
        value: 'FACEBOOK_ORGANIC_ENGAGEMENTS_V2',
        label: 'Engagements',
        field: 'organic_engagements_v2',
      },
      {
        value: 'FACEBOOK_ORGANIC_REACH',
        label: 'Reach',
        field: 'organic_reach',
        flag: 'fbMetricsDeprecation2026',
        includeWithFlag: false,
      },
      {
        value: 'FACEBOOK_ORGANIC_REACTIONS',
        label: 'Reactions',
        field: 'organic_reactions',
      },
      {
        value: 'FACEBOOK_ORGANIC_SHARES',
        label: 'Shares',
        field: 'organic_shares',
      },
      {
        value: 'FACEBOOK_ORGANIC_VIEWS',
        label: 'Views',
        field: 'organic_views',
      },
      {
        value: 'FACEBOOK_ORGANIC_VIDEO_COMPLETE_VIEWS',
        label: 'Video Complete Views',
        field: 'organic_video_complete_views',
      },
      {
        value: 'FACEBOOK_ORGANIC_VIDEO_VIEWS',
        label: 'Video Views',
        field: 'organic_video_views',
      },
    ],
  },
  {
    title: 'Promoted',
    children: [
      {
        value: 'FACEBOOK_PAID_COMMENTS',
        label: 'Comments',
        field: 'paid_comments',
      },
      {
        value: 'FACEBOOK_PAID_EFFECTIVENESS_V2',
        label: 'Effectiveness',
        field: 'paid_effectiveness_v2',
      },
      {
        value: 'FACEBOOK_PAID_ENGAGEMENT_RATE_V2',
        label: 'Engagement Rate',
        field: 'paid_engagement_rate_v2',
      },
      {
        value: 'FACEBOOK_PAID_ENGAGEMENTS',
        label: 'Engagements',
        field: 'paid_engagements',
      },
      {
        value: 'FACEBOOK_PAID_REACH_V2',
        label: 'Reach',
        field: 'paid_reach_v2',
        flag: 'fbMetricsDeprecation2026',
        includeWithFlag: false,
      },
      {
        value: 'FACEBOOK_PAID_REACH_V2',
        label: 'Viewers',
        field: 'paid_reach_v2',
        flag: 'fbMetricsDeprecation2026',
        includeWithFlag: true,
      },
      {
        value: 'FACEBOOK_PAID_REACTIONS',
        label: 'Reactions',
        field: 'paid_reactions',
      },
      {
        value: 'FACEBOOK_PAID_SHARES',
        label: 'Shares',
        field: 'paid_shares',
      },
      {
        value: 'FACEBOOK_PAID_VIEWS',
        label: 'Views',
        field: 'paid_views',
      },
    ],
  },
  {
    title: 'Total',
    children: [
      {
        value: 'FACEBOOK_PAID_AND_ORGANIC_COMMENTS',
        label: 'Comments',
        field: 'paid_and_organic_comments',
      },
      {
        value: 'FACEBOOK_PAID_AND_ORGANIC_EFFECTIVENESS_V2',
        label: 'Effectiveness',
        field: 'paid_and_organic_effectiveness_v2',
      },
      {
        value: 'FACEBOOK_PAID_AND_ORGANIC_ENGAGEMENT_RATE_V2',
        label: 'Engagement Rate',
        field: 'paid_and_organic_engagement_rate_v2',
      },
      {
        value: 'FACEBOOK_PAID_AND_ORGANIC_ENGAGEMENTS_V2',
        label: 'Engagements',
        field: 'paid_and_organic_engagements_v2',
      },
      {
        value: 'FACEBOOK_PAID_AND_ORGANIC_LINK_CLICKS',
        label: 'Link Clicks',
        field: 'paid_and_organic_link_clicks',
      },
      {
        value: 'FACEBOOK_PAID_AND_ORGANIC_OTHER_CLICKS',
        label: 'Other Clicks',
        field: 'paid_and_organic_other_clicks',
      },
      {
        value: 'FACEBOOK_PAID_AND_ORGANIC_PHOTO_VIEW_CLICKS',
        label: 'Photo View Clicks',
        field: 'paid_and_organic_photo_view_clicks',
      },
      {
        value: 'FACEBOOK_PAID_AND_ORGANIC_POST_CLICKS',
        label: 'Post Clicks',
        field: 'paid_and_organic_post_clicks',
      },
      {
        value: 'FACEBOOK_PAID_AND_ORGANIC_REACH_V2',
        label: 'Reach',
        field: 'paid_and_organic_reach_v2',
        flag: 'fbMetricsDeprecation2026',
        includeWithFlag: false,
      },
      {
        value: 'FACEBOOK_PAID_AND_ORGANIC_REACH_V2',
        label: 'Viewers',
        field: 'paid_and_organic_reach_v2',
        flag: 'fbMetricsDeprecation2026',
        includeWithFlag: true,
      },
      {
        value: 'FACEBOOK_PAID_AND_ORGANIC_REACTIONS',
        label: 'Reactions',
        field: 'paid_and_organic_reactions',
      },
      {
        value: 'FACEBOOK_PAID_AND_ORGANIC_SHARES',
        label: 'Shares',
        field: 'paid_and_organic_shares',
      },
      {
        value: 'FACEBOOK_PAID_AND_ORGANIC_VIEWS',
        label: 'Views',
        field: 'paid_and_organic_views',
      },
    ],
  },
  {
    title: 'Discontinued',
    children: [
      {
        value: 'FACEBOOK_IMPRESSIONS',
        label: 'Impressions - Organic',
        field: 'impressions',
      },
      {
        value: 'FACEBOOK_ORGANIC_REACH',
        label: 'Reach - Organic',
        field: 'organic_reach',
        flag: 'fbMetricsDeprecation2026',
        includeWithFlag: true,
      },
    ],
  },
];

export const FACEBOOK_SORT_OPTIONS_WITHOUT_AD_ACCOUNT = [
  {
    value: 'DATE',
    label: 'Recently Published',
  },
  {
    title: 'Organic',
    children: [
      {
        value: 'FACEBOOK_ORGANIC_VIDEO_COMPLETE_VIEWS',
        label: 'Video Complete Views',
        field: 'organic_video_complete_views',
      },
      {
        value: 'FACEBOOK_ORGANIC_VIDEO_VIEWS',
        label: 'Video Views',
        field: 'organic_video_views',
      },
    ],
  },
  {
    title: 'Total',
    children: [
      {
        value: 'FACEBOOK_PAID_AND_ORGANIC_COMMENTS',
        label: 'Comments',
        field: 'paid_and_organic_comments',
      },
      {
        value: 'FACEBOOK_PAID_AND_ORGANIC_EFFECTIVENESS_V2',
        label: 'Effectiveness',
        field: 'paid_and_organic_effectiveness_v2',
      },
      {
        value: 'FACEBOOK_PAID_AND_ORGANIC_ENGAGEMENT_RATE_V2',
        label: 'Engagement Rate',
        field: 'paid_and_organic_engagement_rate_v2',
      },
      {
        value: 'FACEBOOK_PAID_AND_ORGANIC_ENGAGEMENTS_V2',
        label: 'Engagements',
        field: 'paid_and_organic_engagements_v2',
      },
      {
        value: 'FACEBOOK_PAID_AND_ORGANIC_LINK_CLICKS',
        label: 'Link Clicks',
        field: 'paid_and_organic_link_clicks',
      },
      {
        value: 'FACEBOOK_PAID_AND_ORGANIC_OTHER_CLICKS',
        label: 'Other Clicks',
        field: 'paid_and_organic_other_clicks',
      },
      {
        value: 'FACEBOOK_PAID_AND_ORGANIC_PHOTO_VIEW_CLICKS',
        label: 'Photo View Clicks',
        field: 'paid_and_organic_photo_view_clicks',
      },
      {
        value: 'FACEBOOK_PAID_AND_ORGANIC_POST_CLICKS',
        label: 'Post Clicks',
        field: 'paid_and_organic_post_clicks',
      },
      {
        value: 'FACEBOOK_PAID_AND_ORGANIC_REACH_V2',
        label: 'Reach',
        field: 'paid_and_organic_reach_v2',
        flag: 'fbMetricsDeprecation2026',
        includeWithFlag: false,
      },
      {
        value: 'FACEBOOK_PAID_AND_ORGANIC_REACH_V2',
        label: 'Viewers',
        field: 'paid_and_organic_reach_v2',
        flag: 'fbMetricsDeprecation2026',
        includeWithFlag: true,
      },
      {
        value: 'FACEBOOK_PAID_AND_ORGANIC_REACTIONS',
        label: 'Reactions',
        field: 'paid_and_organic_reactions',
      },
      {
        value: 'FACEBOOK_PAID_AND_ORGANIC_SHARES',
        label: 'Shares',
        field: 'paid_and_organic_shares',
      },
      {
        value: 'FACEBOOK_PAID_AND_ORGANIC_VIEWS',
        label: 'Views',
        field: 'paid_and_organic_views',
      },
    ],
  },
  {
    title: 'Discontinued',
    children: [
      {
        value: 'FACEBOOK_IMPRESSIONS',
        label: 'Impressions - Organic',
        field: 'impressions',
      },
    ],
  },
];

export const OLD_INSTAGRAM_SORT_OPTIONS = [
  {
    value: 'DATE',
    label: 'Recently Published',
  },
  {
    title: 'Organic',
    children: [
      {
        value: 'INSTAGRAM_ORGANIC_COMMENTS',
        label: 'Comments',
        field: 'comments_count',
      },
      {
        value: 'INSTAGRAM_EFFECTIVENESS_ENGAGEMENTS',
        label: 'Effectiveness',
        field: 'effectiveness_engagements',
      },
      {
        value: 'INSTAGRAM_ORGANIC_LIKES',
        label: 'Likes',
        field: 'like_count',
      },
      {
        value: 'INSTAGRAM_TOTAL_ENGAGEMENTS',
        label: 'Engagements',
        field: 'total_engagement',
      },
      {
        value: 'INSTAGRAM_REACH',
        label: 'Reach',
        field: 'reach',
      },
      {
        value: 'INSTAGRAM_SAVES',
        label: 'Saves',
        field: 'saved',
      },
      {
        value: 'INSTAGRAM_ENGAGEMENT_RATE',
        label: 'Engagement Rate',
        field: 'engagement',
      },
      {
        value: 'LIKESHOP_CLICKS',
        label: 'LikeShop Clicks',
        field: 'likeshop_clicks',
      },
      {
        value: 'INSTAGRAM_VIEWS',
        label: 'Views',
        field: 'views',
      },
    ],
  },
  {
    title: 'Promoted',
    children: [
      {
        value: 'INSTAGRAM_PAID_COMMENTS',
        label: 'Comments',
        field: 'paid_comments',
      },
      {
        value: 'INSTAGRAM_PAID_IMPRESSIONS',
        label: 'Impressions',
        field: 'paid_impressions',
      },
      {
        value: 'INSTAGRAM_PAID_TOTAL_ENGAGEMENTS',
        label: 'Engagements',
        field: 'paid_total_engagements',
      },
      {
        value: 'INSTAGRAM_PAID_LIKES',
        label: 'Likes',
        field: 'paid_likes',
      },
      {
        value: 'INSTAGRAM_PAID_VIDEO_VIEWS',
        label: 'Video Views',
        field: 'paid_video_views',
      },
    ],
  },
  {
    title: 'Total',
    children: [
      {
        value: 'INSTAGRAM_TOTAL_COMMENTS',
        label: 'Comments',
        field: 'total_comments',
      },
      {
        value: 'INSTAGRAM_TOTAL_LIKES',
        label: 'Likes',
        field: 'total_likes',
      },
      {
        value: 'INSTAGRAM_SUM_TOTAL_ENGAGEMENTS',
        label: 'Engagements',
        field: 'sum_total_engagements',
      },
    ],
  },
  {
    title: 'Discontinued',
    children: [
      {
        value: 'INSTAGRAM_EFFECTIVENESS',
        label: 'Effectiveness (Organic) (Discontinued)',
        field: 'effectiveness',
      },
      {
        value: 'INSTAGRAM_ORGANIC_IMPRESSIONS',
        label: 'Impressions (Organic) (Discontinued)',
        field: 'impressions',
      },
      {
        value: 'INSTAGRAM_VIDEO_VIEWS',
        label: 'Video Views (Organic) (Discontinued)',
        field: 'video_views',
      },
      {
        value: 'INSTAGRAM_TOTAL_IMPRESSIONS',
        label: 'Impressions (Total) (Discontinued)',
        field: 'total_impressions',
      },
      {
        value: 'INSTAGRAM_TOTAL_VIDEO_VIEWS',
        label: 'Video Views (Total) (Discontinued)',
        field: 'total_video_views',
      },
    ],
  },
];

export const OLD_TIKTOK_SORT_OPTIONS = [
  {
    value: 'DATE',
    label: 'Recently Published',
  },
  {
    value: 'TIKTOK_IMPRESSIONS_PERSONAL_PROFILE_RATE',
    label: 'Profile Views %',
    field: 'impressions_personal_profile_rate',
  },
  {
    value: 'TIKTOK_AVERAGE_TIME_WATCHED',
    label: 'Avg. Time Watched',
    field: 'average_time_watched',
  },
  {
    value: 'TIKTOK_REACH',
    label: 'Reach',
    field: 'reach',
  },
  {
    value: 'TIKTOK_COMMENTS',
    label: 'Comments',
    field: 'comments',
  },
  {
    value: 'TIKTOK_AVERAGE_COMPLETION_RATE',
    label: 'Retention Rate',
    field: 'average_completion_rate',
  },
  {
    value: 'TIKTOK_FULL_VIDEO_WATCHED_RATE',
    label: 'Completion Rate',
    field: 'full_video_watched_rate',
  },
  {
    value: 'TIKTOK_IMPRESSIONS_SEARCH_RATE',
    label: 'Search Views %',
    field: 'impressions_search_rate',
  },
  {
    value: 'TIKTOK_ENGAGEMENT_RATE',
    label: 'Engagement Rate',
    field: 'engagement_rate',
  },
  {
    value: 'TIKTOK_SHARES',
    label: 'Shares',
    field: 'shares',
  },
  {
    value: 'TIKTOK_ENTERTAINMENT_SCORE',
    label: 'Entertainment Score',
    field: 'entertainment_score',
  },
  {
    value: 'TIKTOK_IMPRESSIONS_SOUND_RATE',
    label: 'Sound Views %',
    field: 'impressions_sound_rate',
  },
  {
    value: 'TIKTOK_IMPRESSIONS_FOLLOW_RATE',
    label: 'Following Page Views %',
    field: 'impressions_follow_rate',
  },
  {
    value: 'TIKTOK_TOTAL_ENGAGEMENTS',
    label: 'Engagements',
    field: 'total_engagements',
  },
  {
    value: 'TIKTOK_IMPRESSIONS_FOR_YOU_RATE',
    label: 'For You Page Views %',
    field: 'impressions_for_you_rate',
  },
  {
    value: 'TIKTOK_TOTAL_TIME_WATCHED',
    label: 'Total Time Watched',
    field: 'total_time_watched',
  },
  {
    value: 'TIKTOK_IMPRESSIONS_HASHTAG_RATE',
    label: 'Hashtag Views %',
    field: 'impressions_hashtag_rate',
  },
  {
    value: 'TIKTOK_DURATION',
    label: 'Video Duration',
    field: 'duration',
  },
  {
    value: 'TIKTOK_LIKES',
    label: 'Likes',
    field: 'likes',
  },
  {
    value: 'TIKTOK_VIEWS',
    label: 'Video Views',
    field: 'views',
  },
];

export const CHANNEL_SORT_OPTIONS = {
  INSTAGRAM: OLD_INSTAGRAM_SORT_OPTIONS.map((option) => {
    if (option.title === 'Organic' && option.children) {
      return {
        ...option,
        children: option.children.flatMap((organicOption) => {
          if (organicOption.value === 'INSTAGRAM_ENGAGEMENT_RATE') {
            return [
              {
                value: 'INSTAGRAM_ENGAGEMENT_RATE',
                label: 'Eng. Rate (Followers)',
                field: 'engagement',
              },
              {
                value: 'INSTAGRAM_ENGAGEMENT_RATE_VIEWS',
                label: 'Eng. Rate (Views)',
                field: 'engagement_rate_views',
              },
            ];
          }
          return organicOption;
        }),
      };
    }
    return option;
  }),
  TIKTOK: [
    {
      value: 'DATE',
      label: 'Recently Published',
    },
    {
      title: 'Organic + Promoted',
      children: OLD_TIKTOK_SORT_OPTIONS.flatMap((option) => {
        if (option.value === 'DATE') {
          return [];
        }
        if (option.value === 'TIKTOK_ENGAGEMENT_RATE') {
          return [
            {
              value: 'TIKTOK_ENGAGEMENT_RATE',
              label: 'Eng. Rate (Reach)',
              field: 'engagement_rate',
            },
            {
              value: 'TIKTOK_VIEWS_BASED_ENGAGEMENT_RATE',
              label: 'Eng. Rate (Video Views)',
              field: 'views_based_engagement_rate',
            },
          ];
        }
        return option;
      }),
    },
  ],
  FACEBOOK: [
    {
      value: 'DATE',
      label: 'Recently Published',
    },
    {
      value: 'FACEBOOK_POST_CLICKS',
      label: 'Post Clicks',
      field: 'post_clicks',
    },
    {
      value: 'FACEBOOK_COMMENTS',
      label: 'Comments',
      field: 'comments',
    },
    {
      value: 'FACEBOOK_REACH',
      label: 'Reach',
      field: 'reach',
    },
    {
      value: 'FACEBOOK_EFFECTIVENESS',
      label: 'Effectiveness',
      field: 'effectiveness',
    },
    {
      value: 'FACEBOOK_REACTIONS',
      label: 'Reactions',
      field: 'reactions',
    },
    {
      value: 'FACEBOOK_ENGAGEMENT_RATE',
      label: 'Engagement Rate',
      field: 'engagement_rate',
    },
    {
      value: 'FACEBOOK_SHARES',
      label: 'Shares',
      field: 'shares',
    },
    {
      value: 'FACEBOOK_IMPRESSIONS',
      label: 'Impressions',
      field: 'impressions',
    },
    {
      value: 'FACEBOOK_TOTAL_ENGAGEMENTS',
      label: 'Engagements',
      field: 'total_engagements',
    },
    {
      value: 'FACEBOOK_LINK_CLICKS',
      label: 'Link Clicks',
      field: 'link_clicks',
    },
    {
      value: 'FACEBOOK_VIDEO_COMPLETE_VIEWS',
      label: 'Video Complete Views',
      field: 'video_complete_views',
    },
    {
      value: 'FACEBOOK_OTHER_CLICKS',
      label: 'Other Clicks',
      field: 'other_clicks',
    },
    {
      value: 'FACEBOOK_VIDEO_VIEWS',
      label: 'Video Views',
      field: 'video_views',
    },
    {
      value: 'FACEBOOK_PHOTO_VIEW_CLICKS',
      label: 'Photo View Clicks',
      field: 'photo_view_clicks',
    },
  ],
  TWITTER: [
    {
      value: 'DATE',
      label: 'Recently Published',
    },
    {
      value: 'TWITTER_REPLIES',
      label: 'Replies',
      field: 'replies',
    },
    {
      value: 'TWITTER_ENGAGEMENT_RATE',
      label: 'Engagement Rate',
      field: 'engagement_rate',
    },
    {
      value: 'TWITTER_RETWEETS',
      label: 'Reposts',
      field: 'retweets',
    },
    {
      value: 'TWITTER_IMPRESSIONS',
      label: 'Impressions',
      field: 'impressions',
    },
    {
      value: 'TWITTER_TOTAL_ENGAGEMENTS',
      label: 'Engagements',
      field: 'total_engagements',
    },
    {
      value: 'TWITTER_LIKES',
      label: 'Likes',
      field: 'likes',
    },
    {
      value: 'TWITTER_TOTAL_RETWEETS',
      label: 'Total Reposts',
      field: 'total_retweets',
    },
    {
      value: 'TWITTER_URL_CLICKS',
      label: 'Link Clicks',
      field: 'url_clicks',
    },
    {
      value: 'TWITTER_FOLLOWS',
      label: 'User Follows',
      field: 'follows',
    },
    {
      value: 'TWITTER_USER_PROFILE_CLICKS',
      label: 'Profile Clicks',
      field: 'user_profile_clicks',
    },
    {
      value: 'TWITTER_VIDEO_VIEWS',
      label: 'Video Views',
      field: 'video_views',
    },
    {
      value: 'TWITTER_QUOTE_TWEETS',
      label: 'Quote Posts',
      field: 'quote_tweets',
    },
  ],
  INSTAGRAM_STORY: [
    {
      value: 'DATE',
      label: 'Recently Published',
    },
    { value: 'INSTAGRAM_STORY_FRAME_VIEWS_V2', label: 'Views', field: 'views_v2' },
    {
      value: 'INSTAGRAM_STORY_FRAME_COMPLETION_RATE_VIEWS',
      label: 'Completion Rate',
      field: 'completion_rate_views',
    },
    {
      value: 'INSTAGRAM_STORY_FRAME_SWIPE_UPS',
      label: 'Link Clicks',
      field: 'swipe_ups',
    },
    {
      value: 'INSTAGRAM_STORY_FRAME_EXIT_RATE_VIEWS',
      label: 'Exit Rate',
      field: 'exit_rate_views',
    },
    {
      value: 'INSTAGRAM_STORY_FRAME_REACH',
      label: 'Reach',
      field: 'reach',
    },
    {
      value: 'INSTAGRAM_STORY_FRAME_EXITS',
      label: 'Exits',
      field: 'exits',
    },
    {
      value: 'INSTAGRAM_STORY_FRAME_REPLIES',
      label: 'Replies',
      field: 'replies',
    },
    {
      title: 'Discontinued',
      children: [
        {
          value: 'INSTAGRAM_STORY_FRAME_IMPRESSIONS',
          label: 'Impressions (Discontinued)',
          field: 'views',
        },
        {
          value: 'INSTAGRAM_STORY_FRAME_COMPLETION_RATE',
          label: 'Completion Rate (Discontinued)',
          field: 'completion_rate',
        },
        {
          value: 'INSTAGRAM_STORY_FRAME_EXIT_RATE',
          label: 'Exit Rate (Discontinued)',
          field: 'exit_rate',
        },
      ],
    },
  ],
  YOUTUBE: [
    {
      value: 'DATE',
      label: 'Recently Published',
    },
    {
      value: 'YOUTUBE_COMMENTS',
      label: 'Comments',
      field: 'comments',
    },

    {
      value: 'YOUTUBE_VIDEOS_ADDED_TO_PLAYLIST',
      label: 'Added to Playlist',
      field: 'videos_added_to_playlist',
    },
    {
      value: 'YOUTUBE_DISLIKES',
      label: 'Dislikes',
      field: 'dislikes',
    },
    {
      value: 'YOUTUBE_AVG_VIEW_PERCENTAGE',
      label: 'Avg. % Viewed',
      field: 'avg_view_percentage',
    },
    {
      value: 'YOUTUBE_LIKES',
      label: 'Likes',
      field: 'likes',
    },
    {
      value: 'YOUTUBE_PREMIUM_VIEWS',
      label: 'Premimum Views',
      field: 'premimum_views',
    },

    {
      value: 'YOUTUBE_AVG_VIEW_DURATION',
      label: 'Avg. View Duration',
      field: 'avg_view_duration',
    },
    {
      value: 'YOUTUBE_EST_PREMIUM_SECONDS_WATCHED',
      label: 'Premium Watch Time',
      field: 'est_premium_seconds_watched',
    },

    {
      value: 'YOUTUBE_CARD_CLICKS',
      label: 'Card Clicks',
      field: 'card_clicks',
    },
    {
      value: 'YOUTUBE_SHARES',
      label: 'Shares',
      field: 'shares',
    },
    {
      value: 'YOUTUBE_CARD_CLICK_RATE',
      label: 'Card Click Rate',
      field: 'card_click_rate',
    },
    {
      value: 'YOUTUBE_SUBSCRIBERS',
      label: 'Subscribers',
      field: 'subscribers',
    },

    {
      value: 'YOUTUBE_CARD_TEASER_CLICKS',
      label: 'Card Teaser Clicks',
      field: 'card_teaser_clicks',
    },
    {
      value: 'YOUTUBE_ENGAGEMENTS',
      label: 'Engagements',
      field: 'engagements',
    },

    {
      value: 'YOUTUBE_CARD_TEASER_CLICK_RATE',
      label: 'Card Teaser Click Rate',
      field: 'card_teaser_click_rate',
    },

    {
      value: 'YOUTUBE_VIEWS',
      label: 'Video Views',
      field: 'views',
    },
    {
      value: 'YOUTUBE_CARD_TEASER_IMPRESSIONS',
      label: 'Card Teaser Impressions',
      field: 'card_teaser_impressions',
    },

    {
      value: 'YOUTUBE_EST_SECONDS_WATCHED',
      label: 'Watch Time',
      field: 'est_seconds_watched',
    },
  ],
  PINTEREST: [
    {
      value: 'DATE',
      label: 'Recently Published',
    },
    {
      value: 'PINTEREST_TOTAL_CLICKS',
      label: 'Outbound Clicks',
      field: 'total_clicks',
    },
    {
      value: 'PINTEREST_AVERAGE_VIDEO_WATCH_TIME',
      label: 'Average Watch Time',
      field: 'average_video_watch_time',
    },
    {
      value: 'PINTEREST_TOTAL_CLOSEUPS',
      label: 'Pin Clicks',
      field: 'total_closeups',
    },
    {
      value: 'PINTEREST_ENGAGEMENT_RATE',
      label: 'Engagement Rate',
      field: 'engagement_rate',
    },

    {
      value: 'PINTEREST_TOTAL_SAVES',
      label: 'Saves',
      field: 'total_saves',
    },
    {
      value: 'PINTEREST_TOTAL_IMPRESSIONS',
      label: 'Impressions',
      field: 'total_impressions',
    },

    {
      value: 'PINTEREST_TOTAL_VIDEO_VIEWS',
      label: 'Video Views',
      field: 'total_video_views',
    },
  ],
  UGC: [
    { value: 'DATE', label: 'Recently Published' },
    {
      title: 'Posts',
      children: [
        { value: 'INSTAGRAM_REACH', label: 'Reach', field: 'reach' },
        { value: 'INSTAGRAM_ENGAGEMENT_RATE', label: 'Engagement Rate', field: 'engagement' },
        { value: 'INSTAGRAM_TOTAL_ENGAGEMENTS', label: 'Engagements', field: 'total_engagement' },
        { value: 'INSTAGRAM_TOTAL_LIKES', label: 'Likes', field: 'total_likes' },
        { value: 'INSTAGRAM_VIEWS', label: 'Views', field: 'views' },
      ],
    },
    {
      title: 'Stories',
      children: [
        { value: 'INSTAGRAM_STORY_FRAME_REACH', label: 'Reach', field: 'reach' },
        { value: 'INSTAGRAM_STORY_FRAME_VIEWS_V2', label: 'Views', field: 'views_v2' },
        {
          value: 'INSTAGRAM_STORY_FRAME_COMPLETION_RATE_VIEWS',
          label: 'Completion Rate',
          field: 'completion_rate_views',
        },
        {
          value: 'INSTAGRAM_STORY_FRAME_EXIT_RATE_VIEWS',
          label: 'Exit Rate',
          field: 'exit_rate_views',
        },
        {
          value: 'INSTAGRAM_STORY_FRAME_EXITS',
          label: 'Exits',
          field: 'exits',
        },
      ],
    },
    {
      title: 'Discontinued',
      children: [
        {
          value: 'INSTAGRAM_STORY_FRAME_IMPRESSIONS',
          label: 'Impressions (Discontinued)',
          field: 'views',
        },
        {
          value: 'INSTAGRAM_STORY_FRAME_COMPLETION_RATE',
          label: 'Completion Rate (Discontinued)',
          field: 'completion_rate',
        },
        {
          value: 'INSTAGRAM_STORY_FRAME_EXIT_RATE',
          label: 'Exit Rate (Discontinued)',
          field: 'exit_rate',
        },
      ],
    },
  ],
};

export const OLD_TIKTOK_POST_METRICS = {
  [postMetricKeys.TIKTOK.VIDEO_VIEWS]: {
    field: 'views',
    label: 'Video Views',
  },
  [postMetricKeys.TIKTOK.TOTAL_ENGAGEMENTS]: {
    field: 'total_engagements',
    label: 'Engagements',
  },
  [postMetricKeys.TIKTOK.EFFECTIVENESS]: {
    field: 'effectiveness',
    label: 'Effectiveness',
    format: 'percent',
  },
  [postMetricKeys.TIKTOK.ENGAGEMENT_RATE]: {
    field: 'engagement_rate',
    label: 'Engagement Rate',
    format: 'percent',
  },
  [postMetricKeys.TIKTOK.ENTERTAINMENT_SCORE]: {
    field: 'entertainment_score',
    label: 'Entertainment Score',
    format: 'two_decimal_float',
  },
  [postMetricKeys.TIKTOK.RETENTION_RATE]: {
    field: 'average_completion_rate',
    label: 'Retention Rate',
    format: 'percent',
  },
  [postMetricKeys.TIKTOK.FYP_VIEWS]: {
    field: 'impressions_for_you_rate',
    label: 'FYP Views %',
    format: 'percent',
  },
  [postMetricKeys.TIKTOK.DATE]: {
    label: 'Recently Published',
  },
  [postMetricKeys.TIKTOK.IMPRESSIONS_PERSONAL_PROFILE_RATE]: {
    field: 'impressions_personal_profile_rate',
    label: 'Profile Views %',
    format: 'percent',
  },
  [postMetricKeys.TIKTOK.AVERAGE_TIME_WATCHED]: {
    field: 'average_time_watched',
    label: 'Avg. Time Watched',
    format: 'duration',
    num_decimals: 1,
  },
  [postMetricKeys.TIKTOK.REACH]: {
    field: 'reach',
    label: 'Reach',
  },
  [postMetricKeys.TIKTOK.COMMENTS]: {
    field: 'comments',
    label: 'Comments',
  },
  [postMetricKeys.TIKTOK.FULL_VIDEO_WATCHED_RATE]: {
    field: 'full_video_watched_rate',
    label: 'Completion Rate',
    format: 'percent',
  },
  [postMetricKeys.TIKTOK.IMPRESSIONS_SEARCH_RATE]: {
    field: 'impressions_search_rate',
    label: 'Search Views %',
    format: 'percent',
  },
  [postMetricKeys.TIKTOK.SHARES]: {
    field: 'shares',
    label: 'Shares',
  },
  [postMetricKeys.TIKTOK.IMPRESSIONS_SOUND_RATE]: {
    field: 'impressions_sound_rate',
    label: 'Sound Views %',
    format: 'percent',
  },
  [postMetricKeys.TIKTOK.IMPRESSIONS_FOLLOW_RATE]: {
    field: 'impressions_follow_rate',
    label: 'Following Page Views %',
    format: 'percent',
  },
  [postMetricKeys.TIKTOK.TOTAL_TIME_WATCHED]: {
    field: 'total_time_watched',
    label: 'Total Time Watched',
    format: 'duration',
  },
  [postMetricKeys.TIKTOK.IMPRESSIONS_HASHTAG_RATE]: {
    field: 'impressions_hashtag_rate',
    label: 'Hashtag Views %',
    format: 'percent',
  },
  [postMetricKeys.TIKTOK.DURATION]: {
    field: 'duration',
    label: 'Video Duration',
    format: 'duration',
  },
  [postMetricKeys.TIKTOK.LIKES]: {
    field: 'likes',
    label: 'Likes',
  },
};

export const OLD_INSTAGRAM_POST_METRICS = {
  [postMetricKeys.INSTAGRAM.ORGANIC_COMMENTS]: {
    label: 'Comments',
    field: 'comments_count',
    postType: POST_TYPE.ORGANIC,
  },
  [postMetricKeys.INSTAGRAM.PAID_COMMENTS]: {
    label: 'Comments',
    field: 'paid_comments',
    postType: POST_TYPE.PROMOTED,
  },
  [postMetricKeys.INSTAGRAM.TOTAL_COMMENTS]: {
    label: 'Comments ',
    field: 'total_comments',
    postType: POST_TYPE.ORGANIC_PROMOTED,
  },
  [postMetricKeys.INSTAGRAM.ORGANIC_EFFECTIVENESS_ENGAGEMENTS]: {
    label: 'Effectiveness',
    field: 'effectiveness_engagements',
    postType: POST_TYPE.ORGANIC,
  },
  [postMetricKeys.INSTAGRAM.ENGAGEMENT_RATE]: {
    label: 'Engagement Rate',
    field: 'engagement',
    postType: POST_TYPE.ORGANIC,
  },
  [postMetricKeys.INSTAGRAM.PAID_IMPRESSIONS]: {
    label: 'Impressions',
    field: 'paid_impressions',
    postType: POST_TYPE.PROMOTED,
  },
  [postMetricKeys.INSTAGRAM.ORGANIC_LIKES]: {
    label: 'Likes',
    field: 'like_count',
    postType: POST_TYPE.ORGANIC,
  },
  [postMetricKeys.INSTAGRAM.PAID_LIKES]: {
    label: 'Likes',
    field: 'paid_likes',
    postType: POST_TYPE.PROMOTED,
  },
  [postMetricKeys.INSTAGRAM.TOTAL_LIKES]: {
    label: 'Likes',
    field: 'total_likes',
    postType: POST_TYPE.ORGANIC_PROMOTED,
  },
  [postMetricKeys.INSTAGRAM.LIKESHOP_CLICKS]: {
    label: 'LikeShop Clicks',
    field: 'likeshop_clicks',
  },
  [postMetricKeys.INSTAGRAM.REACH]: {
    label: 'Reach',
    field: 'reach',
    postType: POST_TYPE.ORGANIC,
  },
  [postMetricKeys.INSTAGRAM.SAVES]: {
    label: 'Saves',
    field: 'saved',
    postType: POST_TYPE.ORGANIC,
  },
  [postMetricKeys.INSTAGRAM.TOTAL_ENGAGEMENTS]: {
    label: 'Engagements',
    field: 'total_engagement',
    postType: POST_TYPE.ORGANIC,
  },
  [postMetricKeys.INSTAGRAM.PAID_TOTAL_ENGAGEMENTS]: {
    label: 'Engagements',
    field: 'paid_total_engagements',
    postType: POST_TYPE.PROMOTED,
  },
  [postMetricKeys.INSTAGRAM.SUM_TOTAL_ENGAGEMENTS]: {
    label: 'Engagements',
    field: 'sum_total_engagements',
    postType: POST_TYPE.ORGANIC_PROMOTED,
  },
  [postMetricKeys.INSTAGRAM.PAID_VIDEO_VIEWS]: {
    label: 'Video Views',
    field: 'paid_video_views',
    postType: POST_TYPE.PROMOTED,
  },
  [postMetricKeys.INSTAGRAM.ORGANIC_VIEWS]: {
    label: 'Views',
    field: 'views',
    postType: POST_TYPE.ORGANIC,
  },
  // Discontinued metrics
  [postMetricKeys.INSTAGRAM.EFFECTIVENESS_DISCONTINUED]: {
    label: 'Effectiveness (Discontinued)',
    field: 'effectiveness',
    postType: POST_TYPE.ORGANIC,
  },
  [postMetricKeys.INSTAGRAM.ORGANIC_IMPRESSIONS_DISCONTINUED]: {
    label: 'Impressions (Discontinued)',
    field: 'impressions',
    postType: POST_TYPE.ORGANIC,
  },
  [postMetricKeys.INSTAGRAM.VIDEO_VIEWS_DISCONTINUED]: {
    label: 'Video Views (Discontinued)',
    field: 'video_views',
    postType: POST_TYPE.ORGANIC,
  },
  [postMetricKeys.INSTAGRAM.TOTAL_IMPRESSIONS_DISCONTINUED]: {
    label: 'Impressions (Discontinued)',
    field: 'total_impressions',
    postType: POST_TYPE.ORGANIC_PROMOTED,
  },
  [postMetricKeys.INSTAGRAM.TOTAL_VIDEO_VIEWS_DISCONTINUED]: {
    label: 'Video Views (Discontinued)',
    field: 'total_video_views',
    postType: POST_TYPE.ORGANIC_PROMOTED,
  },
};

export const postMetrics = {
  TIKTOK: Object.fromEntries(
    Object.entries(OLD_TIKTOK_POST_METRICS).flatMap(([key, metric]) => {
      if (key === postMetricKeys.TIKTOK.ENGAGEMENT_RATE) {
        return [
          [
            postMetricKeys.TIKTOK.ENGAGEMENT_RATE,
            {
              field: 'engagement_rate',
              label: 'Eng. Rate (Reach)',
              format: 'percent',
            },
          ],
          [
            postMetricKeys.TIKTOK.VIEWS_BASED_ENGAGEMENT_RATE,
            {
              field: 'views_based_engagement_rate',
              label: 'Eng. Rate (Video Views)',
              format: 'percent',
            },
          ],
        ];
      }
      return [[key, metric]];
    }),
  ),
  FACEBOOK: {
    [postMetricKeys.FACEBOOK.DATE]: {
      label: 'Recently Published',
    },
    [postMetricKeys.FACEBOOK.POST_CLICKS]: {
      label: 'Post Clicks',
      field: 'post_clicks',
    },
    [postMetricKeys.FACEBOOK.COMMENTS]: {
      label: 'Comments',
      field: 'comments',
    },
    [postMetricKeys.FACEBOOK.REACH]: {
      label: 'Reach',
      field: 'reach',
    },
    [postMetricKeys.FACEBOOK.EFFECTIVENESS]: {
      label: 'Effectiveness',
      field: 'effectiveness',
      format: 'percent',
    },
    [postMetricKeys.FACEBOOK.REACTIONS]: {
      label: 'Reactions',
      field: 'reactions',
    },
    [postMetricKeys.FACEBOOK.ENGAGEMENT_RATE]: {
      label: 'Engagement Rate',
      field: 'engagement_rate',
      format: 'percent',
    },
    [postMetricKeys.FACEBOOK.SHARES]: {
      label: 'Shares',
      field: 'shares',
    },
    [postMetricKeys.FACEBOOK.IMPRESSIONS]: {
      label: 'Impressions - Organic (Discontinued)',
      field: 'impressions',
    },
    [postMetricKeys.FACEBOOK.TOTAL_ENGAGEMENTS]: {
      label: 'Engagements',
      field: 'total_engagements',
    },
    [postMetricKeys.FACEBOOK.LINK_CLICKS]: {
      label: 'Link Clicks (Promoted)',
      field: 'link_clicks',
    },
    [postMetricKeys.FACEBOOK.VIDEO_COMPLETE_VIEWS]: {
      label: 'Video Complete Views',
      field: 'video_complete_views',
    },
    [postMetricKeys.FACEBOOK.OTHER_CLICKS]: {
      label: 'Other Clicks',
      field: 'other_clicks',
    },
    [postMetricKeys.FACEBOOK.VIDEO_VIEWS]: {
      label: 'Video Views',
      field: 'video_views',
    },
    [postMetricKeys.FACEBOOK.PHOTO_VIEW_CLICKS]: {
      label: 'Photo View Clicks',
      field: 'photo_view_clicks',
    },
    [postMetricKeys.FACEBOOK.ORGANIC_COMMENTS]: {
      label: 'Comments (Organic)',
      field: 'organic_comments',
    },
    [postMetricKeys.FACEBOOK.ORGANIC_EFFECTIVENESS]: {
      label: 'Effectiveness (Organic)',
      field: 'organic_effectiveness',
      format: 'percent',
    },
    [postMetricKeys.FACEBOOK.ORGANIC_EFFECTIVENESS_V2]: {
      label: 'Effectiveness (Organic)',
      field: 'organic_effectiveness_v2',
      format: 'percent',
    },
    [postMetricKeys.FACEBOOK.ORGANIC_ENGAGEMENT_RATE]: {
      label: 'Engagement Rate (Organic)',
      field: 'organic_engagement_rate',
      format: 'percent',
    },
    [postMetricKeys.FACEBOOK.ORGANIC_ENGAGEMENT_RATE_V2]: {
      label: 'Engagement Rate (Organic)',
      field: 'organic_engagement_rate_v2',
      format: 'percent',
    },
    [postMetricKeys.FACEBOOK.ORGANIC_ENGAGEMENTS]: {
      label: 'Engagements (Organic)',
      field: 'organic_engagements',
    },
    [postMetricKeys.FACEBOOK.ORGANIC_ENGAGEMENTS_V2]: {
      label: 'Engagements (Organic)',
      field: 'organic_engagements_v2',
    },
    [postMetricKeys.FACEBOOK.ORGANIC_REACH]: {
      label: 'Reach (Organic)',
      field: 'organic_reach',
      flag: 'fbMetricsDeprecation2026',
      includeWithFlag: false,
    },
    [postMetricKeys.FACEBOOK.ORGANIC_REACTIONS]: {
      label: 'Reactions (Organic)',
      field: 'organic_reactions',
    },
    [postMetricKeys.FACEBOOK.ORGANIC_SHARES]: {
      label: 'Shares (Organic)',
      field: 'organic_shares',
    },
    [postMetricKeys.FACEBOOK.ORGANIC_VIEWS]: {
      label: 'Views (Organic)',
      field: 'organic_views',
    },
    [postMetricKeys.FACEBOOK.ORGANIC_VIDEO_VIEWS]: {
      label: 'Video Views (Organic)',
      field: 'organic_video_views',
    },
    [postMetricKeys.FACEBOOK.ORGANIC_VIDEO_COMPLETE_VIEWS]: {
      label: 'Video Complete Views (Organic)',
      field: 'organic_video_complete_views',
    },
    [postMetricKeys.FACEBOOK.PAID_COMMENTS]: {
      label: 'Comments (Promoted)',
      field: 'paid_comments',
    },
    [postMetricKeys.FACEBOOK.PAID_EFFECTIVENESS]: {
      label: 'Effectiveness (Promoted)',
      field: 'paid_effectiveness',
      format: 'percent',
    },
    [postMetricKeys.FACEBOOK.PAID_EFFECTIVENESS_V2]: {
      label: 'Effectiveness (Promoted)',
      field: 'paid_effectiveness_v2',
      format: 'percent',
    },
    [postMetricKeys.FACEBOOK.PAID_ENGAGEMENT_RATE]: {
      label: 'Engagement Rate (Promoted)',
      field: 'paid_engagement_rate',
      format: 'percent',
    },
    [postMetricKeys.FACEBOOK.PAID_ENGAGEMENT_RATE_V2]: {
      label: 'Engagement Rate (Promoted)',
      field: 'paid_engagement_rate_v2',
      format: 'percent',
    },
    [postMetricKeys.FACEBOOK.PAID_ENGAGEMENTS]: {
      label: 'Engagements (Promoted)',
      field: 'paid_engagements',
    },
    [postMetricKeys.FACEBOOK.PAID_REACH]: {
      label: 'Reach (Promoted)',
      field: 'paid_reach',
      flag: 'fbMetricsDeprecation2026',
      includeWithFlag: false,
    },
    [postMetricKeys.FACEBOOK.PAID_REACH_V2]: {
      label: 'Reach (Promoted)',
      field: 'paid_reach_v2',
      flag: 'fbMetricsDeprecation2026',
      includeWithFlag: false,
    },
    [postMetricKeys.FACEBOOK.PAID_VIEWERS]: {
      label: 'Viewers (Promoted)',
      field: 'paid_reach_v2',
      flag: 'fbMetricsDeprecation2026',
      includeWithFlag: true,
    },
    [postMetricKeys.FACEBOOK.PAID_REACTIONS]: {
      label: 'Reactions (Promoted)',
      field: 'paid_reactions',
    },
    [postMetricKeys.FACEBOOK.PAID_SHARES]: {
      label: 'Shares (Promoted)',
      field: 'paid_shares',
    },
    [postMetricKeys.FACEBOOK.PAID_VIEWS]: {
      label: 'Views (Promoted)',
      field: 'paid_views',
    },
    [postMetricKeys.FACEBOOK.PAID_VIDEO_VIEWS]: {
      label: 'Video Views (Promoted)',
      field: 'paid_video_views',
    },
    [postMetricKeys.FACEBOOK.PAID_VIDEO_COMPLETE_VIEWS]: {
      label: 'Video Complete Views (Promoted)',
      field: 'paid_video_complete_views',
    },
    [postMetricKeys.FACEBOOK.PAID_LINK_CLICKS]: {
      label: 'Link Clicks (Promoted)',
      field: 'paid_link_clicks',
    },
    [postMetricKeys.FACEBOOK.PAID_AND_ORGANIC_COMMENTS]: {
      label: 'Comments (Total)',
      field: 'paid_and_organic_comments',
    },
    [postMetricKeys.FACEBOOK.PAID_AND_ORGANIC_EFFECTIVENESS]: {
      label: 'Effectiveness (Total)',
      field: 'paid_and_organic_effectiveness',
      format: 'percent',
    },
    [postMetricKeys.FACEBOOK.PAID_AND_ORGANIC_EFFECTIVENESS_V2]: {
      label: 'Effectiveness (Total)',
      field: 'paid_and_organic_effectiveness_v2',
      format: 'percent',
    },
    [postMetricKeys.FACEBOOK.PAID_AND_ORGANIC_ENGAGEMENT_RATE]: {
      label: 'Engagement Rate (Total)',
      field: 'paid_and_organic_engagement_rate',
      format: 'percent',
    },
    [postMetricKeys.FACEBOOK.PAID_AND_ORGANIC_ENGAGEMENT_RATE_V2]: {
      label: 'Engagement Rate (Total)',
      field: 'paid_and_organic_engagement_rate_v2',
      format: 'percent',
    },
    [postMetricKeys.FACEBOOK.PAID_AND_ORGANIC_ENGAGEMENTS]: {
      label: 'Engagements (Total)',
      field: 'paid_and_organic_engagements',
    },
    [postMetricKeys.FACEBOOK.PAID_AND_ORGANIC_ENGAGEMENTS_V2]: {
      label: 'Engagements (Total)',
      field: 'paid_and_organic_engagements_v2',
    },
    [postMetricKeys.FACEBOOK.PAID_AND_ORGANIC_LINK_CLICKS]: {
      label: 'Link Clicks (Total)',
      field: 'paid_and_organic_link_clicks',
    },
    [postMetricKeys.FACEBOOK.PAID_AND_ORGANIC_OTHER_CLICKS]: {
      label: 'Other Clicks (Total)',
      field: 'paid_and_organic_other_clicks',
    },
    [postMetricKeys.FACEBOOK.PAID_AND_ORGANIC_PHOTO_VIEW_CLICKS]: {
      label: 'Photo View Clicks (Total)',
      field: 'paid_and_organic_photo_view_clicks',
    },
    [postMetricKeys.FACEBOOK.PAID_AND_ORGANIC_POST_CLICKS]: {
      label: 'Post Clicks (Total)',
      field: 'paid_and_organic_post_clicks',
    },
    [postMetricKeys.FACEBOOK.PAID_AND_ORGANIC_REACH]: {
      label: 'Reach (Total)',
      field: 'paid_and_organic_reach',
      flag: 'fbMetricsDeprecation2026',
      includeWithFlag: false,
    },
    [postMetricKeys.FACEBOOK.PAID_AND_ORGANIC_REACH_V2]: {
      label: 'Reach (Total)',
      field: 'paid_and_organic_reach_v2',
      flag: 'fbMetricsDeprecation2026',
      includeWithFlag: false,
    },
    [postMetricKeys.FACEBOOK.PAID_AND_ORGANIC_VIEWERS]: {
      label: 'Viewers (Total)',
      field: 'paid_and_organic_reach_v2',
      flag: 'fbMetricsDeprecation2026',
      includeWithFlag: true,
    },
    [postMetricKeys.FACEBOOK.PAID_AND_ORGANIC_REACTIONS]: {
      label: 'Reactions (Total)',
      field: 'paid_and_organic_reactions',
    },
    [postMetricKeys.FACEBOOK.PAID_AND_ORGANIC_SHARES]: {
      label: 'Shares (Total)',
      field: 'paid_and_organic_shares',
    },
    [postMetricKeys.FACEBOOK.PAID_AND_ORGANIC_VIEWS]: {
      label: 'Views (Total)',
      field: 'paid_and_organic_views',
    },
    [postMetricKeys.FACEBOOK.PAID_AND_ORGANIC_VIDEO_VIEWS]: {
      label: 'Video Views (Total)',
      field: 'paid_and_organic_video_views',
    },
    [postMetricKeys.FACEBOOK.PAID_AND_ORGANIC_VIDEO_COMPLETE_VIEWS]: {
      label: 'Video Complete Views (Total)',
      field: 'paid_and_organic_video_complete_views',
    },
  },
  TWITTER: {
    [postMetricKeys.TWITTER.DATE]: {
      label: 'Recently Published',
    },
    [postMetricKeys.TWITTER.ENGAGEMENT_RATE]: {
      label: 'Engagement Rate',
      field: 'engagement_rate',
    },
    [postMetricKeys.TWITTER.TOTAL_ENGAGEMENTS]: {
      label: 'Engagements',
      field: 'total_engagements',
    },
    [postMetricKeys.TWITTER.IMPRESSIONS]: {
      label: 'Impressions',
      field: 'impressions',
    },
    [postMetricKeys.TWITTER.LIKES]: {
      label: 'Likes',
      field: 'likes',
    },
    [postMetricKeys.TWITTER.URL_CLICKS]: {
      label: 'Link Clicks',
      field: 'url_clicks',
    },
    [postMetricKeys.TWITTER.TOTAL_RETWEETS]: {
      label: 'Total Reposts',
      field: 'total_retweets',
    },
    [postMetricKeys.TWITTER.RETWEETS]: {
      label: 'Reposts',
      field: 'retweets',
    },
    [postMetricKeys.TWITTER.FOLLOWS]: {
      label: 'User Follows',
      field: 'follows',
    },
    [postMetricKeys.TWITTER.PROFILE_CLICKS]: {
      label: 'Profile Clicks',
      field: 'user_profile_clicks',
    },
    [postMetricKeys.TWITTER.VIDEO_VIEWS]: {
      label: 'Video Views',
      field: 'video_views',
    },
    [postMetricKeys.TWITTER.QUOTE_TWEETS]: {
      label: 'Quote Posts',
      field: 'quote_tweets',
    },
    [postMetricKeys.TWITTER.REPLIES]: {
      label: 'Replies',
      field: 'replies',
    },
  },
  INSTAGRAM_STORY: {
    [postMetricKeys.INSTAGRAM_STORY.REACH]: {
      label: 'Reach',
      field: 'reach',
    },
    [postMetricKeys.INSTAGRAM_STORY.IMPRESSIONS]: {
      label: 'Impressions (Discontinued)',
      field: 'views',
    },
    [postMetricKeys.INSTAGRAM_STORY.COMPLETION_RATE]: {
      label: 'Completion Rate (Discontinued)',
      field: 'completion_rate',
      format: 'percent',
    },
    [postMetricKeys.INSTAGRAM_STORY.EXIT_RATE]: {
      label: 'Exit Rate (Discontinued)',
      field: 'exit_rate',
    },
    [postMetricKeys.INSTAGRAM_STORY.VIEWS]: {
      label: 'Views',
      field: 'views_v2',
    },
    [postMetricKeys.INSTAGRAM_STORY.COMPLETION_RATE_VIEWS]: {
      label: 'Completion Rate',
      field: 'completion_rate_views',
      format: 'percent',
    },
    [postMetricKeys.INSTAGRAM_STORY.EXIT_RATE_VIEWS]: {
      label: 'Exit Rate',
      field: 'exit_rate_views',
    },
    [postMetricKeys.INSTAGRAM_STORY.EXITS]: {
      label: 'Exits',
      field: 'exits',
    },
    [postMetricKeys.INSTAGRAM_STORY.LINK_CLICKS]: {
      label: 'Link Clicks',
      field: 'swipe_ups',
    },
    [postMetricKeys.INSTAGRAM_STORY.REPLIES]: {
      label: 'Replies',
      field: 'replies',
    },
  },
  YOUTUBE: {
    [postMetricKeys.YOUTUBE.DATE]: {
      label: 'Recently Published',
    },
    [postMetricKeys.YOUTUBE.VIDEO_VIEWS]: {
      label: 'Video Views',
      field: 'views',
    },
    [postMetricKeys.YOUTUBE.AVERAGE_VIEW_DURATION]: {
      label: 'Avg. View Duration',
      field: 'avg_view_duration',
    },
    [postMetricKeys.YOUTUBE.AVERAGE_PERCENTAGE_VIEWED]: {
      label: 'Avg. % Viewed',
      field: 'avg_view_percentage',
    },
    [postMetricKeys.YOUTUBE.WATCH_TIME]: {
      label: 'Watch Time',
      field: 'est_seconds_watched',
    },
    [postMetricKeys.YOUTUBE.SUBSCRIBERS]: {
      label: 'Subscribers',
      field: 'subscribers',
    },
    [postMetricKeys.YOUTUBE.TOTAL_ENGAGEMENTS]: {
      label: 'Engagements',
      field: 'engagements',
    },
    [postMetricKeys.YOUTUBE.CARD_CLICKS]: {
      label: 'Card Clicks',
      field: 'card_clicks',
    },
    [postMetricKeys.YOUTUBE.CARD_CLICK_RATE]: {
      label: 'Card Click Rate',
      field: 'card_click_rate',
    },
    [postMetricKeys.YOUTUBE.CARD_TEASER_CLICKS]: {
      label: 'Card Teaser Clicks',
      field: 'card_teaser_clicks',
    },
    [postMetricKeys.YOUTUBE.CARD_TEASER_CLICK_RATE]: {
      label: 'Card Teaser Click Rate',
      field: 'card_teaser_click_rate',
    },
    [postMetricKeys.YOUTUBE.CARD_TEASER_IMPRESSIONS]: {
      label: 'Card Teaser Impressions',
      field: 'card_teaser_impressions',
    },
    [postMetricKeys.YOUTUBE.PREMIUM_VIEWS]: {
      label: 'Premium Views',
      field: 'premium_views',
    },
    [postMetricKeys.YOUTUBE.PREMIUM_WATCH_TIME]: {
      label: 'Premium Watch Time',
      field: 'est_premium_seconds_watched',
    },
    [postMetricKeys.YOUTUBE.LIKES]: {
      label: 'Likes',
      field: 'likes',
    },
    [postMetricKeys.YOUTUBE.DISLIKES]: {
      label: 'Dislikes',
      field: 'dislikes',
    },
    [postMetricKeys.YOUTUBE.COMMENTS]: {
      label: 'Comments',
      field: 'comments',
    },
    [postMetricKeys.YOUTUBE.SHARES]: {
      label: 'Shares',
      field: 'shares',
    },
    [postMetricKeys.YOUTUBE.ADDED_TO_PLAYLIST]: {
      label: 'Added to Playlist',
      field: 'videos_added_to_playlist',
    },
  },
  PINTEREST: {
    [postMetricKeys.PINTEREST.DATE]: {
      label: 'Recently Published',
    },
    [postMetricKeys.PINTEREST.IMPRESSIONS]: {
      label: 'Impressions',
      field: 'total_impressions',
    },
    [postMetricKeys.PINTEREST.ENGAGEMENT_RATE]: {
      label: 'Engagement Rate',
      field: 'engagement_rate',
    },
    [postMetricKeys.PINTEREST.SAVES]: {
      label: 'Saves',
      field: 'total_saves',
    },
    [postMetricKeys.PINTEREST.OUTBOUND_CLICKS]: {
      label: 'Outbound Clicks',
      field: 'total_clicks',
    },
    [postMetricKeys.PINTEREST.PIN_CLICKS]: {
      label: 'Pin Clicks',
      field: 'total_closeups',
    },
    [postMetricKeys.PINTEREST.VIDEO_VIEWS]: {
      label: 'Video Views',
      field: 'total_video_views',
    },
    [postMetricKeys.PINTEREST.AVERAGE_VIDEO_WATCH_TIME]: {
      label: 'Average Watch Time',
      field: 'average_video_watch_time',
    },
  },
  INSTAGRAM: Object.fromEntries(
    Object.entries(OLD_INSTAGRAM_POST_METRICS).flatMap(([key, metric]) => {
      if (key === postMetricKeys.INSTAGRAM.ENGAGEMENT_RATE) {
        return [
          [
            postMetricKeys.INSTAGRAM.ENGAGEMENT_RATE,
            {
              label: 'Eng. Rate (Followers)',
              field: 'engagement',
              postType: POST_TYPE.ORGANIC,
            },
          ],
          [
            postMetricKeys.INSTAGRAM.ENGAGEMENT_RATE_VIEWS,
            {
              field: 'engagement_rate_views',
              label: 'Eng. Rate (Views)',
              postType: POST_TYPE.ORGANIC,
            },
          ],
        ];
      }
      return [[key, metric]];
    }),
  ),
  UGC: {
    [postMetricKeys.UGC.DATE]: { field: '' },
    [postMetricKeys.UGC.ESTIMATED_REACH]: {
      label: 'Estimated Reach',
      field: 'reach',
    },
    [postMetricKeys.UGC.ENGAGEMENT_RATE]: {
      label: 'Engagement Rate',
      field: 'engagement',
    },
    [postMetricKeys.UGC.ENGAGEMENTS]: {
      label: 'Engagements - Organic',
      field: 'total_engagement',
    },
    [postMetricKeys.INSTAGRAM.TOTAL_LIKES]: {
      label: 'Likes',
      field: 'total_likes',
    },
    [postMetricKeys.UGC.MENTIONED_YOU]: {
      label: 'Mentioned You',
      field: 'is_mentioned',
    },
    [postMetricKeys.UGC.TAGGED_YOU]: {
      label: 'Tagged You',
      field: 'is_tagged',
    },
    [postMetricKeys.UGC.REACH]: {
      label: 'Estimated Reach',
      field: 'reach',
    },
    [postMetricKeys.UGC.IMPRESSIONS]: {
      label: 'Impressions (Discontinued)',
      field: 'views',
    },
    [postMetricKeys.UGC.COMPLETION_RATE]: {
      label: 'Completion Rate (Discontinued)',
      field: 'completion_rate',
    },
    [postMetricKeys.UGC.EXIT_RATE]: {
      label: 'Exit Rate (Discontinued)',
      field: 'exit_rate',
    },
    [postMetricKeys.UGC.COMPLETION_RATE_VIEWS]: {
      label: 'Completion Rate',
      field: 'completion_rate_views',
    },
    [postMetricKeys.UGC.EXIT_RATE_VIEWS]: {
      label: 'Exit Rate',
      field: 'exit_rate_views',
    },
    [postMetricKeys.UGC.EXITS]: {
      label: 'Exits',
      field: 'exits',
    },
    [postMetricKeys.UGC.VIEWS]: {
      label: 'Views - Organic',
      field: 'views',
    },
    [postMetricKeys.UGC.STORY_VIEWS]: {
      label: 'Views',
      field: 'views_v2',
    },
  },
  RELATIONSHIPS: {
    [postMetricKeys.RELATIONSHIPS.ENGAGEMENT_RATE]: {
      label: 'Engagement Rate',
      field: 'engagement',
    },
    [postMetricKeys.RELATIONSHIPS.EFFECTIVENESS]: {
      label: 'Effectiveness',
      field: 'effectiveness',
    },
    [postMetricKeys.RELATIONSHIPS.FOLLOWERS_GAINED]: {
      label: 'Followers Gained',
      field: 'followersGained',
    },
    [postMetricKeys.RELATIONSHIPS.EMV]: {
      label: 'EMV',
      field: 'emv',
    },
    [postMetricKeys.RELATIONSHIPS.REACH]: {
      label: 'Reach',
      field: 'reach',
    },
    [postMetricKeys.RELATIONSHIPS.VIEWS]: {
      label: 'Views',
      field: 'views',
    },
    [postMetricKeys.RELATIONSHIPS.COMPLETION_RATE_VIEWS]: {
      label: 'Completion Rate',
      field: 'completionRateViews',
    },
    [postMetricKeys.RELATIONSHIPS.EXIT_RATE_VIEWS]: {
      label: 'Exit Rate',
      field: 'exitRateViews',
    },
  },
};

export const OLD_INSTAGRAM_MEDIA_CARD_DISPLAY_METRICS = [
  OLD_INSTAGRAM_POST_METRICS[postMetricKeys.INSTAGRAM.ENGAGEMENT_RATE],
  OLD_INSTAGRAM_POST_METRICS[postMetricKeys.INSTAGRAM.ORGANIC_EFFECTIVENESS_ENGAGEMENTS],
  OLD_INSTAGRAM_POST_METRICS[postMetricKeys.INSTAGRAM.TOTAL_ENGAGEMENTS],
  OLD_INSTAGRAM_POST_METRICS[postMetricKeys.INSTAGRAM.REACH],
];

export const MEDIA_CARD_DISPLAY_METRICS = {
  TIKTOK: [
    postMetrics.TIKTOK[postMetricKeys.TIKTOK.ENTERTAINMENT_SCORE],
    postMetrics.TIKTOK[postMetricKeys.TIKTOK.VIDEO_VIEWS],
    postMetrics.TIKTOK[postMetricKeys.TIKTOK.TOTAL_ENGAGEMENTS],
    postMetrics.TIKTOK[postMetricKeys.TIKTOK.AVERAGE_TIME_WATCHED],
  ],
  FACEBOOK: [
    postMetrics.FACEBOOK[postMetricKeys.FACEBOOK.PAID_AND_ORGANIC_ENGAGEMENT_RATE_V2],
    postMetrics.FACEBOOK[postMetricKeys.FACEBOOK.PAID_AND_ORGANIC_ENGAGEMENTS_V2],
    postMetrics.FACEBOOK[postMetricKeys.FACEBOOK.PAID_AND_ORGANIC_REACH_V2],
    postMetrics.FACEBOOK[postMetricKeys.FACEBOOK.PAID_AND_ORGANIC_VIEWERS],
    postMetrics.FACEBOOK[postMetricKeys.FACEBOOK.PAID_AND_ORGANIC_VIEWS],
  ],
  TWITTER: [
    postMetrics.TWITTER[postMetricKeys.TWITTER.ENGAGEMENT_RATE],
    postMetrics.TWITTER[postMetricKeys.TWITTER.TOTAL_ENGAGEMENTS],
    postMetrics.TWITTER[postMetricKeys.TWITTER.IMPRESSIONS],
    postMetrics.TWITTER[postMetricKeys.TWITTER.LIKES],
  ],
  INSTAGRAM_STORY: [
    postMetrics.INSTAGRAM_STORY[postMetricKeys.INSTAGRAM_STORY.REACH],
    postMetrics.INSTAGRAM_STORY[postMetricKeys.INSTAGRAM_STORY.VIEWS],
    postMetrics.INSTAGRAM_STORY[postMetricKeys.INSTAGRAM_STORY.COMPLETION_RATE_VIEWS],
    postMetrics.INSTAGRAM_STORY[postMetricKeys.INSTAGRAM_STORY.EXIT_RATE_VIEWS],
    postMetrics.INSTAGRAM_STORY[postMetricKeys.INSTAGRAM_STORY.EXITS],
    postMetrics.INSTAGRAM_STORY[postMetricKeys.INSTAGRAM_STORY.LINK_CLICKS],
  ],
  YOUTUBE: [
    postMetrics.YOUTUBE[postMetricKeys.YOUTUBE.VIDEO_VIEWS],
    postMetrics.YOUTUBE[postMetricKeys.YOUTUBE.WATCH_TIME],
    postMetrics.YOUTUBE[postMetricKeys.YOUTUBE.AVERAGE_VIEW_DURATION],
    postMetrics.YOUTUBE[postMetricKeys.YOUTUBE.TOTAL_ENGAGEMENTS],
    postMetrics.YOUTUBE[postMetricKeys.YOUTUBE.AVERAGE_PERCENTAGE_VIEWED],
  ],
  PINTEREST: [
    postMetrics.PINTEREST[postMetricKeys.PINTEREST.ENGAGEMENT_RATE],
    postMetrics.PINTEREST[postMetricKeys.PINTEREST.SAVES],
    postMetrics.PINTEREST[postMetricKeys.PINTEREST.IMPRESSIONS],
    postMetrics.PINTEREST[postMetricKeys.PINTEREST.PIN_CLICKS],
  ],
  INSTAGRAM: OLD_INSTAGRAM_MEDIA_CARD_DISPLAY_METRICS.map((metric) => {
    if (metric.field === postMetrics.INSTAGRAM[postMetricKeys.INSTAGRAM.ENGAGEMENT_RATE].field) {
      return postMetrics.INSTAGRAM[postMetricKeys.INSTAGRAM.ENGAGEMENT_RATE_VIEWS];
    }
    return metric;
  }),
  UGC: [
    postMetrics.UGC[postMetricKeys.UGC.ESTIMATED_REACH],
    postMetrics.UGC[postMetricKeys.UGC.ENGAGEMENT_RATE],
    postMetrics.UGC[postMetricKeys.UGC.ENGAGEMENTS],
    postMetrics.UGC[postMetricKeys.UGC.LIKES],
    postMetrics.UGC[postMetricKeys.UGC.VIEWS],
  ],
  UGC_STORY: [
    postMetrics.UGC[postMetricKeys.UGC.ESTIMATED_REACH],
    postMetrics.UGC[postMetricKeys.UGC.STORY_VIEWS],
    postMetrics.UGC[postMetricKeys.UGC.COMPLETION_RATE_VIEWS],
    postMetrics.UGC[postMetricKeys.UGC.EXIT_RATE_VIEWS],
  ],
  RELATIONSHIP_INSTAGRAM: [
    postMetrics.RELATIONSHIPS[postMetricKeys.RELATIONSHIPS.ENGAGEMENT_RATE],
    postMetrics.RELATIONSHIPS[postMetricKeys.RELATIONSHIPS.EFFECTIVENESS],
    postMetrics.RELATIONSHIPS[postMetricKeys.RELATIONSHIPS.FOLLOWERS_GAINED],
    postMetrics.RELATIONSHIPS[postMetricKeys.RELATIONSHIPS.EMV],
  ],
  RELATIONSHIP_STORY: [
    postMetrics.RELATIONSHIPS[postMetricKeys.RELATIONSHIPS.REACH],
    postMetrics.RELATIONSHIPS[postMetricKeys.RELATIONSHIPS.IMPRESSIONS],
    postMetrics.RELATIONSHIPS[postMetricKeys.RELATIONSHIPS.COMPLETION_RATE],
    postMetrics.RELATIONSHIPS[postMetricKeys.RELATIONSHIPS.EXIT_RATE],
    postMetrics.RELATIONSHIPS[postMetricKeys.RELATIONSHIPS.VIEWS],
    postMetrics.RELATIONSHIPS[postMetricKeys.RELATIONSHIPS.COMPLETION_RATE_VIEWS],
    postMetrics.RELATIONSHIPS[postMetricKeys.RELATIONSHIPS.EXIT_RATE_VIEWS],
  ],
  RELATIONSHIPS: [
    postMetrics.RELATIONSHIPS[postMetricKeys.RELATIONSHIPS.ENGAGEMENT_RATE],
    postMetrics.RELATIONSHIPS[postMetricKeys.RELATIONSHIPS.EFFECTIVENESS],
    postMetrics.RELATIONSHIPS[postMetricKeys.RELATIONSHIPS.FOLLOWERS_GAINED],
    postMetrics.RELATIONSHIPS[postMetricKeys.RELATIONSHIPS.EMV],
  ],
};

export const verticalMediaPanelCopy = {
  campaignsTopPerformingVideos: {
    title: 'Top Performing Videos - Owned',
    tooltip:
      'The top performing videos in this Campaign across all owned channels, sorted by video views',
    emptyMessage: 'No videos found during this reporting period',
  },
  campaignsLowestPerformingVideos: {
    title: 'Lowest Performing Videos - Owned',
    tooltip:
      'The lowest performing videos in this Campaign across all owned channels, sorted by video views ',
    emptyMessage: 'No videos found during this reporting period',
  },
  campaignsTopPerformingPosts: {
    title: 'Top Performing Posts - Owned',
    tooltip: 'The top performing posts in this Campaign across all owned channels',
    emptyMessage: 'No posts found during this reporting period',
  },
  campaignsLowestPerformingPosts: {
    title: 'Lowest Performing Posts - Owned',
    tooltip: 'The lowest performing posts in this Campaign across all owned channels',
    emptyMessage: 'No posts found during this reporting period',
  },
};

export const videoViewsAliasMap = {
  INSTAGRAM: 'video_views',
  TIKTOK: 'views',
  FACEBOOK: 'video_views',
  PINTEREST: 'total_video_views',
  TWITTER: 'video_views',
  INSTAGRAM_STORY: 'views',
  YOUTUBE: 'views',
};

export const impressionsAliasMap = {
  INSTAGRAM: 'total_impressions',
  TIKTOK: 'views',
  FACEBOOK: 'impressions',
  PINTEREST: 'total_impressions',
  TWITTER: 'impressions_organic',
  INSTAGRAM_STORY: 'views',
};

export const engagementRateAliasMap = {
  INSTAGRAM: 'engagement',
  TIKTOK: 'engagement_rate',
  FACEBOOK: 'engagement_rate',
  PINTEREST: 'engagement_rate',
  TWITTER: 'engagement_rate_organic',
};

export const videoSortOptions = {
  CROSS_CHANNEL_VIDEO_VIEWS: 'CROSS_CHANNEL_VIDEO_VIEWS',
};

export const graphMetrics = {
  POSTS: {
    value: 'NUMBER_OF_MEDIA',
    text: 'Posts',
  },
  NUMBER_OF_MEDIA: {
    value: 'NUMBER_OF_MEDIA',
    text: 'Posts',
  },
  NET_NEW_FOLLOWERS: {
    value: 'NET_NEW_FOLLOWERS',
    text: 'Net New Followers',
  },
  VIDEO_VIEWS: {
    value: 'VIDEO_VIEWS',
    text: 'Video Views',
  },
  TOTAL_VIDEO_VIEWS: {
    value: 'TOTAL_VIDEO_VIEWS',
    text: 'Video Views',
  },
  VIEWS_ONLY_VIDEOS: {
    value: 'VIEWS_ONLY_VIDEOS',
    text: 'Video Views',
  },
  IMPRESSIONS: {
    value: 'IMPRESSIONS',
    text: 'Impressions',
  },
  Views: {
    value: 'VIEWS',
    text: 'Views',
  },
  LINK_CLICKS: {
    value: 'LINK_CLICKS',
    text: 'Link Clicks',
  },
  SUBSCRIBERS_GAINED: {
    value: 'SUBSCRIBERS_GAINED',
    text: 'Subscribers Gained',
  },
  SUBSCRIBERS_LOST: {
    value: 'SUBSCRIBERS_LOST',
    text: 'Subscribers Lost',
  },
};

export const postsDefaultSortOption = 'CROSS_CHANNEL_ENGAGEMENT_RATE';

export const campaignRouteNames = /** @type {const} */ Object.freeze({
  CAMPAIGNS: 'campaigns',
  CAMPAIGNS_CREATE: 'campaigns.create',
  CAMPAIGN_DETAIL: 'campaigns.detail',
  CAMPAIGN_DETAIL_EDIT: 'campaigns.detail.edit',
  CAMPAIGN_DETAIL_DELETE: 'campaigns.detail.delete',
  CAMPAIGN_DETAIL_OVERVIEW: 'campaigns.detail.overview',
  CAMPAIGN_DETAIL_OWNED_SUMMARY: 'campaigns.detail.owned-summary',
  CAMPAIGN_DETAIL_SOCIAL_ADS_SUMMARY: 'campaigns.detail.social-ads-summary',
  CAMPAIGN_DETAIL_CREATOR_SUMMARY: 'campaigns.detail.creator-summary',
  CAMPAIGN_DETAIL_TIKTOK: 'campaigns.detail.tiktok',
  CAMPAIGN_DETAIL_INSTAGRAM: 'campaigns.detail.instagram',
  CAMPAIGN_DETAIL_INSTAGRAM_STORIES: 'campaigns.detail.instagram-stories',
  CAMPAIGN_DETAIL_FACEBOOK: 'campaigns.detail.facebook',
  CAMPAIGN_DETAIL_PINTEREST: 'campaigns.detail.pinterest',
  CAMPAIGN_DETAIL_TWITTER: 'campaigns.detail.twitter',
  CAMPAIGN_DETAIL_YOUTUBE: 'campaigns.detail.youtube',
  CAMPAIGN_DETAIL_ECOMM: 'campaigns.detail.ecomm',
  CAMPAIGN_DETAIL_GOOGLE_ANALYTICS: 'campaigns.detail.google-analytics',
  CAMPAIGN_DETAIL_RELATIONSHIPS: 'campaigns.detail.relationships',
  CAMPAIGN_DETAIL_UGC: 'campaigns.detail.ugc',
  CAMPAIGN_DETAIL_META_ADS: 'campaigns.detail.meta-ads',
  CAMPAIGN_DETAIL_TIKTOK_ADS: 'campaigns.detail.tiktok-ads',
  CAMPAIGN_DETAIL_CREATOR_INSIGHTS: 'campaigns.detail.creator-insights',
  CAMPAIGN_DETAIL_CREATOR_DELIVERABLES: 'campaigns.detail.creator-deliverables',
  CAMPAIGN_DETAIL_REPORT: 'campaigns.detail.report',
  CAMPAIGN_DETAIL_OVERVIEW_REPORT: 'campaigns.detail.overview.report',
  CAMPAIGN_DETAIL_OWNED_SUMMARY_REPORT: 'campaigns.detail.owned-summary.report',
  CAMPAIGN_DETAIL_SOCIAL_ADS_SUMMARY_REPORT: 'campaigns.detail.social-ads-summary.report',
  CAMPAIGN_DETAIL_CREATOR_SUMMARY_REPORT: 'campaigns.detail.creator-summary.report',
  CAMPAIGN_DETAIL_TIKTOK_REPORT: 'campaigns.detail.tiktok.report',
  CAMPAIGN_DETAIL_INSTAGRAM_REPORT: 'campaigns.detail.instagram.report',
  CAMPAIGN_DETAIL_INSTAGRAM_STORIES_REPORT: 'campaigns.detail.instagram-stories.report',
  CAMPAIGN_DETAIL_FACEBOOK_REPORT: 'campaigns.detail.facebook.report',
  CAMPAIGN_DETAIL_PINTEREST_REPORT: 'campaigns.detail.pinterest.report',
  CAMPAIGN_DETAIL_TWITTER_REPORT: 'campaigns.detail.twitter.report',
  CAMPAIGN_DETAIL_YOUTUBE_REPORT: 'campaigns.detail.youtube.report',
  CAMPAIGN_DETAIL_ECOMM_REPORT: 'campaigns.detail.ecomm.report',
  CAMPAIGN_DETAIL_GOOGLE_ANALYTICS_REPORT: 'campaigns.detail.google-analytics.report',
  CAMPAIGN_DETAIL_RELATIONSHIPS_REPORT: 'campaigns.detail.relationships.report',
  CAMPAIGN_DETAIL_UGC_REPORT: 'campaigns.detail.ugc.report',
  CAMPAIGN_DETAIL_META_ADS_REPORT: 'campaigns.detail.meta-ads.report',
  CAMPAIGN_DETAIL_TIKTOK_ADS_REPORT: 'campaigns.detail.tiktok-ads.report',
  CAMPAIGN_DETAIL_CREATOR_INSIGHTS_REPORT: 'campaigns.detail.creator-insights.report',
  CAMPAIGN_DETAIL_CREATOR_DELIVERABLES_REPORT: 'campaigns.detail.creator-deliverables.report',
  CAMPAIGN_DETAIL_ALL_TABS_REPORT: 'campaigns.detail.all.report',
});

export const AD_SOURCE_TO_ROUTE_NAME = {
  [AD_SOURCES.META_ADS]: campaignRouteNames.CAMPAIGN_DETAIL_META_ADS,
  [AD_SOURCES.TIKTOK_ADS]: campaignRouteNames.CAMPAIGN_DETAIL_TIKTOK_ADS,
};

export const CAMPAIGN_TAB_TYPES = Object.freeze({
  OWNED: 'OWNED',
  CREATORS: 'CREATORS',
  ADS: 'ADS',
  ANALYTICS: 'ANALYTICS',
  OTHER: 'OTHER',
});

export const CAMPAIGN_TABS = Object.freeze({
  OWNED_SUMMARY: 'owned-summary',
  SOCIAL_ADS_SUMMARY: 'social-ads-summary',
  CREATOR_SUMMARY: 'creator-summary',
  CREATOR_DELIVERABLES: 'creator-deliverables',
  TIKTOK: 'tiktok',
  INSTAGRAM: 'instagram',
  INSTAGRAM_STORIES: 'instagram-stories',
  FACEBOOK: 'facebook',
  PINTEREST: 'pinterest',
  TWITTER: 'twitter',
  YOUTUBE: 'youtube',
  RELATIONSHIPS: 'relationships',
  UGC: 'ugc',
  META_ADS: 'meta-ads',
  TIKTOK_ADS: 'tiktok-ads',
  GOOGLE_ANALYTICS: 'google-analytics',
  ALL: 'all',
});

export const CAMPAIGN_TAB_CONFIG = Object.freeze({
  [CAMPAIGN_TABS.OWNED_SUMMARY]: {
    label: 'Owned Summary',
    type: CAMPAIGN_TAB_TYPES.OWNED,
    showScalePicker: false,
    showEmptyState: true,
    link: campaignRouteNames.CAMPAIGN_DETAIL_OWNED_SUMMARY,
    reportLink: campaignRouteNames.CAMPAIGN_DETAIL_OWNED_SUMMARY_REPORT,
  },
  [CAMPAIGN_TABS.SOCIAL_ADS_SUMMARY]: {
    label: 'Social Ads Summary',
    type: CAMPAIGN_TAB_TYPES.ADS,
    showScalePicker: false,
    showEmptyState: false,
    link: campaignRouteNames.CAMPAIGN_DETAIL_SOCIAL_ADS_SUMMARY,
    reportLink: campaignRouteNames.CAMPAIGN_DETAIL_SOCIAL_ADS_SUMMARY_REPORT,
  },
  [CAMPAIGN_TABS.CREATOR_SUMMARY]: {
    label: 'Creator Summary',
    type: CAMPAIGN_TAB_TYPES.CREATORS,
    showScalePicker: false,
    showEmptyState: false,
    link: campaignRouteNames.CAMPAIGN_DETAIL_CREATOR_SUMMARY,
    reportLink: campaignRouteNames.CAMPAIGN_DETAIL_CREATOR_SUMMARY_REPORT,
  },
  [CAMPAIGN_TABS.CREATOR_DELIVERABLES]: {
    label: 'Creator Deliverables',
    type: CAMPAIGN_TAB_TYPES.CREATORS,
    showScalePicker: false,
    showEmptyState: false,
    link: campaignRouteNames.CAMPAIGN_DETAIL_CREATOR_DELIVERABLES,
    reportLink: campaignRouteNames.CAMPAIGN_DETAIL_CREATOR_DELIVERABLES_REPORT,
  },
  [CAMPAIGN_TABS.TIKTOK]: {
    label: 'TikTok',
    type: CAMPAIGN_TAB_TYPES.OWNED,
    showScalePicker: true,
    showEmptyState: true,
    link: campaignRouteNames.CAMPAIGN_DETAIL_TIKTOK,
    reportLink: campaignRouteNames.CAMPAIGN_DETAIL_TIKTOK_REPORT,
  },
  [CAMPAIGN_TABS.INSTAGRAM]: {
    label: 'Instagram',
    type: CAMPAIGN_TAB_TYPES.OWNED,
    showScalePicker: true,
    showEmptyState: true,
    link: campaignRouteNames.CAMPAIGN_DETAIL_INSTAGRAM,
    reportLink: campaignRouteNames.CAMPAIGN_DETAIL_INSTAGRAM_REPORT,
  },
  [CAMPAIGN_TABS.INSTAGRAM_STORIES]: {
    label: 'Instagram Stories',
    type: CAMPAIGN_TAB_TYPES.OWNED,
    showScalePicker: true,
    showEmptyState: true,
    link: campaignRouteNames.CAMPAIGN_DETAIL_INSTAGRAM_STORIES,
    reportLink: campaignRouteNames.CAMPAIGN_DETAIL_INSTAGRAM_STORIES_REPORT,
  },
  [CAMPAIGN_TABS.FACEBOOK]: {
    label: 'Facebook',
    type: CAMPAIGN_TAB_TYPES.OWNED,
    showScalePicker: true,
    showEmptyState: true,
    link: campaignRouteNames.CAMPAIGN_DETAIL_FACEBOOK,
    reportLink: campaignRouteNames.CAMPAIGN_DETAIL_FACEBOOK_REPORT,
  },
  [CAMPAIGN_TABS.PINTEREST]: {
    label: 'Pinterest',
    type: CAMPAIGN_TAB_TYPES.OWNED,
    showScalePicker: true,
    showEmptyState: true,
    link: campaignRouteNames.CAMPAIGN_DETAIL_PINTEREST,
    reportLink: campaignRouteNames.CAMPAIGN_DETAIL_PINTEREST_REPORT,
  },
  [CAMPAIGN_TABS.TWITTER]: {
    label: 'X',
    type: CAMPAIGN_TAB_TYPES.OWNED,
    showScalePicker: true,
    showEmptyState: true,
    link: campaignRouteNames.CAMPAIGN_DETAIL_TWITTER,
    reportLink: campaignRouteNames.CAMPAIGN_DETAIL_TWITTER_REPORT,
  },
  [CAMPAIGN_TABS.YOUTUBE]: {
    label: 'YouTube',
    type: CAMPAIGN_TAB_TYPES.OWNED,
    showScalePicker: true,
    showEmptyState: true,
    link: campaignRouteNames.CAMPAIGN_DETAIL_YOUTUBE,
    reportLink: campaignRouteNames.CAMPAIGN_DETAIL_YOUTUBE_REPORT,
  },
  [CAMPAIGN_TABS.RELATIONSHIPS]: {
    label: 'Relationships',
    type: CAMPAIGN_TAB_TYPES.OTHER,
    showScalePicker: false,
    showEmptyState: false,
    link: campaignRouteNames.CAMPAIGN_DETAIL_RELATIONSHIPS,
    reportLink: campaignRouteNames.CAMPAIGN_DETAIL_RELATIONSHIPS_REPORT,
  },
  [CAMPAIGN_TABS.UGC]: {
    label: 'Instagram UGC',
    type: CAMPAIGN_TAB_TYPES.OTHER,
    showScalePicker: false,
    showEmptyState: false,
    link: campaignRouteNames.CAMPAIGN_DETAIL_UGC,
    reportLink: campaignRouteNames.CAMPAIGN_DETAIL_UGC_REPORT,
  },
  [CAMPAIGN_TABS.META_ADS]: {
    label: 'Meta Ads',
    type: CAMPAIGN_TAB_TYPES.ADS,
    showScalePicker: true,
    showEmptyState: false,
    link: campaignRouteNames.CAMPAIGN_DETAIL_META_ADS,
    reportLink: campaignRouteNames.CAMPAIGN_DETAIL_META_ADS_REPORT,
  },
  [CAMPAIGN_TABS.TIKTOK_ADS]: {
    label: 'TikTok Ads',
    type: CAMPAIGN_TAB_TYPES.ADS,
    showScalePicker: true,
    showEmptyState: false,
    link: campaignRouteNames.CAMPAIGN_DETAIL_TIKTOK_ADS,
    reportLink: campaignRouteNames.CAMPAIGN_DETAIL_TIKTOK_ADS_REPORT,
  },
  [CAMPAIGN_TABS.GOOGLE_ANALYTICS]: {
    label: 'Google Analytics',
    type: CAMPAIGN_TAB_TYPES.ANALYTICS,
    showScalePicker: false,
    showEmptyState: false,
    link: campaignRouteNames.CAMPAIGN_DETAIL_GOOGLE_ANALYTICS,
    reportLink: campaignRouteNames.CAMPAIGN_DETAIL_GOOGLE_ANALYTICS_REPORT,
  },
  [CAMPAIGN_TABS.ALL]: {
    showEmptyState: false,
  },
});

export const CAMPAIGN_TAB_CATEGORIES = Object.freeze({
  OWNED: 'OWNED',
  CREATORS: 'CREATORS',
  ADS: 'ADS',
});

export const CAMPAIGN_TAB_CATEGORY_LABELS = Object.freeze({
  [CAMPAIGN_TAB_CATEGORIES.OWNED]: 'Owned Channels',
  [CAMPAIGN_TAB_CATEGORIES.CREATORS]: 'Creator Channels',
  [CAMPAIGN_TAB_CATEGORIES.ADS]: 'Social Advertising Channels',
});

export const mixpanelEventProperties = Object.freeze({
  reportTypes: {
    keyword: 'Keyword',
    sentiment: 'Sentiment',
    channel: 'Channel',
  },
  interactionType: {
    labelClicked: 'Label Clicked',
    keywordClicked: 'Keyword Clicked',
    keywordCheckboxUpdated: 'Keyword Checkbox Updated',
  },
  metricTypes: {
    sentiment: 'Campaign sentiment',
  },
});

export const NO_DATA_TOP_KEYWORDS_ERROR_MESSAGE =
  'No top keywords found during this reporting period';

export const CAMPAIGN_TOP_KEYWORDS_TOOLTIP =
  'The top keywords used in the comments on owned posts in this Campaign';

export const CAMPAIGN_SENTIMENT_CHANNEL_DISTRIBUTION_TOOLTIP =
  'The channel and sentiment breakdown of comments on owned posts in this Campaign';

export const CAMPAIGN_SENTIMENT_BAR_CHART_CONFIG = {
  positive: {
    label: 'Positive',
    backgroundColor: colours.SUCCESS.SUCCESS_500,
    order: 1,
  },
  neutral: {
    label: 'Neutral',
    backgroundColor: colours.ACTION.ACTION_500,
    order: 2,
  },
  negative: {
    label: 'Negative',
    backgroundColor: colours.ERROR.ERROR_500,
    order: 3,
  },
};

export const CAMPAIGN_SENTIMENT_CHANNEL_DISTRIBUTION_PLATFORMS = [
  CHANNELS.TIKTOK,
  CHANNELS.INSTAGRAM,
  CHANNELS.FACEBOOK,
  CHANNELS.TWITTER,
  CHANNELS.YOUTUBE,
];

export const FAILED_TO_LOAD_CAMPAIGN_SENTIMENT_ERROR_MESSAGE =
  'Data failed to load. Refresh the page to try again';

export const CAMPAIGN_SENTIMENT_OVERVIEW_NO_DATA_MESSAGE =
  'No data found during this reporting period';

export const CAMPAIGN_PLATFORM_LABELS = {
  [CHANNELS.TIKTOK]: 'TikTok',
  [CHANNELS.INSTAGRAM]: 'Instagram',
  [CHANNELS.FACEBOOK]: 'Facebook',
  [CHANNELS.TWITTER]: 'X',
  [CHANNELS.YOUTUBE]: 'YouTube',
  [CHANNELS.PINTEREST]: 'Pinterest',
  [CHANNELS.INSTAGRAM_STORY]: 'Instagram Story',
  [CHANNELS.RELATIONSHIPS]: 'Relationships',
  [CHANNELS.UGC]: 'UGC',
  [AD_SOURCES.META_ADS]: 'Meta Ads',
  [AD_SOURCES.TIKTOK_ADS]: 'TikTok Ads',
  [DATA_SOURCES.INSTAGRAM_CREATORS]: 'Instagram Creators',
  [DATA_SOURCES.TIKTOK_CREATORS]: 'TikTok Creators',
  INSTAGRAM_UGC: 'Instagram UGC',
  INSTAGRAM_STORY_UGC: 'Instagram Story UGC',
  LIKESHOP: 'Instagram LikeShop',
  TIKTOK_LIKESHOP: 'TikTok LikeShop',
};

export const DOTTED_STATS_UP_TO = 1;

export const campaignCreatorStatusOptions = [
  { label: 'New', value: 'NEW', severity: 'statusNeutral' },
  { label: 'Contacted', value: 'CONTACTED', severity: 'statusNeutral' },
  { label: 'Agreement Sent', value: 'AGREEMENT_SENT', severity: 'info' },
  { label: 'Brief Sent', value: 'BRIEF_SENT', severity: 'info' },
  { label: 'Product Shipped', value: 'PRODUCT_SHIPPED', severity: 'info' },
  { label: 'In Progress', value: 'IN_PROGRESS', severity: 'info' },
  { label: 'Payment Initiated', value: 'PAYMENT_INITIATED', severity: 'info' },
  { label: 'Paid', value: 'PAID', severity: 'info' },
  { label: 'Creative Approved', value: 'CREATIVE_APPROVED', severity: 'info' },
  { label: 'Complete', value: 'COMPLETE', severity: 'success' },
  { label: 'Declined', value: 'DECLINED', severity: 'negative' },
];

export const limitedCampaignCreatorStatusOptions = [
  { label: 'New', value: 'NEW', severity: 'statusNeutral' },
  { label: 'Contacted', value: 'CONTACTED', severity: 'statusNeutral' },
  { label: 'Product Shipped', value: 'PRODUCT_SHIPPED', severity: 'info' },
  { label: 'Complete', value: 'COMPLETE', severity: 'success' },
  { label: 'Declined', value: 'DECLINED', severity: 'negative' },
];

export const campaignCreatorPostTypeOptions = [
  { label: 'TikTok Videos', value: 'TIKTOK_VIDEO', icon: 'tiktok-color' },
  { label: 'Instagram Feed', value: 'INSTAGRAM_FEED', icon: 'instagram-color' },
  { label: 'Instagram Reels', value: 'INSTAGRAM_REELS', icon: 'instagram-reel-color' },
  { label: 'Instagram Stories', value: 'INSTAGRAM_STORIES', icon: 'instagram-story-color' },
  { label: 'YouTube Videos', value: 'YOUTUBE_VIDEO', icon: 'youtube-color' },
  { label: 'YouTube Shorts', value: 'YOUTUBE_SHORT', icon: 'youtube-short-color' },
];

export const campaignCreatorChannelOptions = [
  { label: 'TikTok', value: 'TIKTOK', icon: 'tiktok-color' },
  { label: 'Instagram', value: 'INSTAGRAM', icon: 'instagram-color' },
  { label: 'YouTube', value: 'YOUTUBE', icon: 'youtube-color' },
];

export const campaignCreatorDeliverableFilterDetails = {
  scope: 'creatorDeliverables',
  options: {
    channel: campaignCreatorChannelOptions,
    postType: campaignCreatorPostTypeOptions,
    status: campaignCreatorStatusOptions,
  },
  default: {
    channel: [],
    postType: [],
    tags: [],
    status: [],
  },
};

export const campaignCreatorDeliverableTopLineStats = [
  {
    title: 'Creators',
    value: 'totalCreators',
    format: 'number',
    type: 'Total',
    tooltip: 'The total number of creators added to this Campaign, including gifted and paid',
  },
  {
    title: 'Deliverables',
    value: 'totalDeliverables',
    format: 'number',
    type: 'Total',
    tooltip: 'The total number of expected creator posts as part of this Campaign',
  },
  {
    title: 'Gifted',
    value: 'totalGifted',
    format: 'number',
    type: 'Total',
    tooltip:
      'The total number of unique creators that were gifted product as part of this Campaign',
  },
  {
    title: 'Posts',
    value: 'totalPosts',
    format: 'number',
    type: 'Total',
    tooltip: 'The total number of published posts by creators as part of this Campaign',
  },
  {
    title: 'Completion',
    value: 'completion',
    format: 'percent',
    type: 'Average',
    tooltip:
      'The percentage of creators who have fulfilled their deliverables or have been marked as complete',
  },
];

export const campaignCreatorInsightsTopLineStats = [
  {
    title: 'Number of Posts',
    value: 'totalPosts',
    metric: 'total_posts',
    format: 'abbr',
    breakdownFormat: 'number',
    tooltip: 'The number of posts in this Campaign by all added creators',
    postType: 'ORGANIC',
    metricTimeFrame: 'POSTS_THIS_PERIOD',
  },
  {
    title: 'EMV',
    value: 'emvViews',
    metric: 'emv_views',
    format: 'currency',
    formatOptions: { style: 'currency', currency: 'USD', maximumFractionDigits: 0 },
    breakdownFormat: 'currency',
    breakdownFormatOptions: { maximumFractionDigits: 0 },
    tooltip:
      'The earned media value of all posts in this Campaign.' +
      '\n\n' +
      'EMV is calculated by factoring in the channel, audience size, content type, engagement and current market values for comparable posts.',
    postType: 'ORGANIC',
    metricTimeFrame: 'POSTS_THIS_PERIOD',
    sourceBreakdowns: [
      {
        source: 'INSTAGRAM',
        value: 'emvViews',
        metric: 'emv_views',
      },
      {
        source: 'TIKTOK',
        value: 'emv',
        metric: 'emv',
      },
      {
        source: 'YOUTUBE',
        value: 'emv',
        metric: 'emv',
      },
    ],
  },
  {
    title: 'Avg. EMV',
    value: 'avgEmvViews',
    metric: 'avg_emv_views',
    format: 'currency',
    formatOptions: { style: 'currency', currency: 'USD', maximumFractionDigits: 0 },
    breakdownFormat: 'currency',
    breakdownFormatOptions: { maximumFractionDigits: 0 },
    tooltip:
      'The average earned media value per post in this Campaign.' +
      '\n\n' +
      'EMV is calculated by factoring in the channel, audience size, content type, engagement and current market values for comparable posts.',
    postType: 'ORGANIC',
    metricTimeFrame: 'POSTS_THIS_PERIOD',
    sourceBreakdowns: [
      {
        source: 'INSTAGRAM',
        value: 'avgEmvViews',
        metric: 'avg_emv_views',
      },
      {
        source: 'TIKTOK',
        value: 'avgEmv',
        metric: 'avg_emv',
      },
      {
        source: 'YOUTUBE',
        value: 'avgEmv',
        metric: 'avg_emv',
      },
    ],
  },
  {
    title: 'Likes',
    value: 'likes',
    metric: 'likes',
    format: 'abbr',
    breakdownFormat: 'number',
    tooltip: 'The number of likes across all applicable creator posts in this Campaign',
    postType: 'ORGANIC',
    metricTimeFrame: 'POSTS_THIS_PERIOD',
  },
  {
    title: 'Comments',
    value: 'comments',
    metric: 'comments',
    format: 'abbr',
    breakdownFormat: 'number',
    tooltip: 'The number of comments on all applicable creator posts in this Campaign',
    postType: 'ORGANIC',
    metricTimeFrame: 'POSTS_THIS_PERIOD',
  },
  {
    title: 'Avg. Engagements',
    value: 'avgEngagements',
    metric: 'avg_engagements',
    format: 'abbr',
    breakdownFormat: 'number',
    tooltip: {
      content: 'The average engagements per creator post in this Campaign',
      footer:
        'Instagram Engagements = Likes + Comments + (Saves + Shares + Reposts if connected)\n\nTikTok Engagements = Likes + Comments + Shares\n\nYouTube Engagements = Likes + Comments',
    },
    postType: 'ORGANIC',
    metricTimeFrame: 'POSTS_THIS_PERIOD',
    sourceBreakdowns: [
      {
        source: 'INSTAGRAM',
        tooltip: {
          footer:
            'Avg. Engagements = Likes + Comments + (Saves + Shares + Reposts if connected) / Number of Posts',
        },
      },
      {
        source: 'TIKTOK',
        tooltip: {
          footer: 'Avg. Engagements = (Likes + Comments + Shares) / Number of Posts',
        },
      },
      {
        source: 'YOUTUBE',
        tooltip: {
          footer: 'Avg. Engagements = (Likes + Comments) / Number of Posts',
        },
      },
    ],
  },
  {
    title: 'Avg. Engagement Rate',
    value: 'avgEngagementRate',
    metric: 'avg_engagement_rate',
    format: 'percent',
    formatOptions: {
      style: 'percent',
      maximumFractionDigits: 2,
      minimumFractionDigits: 2,
    },
    breakdownFormat: 'percent',
    breakdownFormatOptions: { maximumFractionDigits: 2, minimumFractionDigits: 2 },
    tooltip: {
      content: 'The average engagement rate per creator post in this Campaign',
      footer:
        'Instagram Engagement Rate = (Likes + Comments) / Followers\n\nTikTok Engagement Rate = (Likes + Comments + Shares) / Video Views\n\nYouTube Engagement Rate = (Likes + Comments) / Views',
    },
    postType: 'ORGANIC',
    metricTimeFrame: 'POSTS_THIS_PERIOD',
    sourceBreakdowns: [
      {
        source: 'INSTAGRAM',
        tooltip: {
          footer: 'Avg. Engagement Rate = (Engagements / Followers) / Number of Posts',
        },
      },
      {
        source: 'TIKTOK',
        tooltip: {
          footer: 'Avg. Engagement Rate = (Engagements / Video Views) / Number of Posts',
        },
      },
      {
        source: 'YOUTUBE',
        tooltip: {
          footer: 'Avg. Engagement Rate = (Engagements / Video Views) / Number of Posts',
        },
      },
    ],
  },
  {
    title: 'Creator Followers',
    value: 'audienceSize',
    metric: 'audience_size',
    format: 'abbr',
    breakdownFormat: 'number',
    tooltip:
      'The follower count of creators added to this Campaign across all channels. Use this metric to gauge the potential reach of your Campaign.',
    postType: 'ORGANIC',
    metricTimeFrame: 'POSTS_THIS_PERIOD',
    sourceBreakdowns: [
      {
        source: 'INSTAGRAM',
        label: 'Followers',
      },
      {
        source: 'TIKTOK',
        label: 'Followers',
      },
      {
        source: 'YOUTUBE',
        label: 'Subscribers',
      },
    ],
  },
];
export const campaignCreatorGoalsStats = campaignCreatorInsightsTopLineStats.filter(
  ({ value }) => !['audienceSize'].includes(value),
);

export const CREATOR_SOURCE_TO_CAMPAIGN_STATS_KEY = {
  INSTAGRAM: 'instagramFeedStats',
  INSTAGRAM_STORY: 'instagramStoryStats',
  TIKTOK: 'tiktokStats',
  YOUTUBE: 'youtubeStats',
};

export const campaignCreatorInsightsInstagramChannelStats = [
  {
    label: 'Creators',
    value: 'totalCreators',
    formatType: 'formatIntegerAbbreviated',
    tooltip:
      'The total number of creators added into the campaign that have an Instagram handle added to their profile',
  },
  {
    label: 'Creator Followers',
    value: 'audienceSize',
    formatType: 'formatIntegerAbbreviated',
    tooltip:
      'The follower count of creators added to this campaign for Instagram. Use this metric to gauge the potential reach of your campaign.',
  },
  {
    label: 'EMV',
    value: 'emvViews',
    formatType: 'formatCurrency',
    tooltip:
      'The total earned media value for all Instagram posts in this campaign.' +
      '\n\n' +
      'EMV is calculated by factoring in the channel, audience size, content type, engagement and current market values for comparable posts.',
  },
  {
    label: 'Avg. EMV',
    value: 'avgEmvViews',
    formatType: 'formatCurrency',
    tooltip:
      'The average earned media value per Instagram post in this campaign.' +
      '\n\n' +
      'EMV is calculated by factoring in the channel, audience size, content type, engagement and current market values for comparable posts.',
  },
  {
    label: 'Engagements',
    value: 'engagements',
    formatType: 'formatIntegerAbbreviated',
    tooltip: {
      content: 'The total engagements across all creator Instagram posts in this campaign',
      footer: 'Instagram Engagements = Likes + Comments + (Saves + Shares + Reposts if connected)',
    },
  },
  {
    label: 'Avg. Engagements',
    value: 'avgEngagements',
    formatType: 'formatIntegerAbbreviated',
    tooltip: {
      content: 'The average engagements per creator Instagram post in this campaign',
      footer: 'Instagram Engagements = Likes + Comments + (Saves + Shares + Reposts if connected)',
    },
  },
  {
    label: 'Avg. Engagement Rate',
    value: 'avgEngagementRate',
    formatType: 'formatPercentage',
    formatOptions: { maximumFractionDigits: 2 },
    tooltip: {
      content: 'The average engagement rate per creator Instagram post in this campaign',
      footer: 'Instagram Engagement Rate = (Likes + Comments) / Followers',
    },
  },
  {
    label: 'Views - Connected',
    value: 'viewsV2',
    formatType: 'formatIntegerAbbreviated',
    tooltip:
      "The number of times connected creators' campaign content (Reels, Stories, and Posts) was displayed on a person's screen or played/replayed for at least 1 ms, including repeat views. Data is only available for posts after the connection date.",
  },
  {
    label: 'Avg. Views - Connected',
    value: 'avgViewsV2',
    formatType: 'formatIntegerAbbreviated',
    tooltip:
      "The average number of times connected creators' campaign content (Reels, Stories, and Posts) was displayed on a person's screen or played/replayed for at least 1 ms, including repeat views. Data is only available for posts after the connection date.",
  },
  {
    label: 'Reel Views',
    value: 'reelViews',
    formatType: 'formatIntegerAbbreviated',
    tooltip:
      "The number of times any creators' Reels in this campaign were played or replayed for at least 1 ms. Replays are counted after the first play within the same video session. Includes organic and paid views.",
  },
  {
    label: 'Avg. Est. Reach',
    value: 'avgReach',
    formatType: 'formatIntegerAbbreviated',
    tooltip:
      'The average reach per creator Instagram post in this campaign. For accounts that are not connected, reach is estimated.',
  },
];

export const campaignCreatorInsightsInstagramChannelStatsExpanded = [
  {
    label: 'Avg. Effectiveness',
    value: 'avgEffectivenessEngagements',
    formatType: 'formatPercentage',
    formatOptions: { maximumFractionDigits: 2 },
    tooltip: {
      content:
        'The average Effectiveness per creator post in this campaign. For accounts that are not connected, reach is estimated.',
      footer:
        'Effectiveness (Posts / Reels) = Likes + Comments (+ Saves + Shares + Reposts if connected) / Reach',
    },
  },
  {
    label: 'Followers Gained',
    value: 'followersGained',
    formatType: 'formatIntegerAbbreviated',
    tooltip:
      'The estimated number of followers that creators in this campaign have gained for you by tagging or mentioning your account in their posts',
  },
  {
    label: 'Stories - Avg. Completion Rate',
    value: 'storyAvgCompletionRateViews',
    formatType: 'formatPercentage',
    formatOptions: { maximumFractionDigits: 2 },
    tooltip: {
      content: "The average completion rate of creators' Stories in this campaign",
      footer: 'Completion Rate = (Views - Exits) / Views',
    },
  },
  {
    label: 'Stories - Avg. Reach',
    formatType: 'formatIntegerAbbreviated',
    value: 'storyAvgReach',
    tooltip: 'The average number of unique accounts reached per story by creators in this campaign',
  },
  {
    label: 'Stories - Avg. Views',
    formatType: 'formatIntegerAbbreviated',
    value: 'storyAvgViews',
    tooltip: 'The average number of views per creator Instagram Story in this campaign',
  },
];

export const campaignCreatorInsightsTikTokChannelStats = [
  {
    label: 'Creators',
    value: 'totalCreators',
    formatType: 'formatIntegerAbbreviated',
    tooltip:
      'The total number of creators added into the campaign that have an TikTok handle added to their profile',
  },
  {
    label: 'Creator Followers',
    value: 'audienceSize',
    formatType: 'formatIntegerAbbreviated',
    tooltip:
      'The follower count of creators added to this campaign for TikTok. Use this metric to gauge the potential reach of your campaign.',
  },
  {
    label: 'EMV',
    value: 'emv',
    formatType: 'formatCurrency',
    tooltip:
      'The earned media value of all TikTok posts in this campaign.' +
      '\n\n' +
      'EMV is calculated by factoring in the channel, audience size, content type, engagement and current market values for comparable posts.',
  },
  {
    label: 'Avg. EMV',
    value: 'avgEmv',
    formatType: 'formatCurrency',
    tooltip:
      'The average earned media value per TikTok post in this campaign.' +
      '\n\n' +
      'EMV is calculated by factoring in the channel, audience size, content type, engagement and current market values for comparable posts.',
  },
  {
    label: 'Engagements',
    value: 'engagements',
    formatType: 'formatIntegerAbbreviated',
    tooltip: {
      content: 'The total engagements across all creator TikTok posts in this campaign',
      footer: 'TikTok Engagements = Likes + Comments + Shares',
    },
  },
  {
    label: 'Avg. Engagements',
    value: 'avgEngagements',
    formatType: 'formatIntegerAbbreviated',
    tooltip: {
      content: 'The average engagements per creator TikTok post in this campaign',
      footer: 'TikTok Engagements = Likes + Comments + Shares',
    },
  },
  {
    label: 'Avg. Engagement Rate',
    value: 'avgEngagementRate',
    formatType: 'formatPercentage',
    formatOptions: { maximumFractionDigits: 2 },
    tooltip: {
      content: 'The average engagement rate per creator TikTok post in this campaign',
      footer: 'TikTok Engagement Rate = (Likes + Comments + Shares) / Video Views',
    },
  },
  {
    label: 'Video Views',
    value: 'videoViews',
    formatType: 'formatIntegerAbbreviated',
    tooltip: 'The number of video views across all creator TikTok posts in this campaign',
  },
  {
    label: 'Avg. Video Views',
    value: 'avgVideoViews',
    formatType: 'formatIntegerAbbreviated',
    tooltip: 'The average number of video views per creator TikTok post in this campaign',
  },
  {
    label: 'Shares',
    value: 'shares',
    formatType: 'formatIntegerAbbreviated',
    tooltip: 'The total shares across all creator TikTok posts in this campaign',
  },
];

export const creatorInsightPostSortOptions = {
  DEFAULT: {
    sortOrder: 'DESC',
    selected: { value: 'DATE', label: 'Recently Published' },
  },
  ALL_CHANNELS: [
    {
      value: 'DATE',
      label: 'Recently Published',
    },
    {
      value: 'CROSS_CHANNEL_EMV',
      label: 'EMV',
    },
  ],
  TIKTOK: [
    {
      value: 'DATE',
      label: 'Recently Published',
    },
    {
      value: 'TIKTOK_TOTAL_ENGAGEMENTS',
      label: 'Engagements',
    },
    {
      value: 'TIKTOK_ENGAGEMENT_RATE',
      label: 'Engagement Rate',
    },
    {
      value: 'CROSS_CHANNEL_EMV',
      label: 'EMV',
    },
    {
      value: 'TIKTOK_REACH',
      label: 'Reach',
    },
    {
      value: 'TIKTOK_SHARES',
      label: 'Shares',
    },
    {
      value: 'TIKTOK_VIEWS',
      label: 'Video Views',
    },
  ],
  INSTAGRAM: [
    {
      value: 'DATE',
      label: 'Recently Published',
    },
    {
      value: 'CROSS_CHANNEL_EMV',
      label: 'EMV',
    },
    {
      value: 'CROSS_CHANNEL_IMPRESSIONS',
      label: 'Impressions',
    },
  ],
  INSTAGRAM_FEED: [
    {
      value: 'DATE',
      label: 'Recently Published',
    },
    {
      value: 'INSTAGRAM_EFFECTIVENESS',
      label: 'Effectiveness',
    },
    {
      value: 'INSTAGRAM_ENGAGEMENT_RATE',
      label: 'Engagement Rate',
    },
    {
      value: 'INSTAGRAM_TOTAL_ENGAGEMENTS',
      label: 'Engagements',
    },
    {
      value: 'INSTAGRAM_REACH',
      label: 'Reach',
    },
    {
      value: 'INSTAGRAM_EMV',
      label: 'EMV',
    },
    {
      value: 'INSTAGRAM_FOLLOWERS_GAINED',
      label: 'Followers Gained',
    },
    {
      value: 'INSTAGRAM_TOTAL_IMPRESSIONS',
      label: 'Impressions',
    },
  ],
  INSTAGRAM_STORY: [
    {
      value: 'DATE',
      label: 'Recently Published',
    },
    {
      value: 'INSTAGRAM_STORY_FRAME_COMPLETION_RATE',
      label: 'Completion Rate',
    },
    {
      value: 'EMV',
      label: 'EMV',
    },
    {
      value: 'INSTAGRAM_STORY_FRAME_EXIT_RATE',
      label: 'Exit Rate',
    },
    {
      value: 'INSTAGRAM_STORY_FRAME_IMPRESSIONS',
      label: 'Impressions',
    },
  ],
  YOUTUBE: [
    {
      value: 'DATE',
      label: 'Recently Published',
    },
    {
      value: 'CROSS_CHANNEL_ENGAGEMENT_RATE',
      label: 'Engagement Rate',
    },
    {
      value: 'YOUTUBE_ENGAGEMENTS',
      label: 'Engagements',
    },
    {
      value: 'YOUTUBE_VIEWS',
      label: 'Views',
    },
    {
      value: 'YOUTUBE_LIKES',
      label: 'Likes',
    },
    {
      value: 'YOUTUBE_COMMENTS',
      label: 'Comments',
    },
    {
      value: 'CROSS_CHANNEL_EMV',
      label: 'EMV',
    },
  ],
};

export const creatorInsightPostSortOptionsUpdate = {
  INSTAGRAM: [
    {
      value: 'DATE',
      label: 'Recently Published',
    },
    {
      value: 'CROSS_CHANNEL_EMV',
      label: 'EMV',
    },
    {
      value: 'CROSS_CHANNEL_IMPRESSIONS',
      label: 'Views',
    },
  ],
  INSTAGRAM_FEED: [
    {
      value: 'DATE',
      label: 'Recently Published',
    },
    {
      value: 'INSTAGRAM_EFFECTIVENESS',
      label: 'Effectiveness',
    },
    {
      value: 'INSTAGRAM_ENGAGEMENT_RATE',
      label: 'Engagement Rate',
    },
    {
      value: 'INSTAGRAM_TOTAL_ENGAGEMENTS',
      label: 'Total Engagement',
    },
    {
      value: 'INSTAGRAM_REACH',
      label: 'Reach',
    },
    {
      value: 'INSTAGRAM_EMV',
      label: 'EMV',
    },
    {
      value: 'INSTAGRAM_FOLLOWERS_GAINED',
      label: 'Followers Gained',
    },
    {
      value: 'INSTAGRAM_VIEWS',
      label: 'Views',
    },
  ],
  INSTAGRAM_STORY: [
    {
      value: 'DATE',
      label: 'Recently Published',
    },
    {
      value: 'INSTAGRAM_STORY_FRAME_COMPLETION_RATE_VIEWS',
      label: 'Completion Rate',
    },
    {
      value: 'EMV',
      label: 'EMV',
    },
    {
      value: 'INSTAGRAM_STORY_FRAME_EXIT_RATE_VIEWS',
      label: 'Exit Rate',
    },
    {
      value: 'INSTAGRAM_STORY_FRAME_VIEWS_V2',
      label: 'Views',
    },
  ],
};

export const CREATOR_AVATAR_TOOLTIP = 'Creator deliverables date range:';

export const ADD_CREATORS_WIZARD_STEP_TWO_TEXTS = Object.freeze({
  NO_CREATORS: {
    PANEL_TITLE: 'Select Date Range',
    MESSAGE_HEADER: 'Select your creator Campaign dates',
    MESSAGE_BODY:
      'Choose a date range to automatically import content from your selected creators. Only posts mentioning your brand and published within this period will be added to this Campaign.',
  },
  HAS_CREATORS: {
    PANEL_TITLE: 'Review Date Range',
    MESSAGE_HEADER: 'Dates applied to Campaign. Add Creators to proceed.',
    MESSAGE_BODY:
      'Only posts mentioning your brand and published within this period will be added to this Campaign. Changes to this date range will affect all creator posts in this Campaign.',
  },
});

export const topPerformingCreatorsSortOptions = [
  { label: 'EMV', value: 'TOTAL_EMV' },
  { label: 'Likes', value: 'LIKES' },
  { label: 'Comments', value: 'COMMENTS' },
  { label: 'Avg. Engagements', value: 'AVG_ENGAGEMENT' },
  { label: 'Avg. Engagement Rate', value: 'AVG_ENGAGEMENT_RATE' },
  { label: 'Avg. Reach', value: 'AVG_REACH' },
  { label: 'Video Views', value: 'VIDEO_VIEWS' },
  { label: 'Impressions', value: 'TOTAL_IMPRESSIONS' },
  { label: 'Avg. Impressions', value: 'AVG_IMPRESSIONS' },
  { label: 'Avg. Completion Rate', value: 'AVG_COMPLETION_RATE' },
  { label: 'Instagram Followers', value: 'INSTAGRAM_FOLLOWERS' },
  { label: 'TikTok Followers', value: 'TIKTOK_FOLLOWERS' },
  { label: 'YouTube Subscribers', value: 'YOUTUBE_SUBSCRIBERS' },
];

export const POST_PERFORMANCE_POST_TYPES = {
  TIKTOK: 'TIKTOK',
  INSTAGRAM_FEED: 'FEED_POSTS',
  INSTAGRAM_STORY: 'STORY',
  YOUTUBE: 'YOUTUBE',
};

export const POST_PERFORMANCE_DEFAULT_POST_TYPES = [];

export const postTypeToMediaType = {
  TIKTOK_POSTS: 'TIKTOK_UGC',
  INSTAGRAM_FEED_REELS: 'INSTAGRAM_UGC',
  INSTAGRAM_STORIES: 'INSTAGRAM_STORY_UGC',
  YOUTUBE_VIDEOS: 'YOUTUBE_UGC',
  YOUTUBE_SHORTS: 'YOUTUBE_UGC',
};

export const POST_PERFORMANCE_POST_TYPES_SELECTED = {
  TIKTOK_POST: [POST_PERFORMANCE_POST_TYPES.TIKTOK],
  INSTAGRAM_FEED: [POST_PERFORMANCE_POST_TYPES.INSTAGRAM_FEED],
  INSTAGRAM_STORY: [POST_PERFORMANCE_POST_TYPES.INSTAGRAM_STORY],
  INSTAGRAM_ALL_POST_TYPES: [
    POST_PERFORMANCE_POST_TYPES.INSTAGRAM_FEED,
    POST_PERFORMANCE_POST_TYPES.INSTAGRAM_STORY,
  ],
  YOUTUBE: [POST_PERFORMANCE_POST_TYPES.YOUTUBE],
};

export const POST_PERFORMANCE_DEFAULT_SORT = ['-DATE'];

export const POST_PERFORMANCE_DEFAULT_MEDIA_TYPES = [
  'INSTAGRAM_UGC',
  'INSTAGRAM_STORY_UGC',
  'TIKTOK_UGC',
  'YOUTUBE_UGC',
];

export const REPORTING_PERIOD_SPECIAL_PRESETS = Object.freeze({
  ALL_TIME: {
    value: 'ALL_TIME',
    label: 'All Time',
  },
  CUSTOM: {
    value: 'CUSTOM',
    label: 'Custom',
  },
});

// This matches dashing-ui's `PresetType` type.
export const REPORTING_PERIOD_PRESETS = Object.freeze({
  LAST_24_HOURS: {
    value: 'LAST_24_HOURS',
    label: 'Last 24 Hours',
    range: ({ dateService } = {}) => lastDateRange(1, 'day', dateService),
  },
  LAST_3_DAYS: {
    value: 'LAST_3_DAYS',
    label: 'Last 3 Days',
    range: ({ dateService } = {}) => lastDateRange(3, 'day', dateService),
  },
  LAST_7_DAYS: {
    value: 'LAST_7_DAYS',
    label: 'Last 7 Days',
    range: ({ dateService } = {}) => lastDateRange(7, 'day', dateService),
  },
  LAST_4_WEEKS: {
    value: 'LAST_4_WEEKS',
    label: 'Last 4 Weeks',
    range: ({ dateService } = {}) => lastDateRange(28, 'day', dateService),
  },
});

export const CAMPAIGN_DETAIL_FILTER_SCOPE = 'campaignDetail';

export const CAMPAIGN_SWITCH_SCALE_THRESHOLD_DAYS = 60;

export const SOCIAL_COMMERCE_TOOLTIPS = Object.freeze({
  USERS: 'The number of unique users who have logged at least one event',
  SESSIONS: 'The number of website or app sessions initiated',
  CONVERSION_RATE: 'The percentage of sessions triggering a specific purchase conversion event',
  TRANSACTIONS: 'The number of transaction events with purchase revenue',
  REVENUE:
    'The sum of revenue during the reporting period from purchases, subscriptions and advertising, minus refunded transaction revenue',
});

export const SOCIAL_COMMERCE_TABLE_SORT_OPTIONS = Object.freeze([
  { label: 'Source / Medium', value: 'sourceMedium' },
  { label: 'Users', value: 'totalUsers' },
  { label: 'Sessions', value: 'sessions' },
  { label: 'Conversion Rate', value: 'ecommerceConversionRate' },
  { label: 'Transactions', value: 'transactions' },
  { label: 'Revenue', value: 'revenue' },
]);

export const CAMPAIGN_RELATIONSHIP_METRICS = Object.freeze([
  {
    title: 'Posts',
    valueKey: 'number_of_media',
    tooltip: 'The number of posts that mentioned or tagged you',
    format: 'number',
    postType: 'ORGANIC',
    metricTimeFrame: 'POSTS_THIS_PERIOD',
  },
  {
    title: 'Followers Gained',
    valueKey: 'followers_gained',
    tooltip: 'The estimated number of followers gained for you',
    format: 'number',
    postType: 'ORGANIC',
    metricTimeFrame: 'POSTS_THIS_PERIOD',
  },
  {
    title: 'Avg. Engagement Rate',
    valueKey: 'avg_engagement_rate',
    tooltip:
      "The average percentage of the poster's audience that engaged\n\nEngagement Rate = (Likes + Comments) / Followers",
    format: 'percent',
    formatOptions: {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    },
    postType: 'ORGANIC',
    metricTimeFrame: 'POSTS_THIS_PERIOD',
  },
  {
    title: 'Avg. Effectiveness',
    valueKey: 'avg_effectiveness_rate',
    tooltip:
      'The percentage of unique accounts who saw these posts and engaged with it\n\nEffectiveness = (Likes + Comments) / Est. Reach',
    format: 'percent',
    formatOptions: {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    },
    postType: 'ORGANIC',
    metricTimeFrame: 'POSTS_THIS_PERIOD',
  },
  {
    title: 'Engagements',
    valueKey: 'engagements',
    tooltip:
      'The total number of engagements received\n\nEngagements = Likes + Comments + (Saves + Shares + Reposts if connected)',
    format: 'number',
    postType: 'ORGANIC',
    metricTimeFrame: 'POSTS_THIS_PERIOD',
  },
  {
    title: 'Total EMV',
    valueKey: 'total_emv',
    tooltip:
      "The Earned Media Value of posts in this Campaign.\n\nThis value is based on the creators' audience size, media type, and number of engagements.",
    format: 'currency',
    formatOptions: { maximumFractionDigits: 0 },
    postType: 'ORGANIC',
    metricTimeFrame: 'POSTS_THIS_PERIOD',
  },
]);

export const NO_DATA_FOUND = 'No posts found during this reporting period.';
export const EMPTY_CHART_DATA_MESSAGE = 'Data during the reporting period will be displayed here';
export const ERROR_CHART_DATA_MESSAGE =
  'There was an issue loading your data. Please refresh the page to try again.';
export const PLATFORM_DISCONNECTED_MESSAGE = (platform) =>
  `Your ${platform} account has been disconnected. Please reconnect to see applicable data.`;

export const MEDIA_LIST_EMPTY_STATES = Object.freeze({
  NO_MEDIA_STATE: {
    title: "Couldn't Find a Match",
    variant: 'sectionEmpty',
    icon: 'search',
    message: 'Review or adjust your filters to uncover more results',
    ctaButton: { label: 'Reset Filters' },
  },
  ERROR_STATE: {
    title: "Couldn't Load Posts",
    variant: 'sectionEmpty',
    icon: 'alert-triangle',
    message: 'There was an issue loading your posts. Please refresh the page to try again.',
  },
});

export const ADS_LIST_EMPTY_STATES = Object.freeze({
  NO_ADS: {
    title: 'Your Ads will appear here',
    variant: 'sectionEmpty',
  },
  ERROR: {
    title: "Couldn't Load Ads",
    variant: 'sectionEmpty',
    icon: 'alert-triangle',
    message: 'There was an issue loading your ads. Please refresh the page to try again.',
  },
});

export const CAMPAIGN_EMPTY_STATE_IMAGES = {
  ADD_BOARDS: {
    BANNER_SRC: emptyCampaignAddBoards1x,
    BANNER_SRC_SET: srcSet(
      emptyCampaignAddBoards1x,
      emptyCampaignAddBoards2x,
      emptyCampaignAddBoards3x,
    ),
  },
  ADD_MEDIA: {
    BANNER_SRC: emptyCampaignAddMedia1x,
    BANNER_SRC_SET: srcSet(
      emptyCampaignAddMedia1x,
      emptyCampaignAddMedia2x,
      emptyCampaignAddMedia3x,
    ),
  },
  ADD_CREATORS: {
    BANNER_SRC: emptyCampaignAddCreators1x,
    BANNER_SRC_SET: srcSet(
      emptyCampaignAddCreators1x,
      emptyCampaignAddCreators2x,
      emptyCampaignAddCreators3x,
    ),
  },
  ADD_AD_CAMPAIGNS: {
    BANNER_SRC: emptyCampaignAddAdCampaigns1x,
    BANNER_SRC_SET: srcSet(
      emptyCampaignAddAdCampaigns1x,
      emptyCampaignAddAdCampaigns2x,
      emptyCampaignAddAdCampaigns3x,
    ),
  },
};

export const CAMPAIGN_EMPTY_STATE_IMAGES_NEW = {
  ADD_BOARDS: {
    BANNER_SRC: newEmptyCampaignAddBoards1x,
    BANNER_SRC_SET: srcSet(
      newEmptyCampaignAddBoards1x,
      newEmptyCampaignAddBoards2x,
      newEmptyCampaignAddBoards3x,
    ),
  },
  ADD_MEDIA: {
    BANNER_SRC: newEmptyCampaignAddMedia1x,
    BANNER_SRC_SET: srcSet(
      newEmptyCampaignAddMedia1x,
      newEmptyCampaignAddMedia2x,
      newEmptyCampaignAddMedia3x,
    ),
  },
  ADD_CREATORS: {
    BANNER_SRC: newEmptyCampaignAddCreators1x,
    BANNER_SRC_SET: srcSet(
      newEmptyCampaignAddCreators1x,
      newEmptyCampaignAddCreators2x,
      newEmptyCampaignAddCreators3x,
    ),
  },
  ADD_AD_CAMPAIGNS: {
    BANNER_SRC: newEmptyCampaignAddAdCampaigns1x,
    BANNER_SRC_SET: srcSet(
      newEmptyCampaignAddAdCampaigns1x,
      newEmptyCampaignAddAdCampaigns2x,
      newEmptyCampaignAddAdCampaigns3x,
    ),
  },
};

export const CAMPAIGN_METRICS = {
  creator: [
    {
      label: 'Avg. Engagements',
      value: 'avg_engagements',
      formatType: 'number',
    },
    {
      label: 'Avg. Engagement Rate',
      value: 'avg_engagement_rate',
      formatType: 'percent',
      formatOptions: {
        style: 'percent',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      },
    },
    {
      label: 'Likes',
      value: 'total_creator_likes',
      formatType: 'number',
    },
    {
      label: 'EMV',
      value: 'total_emv',
      formatType: 'currency',
      formatOptions: { maximumFractionDigits: 0 },
    },
  ],
  owned: [
    {
      label: 'Avg. Engagement Rate',
      value: 'avg_engagement_rate',
      formatType: 'percent',
      formatOptions: {
        style: 'percent',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      },
    },
    {
      label: 'Engagements',
      value: 'total_engagements',
      formatType: 'number',
    },
    {
      label: 'Impressions',
      value: 'total_impressions',
      formatType: 'number',
    },
    {
      label: 'Video Views',
      value: 'total_video_views',
      formatType: 'number',
    },
  ],
};

export const SHOPIFY_PRODUCT_FILTER_DETAILS = {
  scope: 'shopifyProducts',
  defaultState: {
    price: { min: null, max: null },
    inventoryCount: { min: null, max: null },
    stockStatus: [],
    category: [],
    type: [],
  },
  options: {
    stockStatus: [
      { label: 'In Stock', value: 'IN_STOCK' },
      { label: 'Out of Stock', value: 'OUT_OF_STOCK' },
    ],
  },
};

export const METRIC_TYPE_TO_DASHING_UI_FORMAT = Object.freeze({
  [METRIC_DATA_TYPES.INTEGER]: Formatters.FORMAT_TYPES.NUMBER,
  [METRIC_DATA_TYPES.FLOAT]: Formatters.FORMAT_TYPES.NUMBER,
  [METRIC_DATA_TYPES.MONETARY]: Formatters.FORMAT_TYPES.CURRENCY,
  [METRIC_DATA_TYPES.PERCENTAGE]: Formatters.FORMAT_TYPES.PERCENT,
});

export const FRACTIONAL_METRIC_TYPES = Object.freeze([
  METRIC_DATA_TYPES.FLOAT,
  METRIC_DATA_TYPES.PERCENTAGE,
]);

export const CAMPAIGN_ADS_GRAPHS = Object.freeze({
  [AD_SOURCES.META_ADS]: [
    {
      title: 'Amount Spent vs ROAS',
      tooltip: {
        content:
          'Track your Meta ad spend against return on ad spend (ROAS). Use this to evaluate paid campaign efficiency.',
        footer: 'ROAS = Purchase Conversion ÷ Amount Spent',
      },
      metrics: [{ key: 'TOTAL_SPENT' }, { key: 'RETURN_ON_AD_SPEND' }],
    },
    {
      title: 'Clicks (All) vs CPC',
      tooltip:
        'Track total ad clicks alongside cost per click to help optimize campaigns for cost-effective engagement',
      metrics: [{ key: 'CLICKS' }, { key: 'COST_PER_CLICK' }],
    },
  ],
  [AD_SOURCES.TIKTOK_ADS]: [
    {
      title: 'Amount Spent vs Reach',
      tooltip:
        'Compares your TikTok ad spend to the number of users reached over time. Use this to understand how efficiently your budget is scaling audience exposure.',
      metrics: [{ key: 'TOTAL_SPENT' }, { key: 'REACH' }],
    },
    {
      title: 'Clicks vs CPC',
      tooltip:
        'Track total ad clicks alongside cost per click to help optimize campaigns for cost-effective conversion',
      metrics: [{ key: 'CLICKS' }, { key: 'COST_PER_CLICK' }],
    },
  ],
});

export const CAMPAIGN_ADS_DEFAULT_SORT = {
  [AD_SOURCES.META_ADS]: '-CTR',
  [AD_SOURCES.META_ADS_CAMPAIGNS_DETAIL]: 'CTR',
  [AD_SOURCES.TIKTOK_ADS]: '-TIKTOK_AD_CPM',
};

export const CAMPAIGN_ADS_SORT_OPTIONS = {
  [AD_SOURCES.META_ADS]: [
    { value: 'SPEND', metricKey: 'TOTAL_SPENT' },
    { value: 'CLICKS' },
    { value: 'CONVERSION_RATE' },
    { value: 'CPC', metricKey: 'COST_PER_CLICK' },
    { value: 'CPM', metricKey: 'COST_PER_MILE' },
    { value: 'CTR', metricKey: 'CLICK_THROUGH_RATE' },
    { value: 'ENGAGEMENT_RATE' },
    { value: 'ENGAGEMENTS' },
    { value: 'FREQUENCY' },
    { value: 'IMPRESSIONS' },
    { value: 'LINK_CLICKS' },
    { value: 'PAGE_ENGAGEMENTS' },
    { value: 'REACH' },
    { value: 'ROAS', metricKey: 'RETURN_ON_AD_SPEND' },
    { value: 'VIDEO_VIEWS' },
    { value: 'WEB_CONVERSIONS' },
  ],
  [AD_SOURCES.TIKTOK_ADS]: [
    { value: 'TIKTOK_AD_AMOUNT_SPENT', metricKey: 'TOTAL_SPENT' },
    { value: 'TIKTOK_AD_CLICKS', metricKey: 'CLICKS' },
    { value: 'TIKTOK_AD_CLICKS_ALL', metricKey: 'ENGAGEMENTS' },
    { value: 'TIKTOK_AD_CPC', metricKey: 'COST_PER_CLICK' },
    { value: 'TIKTOK_AD_CPM', metricKey: 'COST_PER_MILE' },
    { value: 'TIKTOK_AD_CTR', metricKey: 'CLICK_THROUGH_RATE_DESTINATION' },
    { value: 'TIKTOK_AD_ENGAGED_VIEWS', metricKey: 'ENGAGED_VIEW' },
    { value: 'TIKTOK_AD_FREQUENCY', metricKey: 'FREQUENCY' },
    { value: 'TIKTOK_AD_IMPRESSIONS', metricKey: 'IMPRESSIONS' },
    { value: 'TIKTOK_AD_REACH', metricKey: 'REACH' },
    { value: 'TIKTOK_AD_REAL_TIME_CONVERSION_RATE', metricKey: 'REAL_TIME_CONVERSION_RATE' },
    { value: 'TIKTOK_AD_REAL_TIME_CONVERSION', metricKey: 'REAL_TIME_CONVERSIONS' },
    { value: 'TIKTOK_AD_VIDEO_VIEWS_50_PERCENT', metricKey: 'VIDEO_VIEWS_P50' },
    { value: 'TIKTOK_AD_VIDEO_VIEWS_100_PERCENT', metricKey: 'VIDEO_VIEWS_P100' },
    { value: 'TIKTOK_AD_VIDEO_WATCHED_6_SEC', metricKey: 'VIDEO_WATCHED_6S' },
  ],
};

export const EXCLUDED_POSTS_MESSAGE = {
  title: 'Excluded Posts',
  message:
    'These posts are now excluded from your Campaign performance metrics. To see all excluded posts, use the filter options below.',
  severity: 'info',
  ctaText: "Don't Show Again",
};

export const INCLUDED_POSTS_MESSAGE = {
  title: 'Included Posts',
  message:
    'These posts are now included in your Campaign performance metrics. To see all included posts, use the filter options below.',
  severity: 'info',
  ctaText: "Don't Show Again",
};

export const CREATOR_INSIGHTS_ERROR_MESSAGES = {
  INCLUDE_POSTS_ERROR:
    'An error occurred while including posts. Please wait a moment before trying again',
  EXCLUDE_POSTS_ERROR:
    'An error occurred while excluding posts. Please wait a moment before trying again',
};

export const AD_CAMPAIGN_STATUS_CONFIG = Object.freeze({
  ACTIVE: {
    label: 'Active',
    badgeSeverity: 'success',
  },
  PAUSED: {
    label: 'Paused',
    badgeSeverity: 'warning',
  },
  ARCHIVED: {
    label: 'Archived',
    badgeSeverity: 'statusNeutral',
  },
  DISABLE: {
    label: 'Paused',
    badgeSeverity: 'warning',
  },
  ENABLE: {
    label: 'Active',
    badgeSeverity: 'success',
  },
  DELETE: {
    label: 'Deleted',
    badgeSeverity: 'statusNeutral',
  },
  BUDGET_EXCEED: {
    label: 'Overbudget',
    badgeSeverity: 'error',
  },
  WITH_ISSUES: {
    label: 'With Issues',
    badgeSeverity: 'error',
  },
});

export const CREATOR_CAMPAIGNS_CHANNEL_OPTIONS = [
  {
    label: 'TikTok',
    value: 'TIKTOK',
    icon: 'tiktok-color',
    mediaTypes: ['TIKTOK_UGC'],
  },
  {
    label: 'Instagram',
    value: 'INSTAGRAM',
    icon: 'instagram-color',
    mediaTypes: ['INSTAGRAM_UGC', 'INSTAGRAM_STORY_UGC'],
  },
  {
    label: 'YouTube',
    value: 'YOUTUBE',
    icon: 'youtube-color',
    mediaTypes: ['YOUTUBE_UGC'],
  },
];

export const CREATOR_CAMPAIGNS_POST_TYPE_OPTIONS = [
  {
    label: 'TikTok Posts',
    value: 'TIKTOK_POSTS',
    icon: 'tiktok-color',
    requiredChannels: ['TIKTOK'],
  },
  {
    label: 'Instagram Feed and Reels',
    value: 'INSTAGRAM_FEED_REELS',
    icon: 'instagram-color',
    requiredChannels: ['INSTAGRAM'],
  },
  {
    label: 'Instagram Stories',
    value: 'INSTAGRAM_STORIES',
    icon: 'instagram-story-color',
    requiredChannels: ['INSTAGRAM'],
  },
  {
    label: 'YouTube Videos',
    value: 'YOUTUBE_VIDEOS',
    icon: 'youtube-color',
    requiredChannels: ['YOUTUBE'],
    tooltip: 'YouTube post types can only be refined when YouTube channel is selected alone',
  },
  {
    label: 'YouTube Shorts',
    value: 'YOUTUBE_SHORTS',
    icon: 'youtube-short-color',
    requiredChannels: ['YOUTUBE'],
    tooltip: 'YouTube post types can only be refined when YouTube channel is selected alone',
  },
];

export const campaignCreatorInsightsYouTubeChannelStats = [
  {
    label: 'Creators',
    value: 'totalCreators',
    formatType: 'formatIntegerAbbreviated',
    tooltip: 'The number of creators in this campaign with a YouTube handle added to their profile',
  },
  {
    label: 'Subscribers',
    value: 'audienceSize',
    formatType: 'formatIntegerAbbreviated',
    tooltip: 'The number of subscribers this creator has on YouTube',
  },
  {
    label: 'EMV',
    value: 'emv',
    formatType: 'formatCurrency',
    tooltip:
      'The total earned media value for all YouTube posts in this campaign.' +
      '\n\n' +
      'EMV is calculated by factoring in the channel, audience size, content type, engagement and current market values for comparable posts.',
  },
  {
    label: 'Avg. EMV',
    value: 'avgEmv',
    formatType: 'formatCurrency',
    tooltip:
      'The average earned media value of YouTube creators in this campaign.\n\nEMV is calculated by factoring in the channel, content type, engagement and current market values for comparable posts.',
  },
  {
    label: 'Engagements',
    value: 'engagements',
    formatType: 'formatIntegerAbbreviated',
    tooltip:
      'The total engagements across all YouTube creators’ posts in this campaign.\n\nEngagements = Likes + Comments',
  },
  {
    label: 'Avg. Engagements',
    value: 'avgEngagements',
    formatType: 'formatIntegerAbbreviated',
    tooltip:
      'The average number of engagements per YouTube post in this campaign.\n\nEngagements = Likes + Comments',
  },
  {
    label: 'Avg. Engagement Rate',
    value: 'avgEngagementRate',
    formatType: 'formatPercentage',
    tooltip:
      'The average engagement rate across YouTube posts in this campaign.\n\nEngagement Rate = (Likes + Comments) / Views',
  },
  {
    label: 'Views',
    value: 'views',
    formatType: 'formatIntegerAbbreviated',
    tooltip: 'The total number of video views across all YouTube posts in this campaign',
  },
  {
    label: 'Avg. Views',
    value: 'avgViews',
    formatType: 'formatIntegerAbbreviated',
    tooltip: 'The average number of video views per YouTube post across this campaign',
  },
  {
    label: 'Likes',
    value: 'likes',
    formatType: 'formatIntegerAbbreviated',
    tooltip: 'The total number of likes across all YouTube posts in this campaign',
  },
  {
    label: 'Avg. Likes',
    value: 'avgLikes',
    formatType: 'formatIntegerAbbreviated',
    tooltip: 'The average number of likes per YouTube post across this campaign',
  },
  {
    label: 'Comments',
    value: 'comments',
    formatType: 'formatIntegerAbbreviated',
    tooltip: 'The total number of comments across all YouTube posts in this campaign',
  },
  {
    label: 'Avg. Comments',
    value: 'avgComments',
    formatType: 'formatIntegerAbbreviated',
    tooltip: 'The average number of comments per YouTube post across this campaign',
  },
  {
    label: 'Net New Subscribers',
    value: 'netNewSubscribers',
    formatType: 'formatIntegerAbbreviated',
    tooltip:
      'The net number of new YouTube subscribers your channel has gained or lost during this campaign date range.',
  },
];

export const HIDDEN_YOUTUBE_METRICS = [
  'avgLikes',
  'avgComments',
  'emv',
  'avgEmv',
  'engagements',
  'avgEngagements',
  'avgEngagementRate',
  'netNewSubscribers',
];

export const CAMPAIGN_BENCHMARKS_GRAPH_COLORS = Object.freeze({
  CAMPAIGN_AVERAGE_MARKER: '#19A695',
  COMPARISON_CAMPAIGN_MARKER: '#F75C9C',
  CHANNEL_AVERAGE_MARKER: '#0872ee',
  CAMPAIGN_DATA: '#3F6B9F',
});

export const COMPARISON_CAMPAIGNS_LEGEND_ITEM_VALUE = 'ComparisonCampaignsLegendItem';

export const AFFILIATE_LINKS = Object.freeze({
  TOOLTIPS: {
    LINK_NAME: 'A name to identify your affiliate link',
    DOMAIN: 'The domain used for this link',
    CUSTOM_BACK_HALF: 'The custom back half used for this link',
    UTM_PARAMETERS:
      'Toggle on to add campaign tracking details (source, medium, term, content, campaign). Toggle off to hide these fields.',
    UTM_SOURCE: 'Identifies where the traffic is coming from (e.g., facebook, tiktok, newsletter)',
    UTM_MEDIUM: 'Defines the type of traffic channel (e.g., cpc, email, social)',
    UTM_CAMPAIGN:
      'Pre-filled with the Dash campaign name and creator handle. You can edit this to customize tracking.',
    UTM_TERM: 'Keyword for paid search ads',
    UTM_CONTENT: 'Optional label to differentiate ad creatives',
    TARGET_URL: 'The original destination this affiliate link redirects to',
    SHORT_LINK: 'The affiliate link that redirects to the target URL',
    CLICKS: 'The number of times this affiliate link has been clicked',
  },
  BANNER_INFO: {
    TITLE: 'Domain selection is final',
    MESSAGE:
      "Once you choose a domain and save your affiliate link, the domain can't be changed. To use a different domain, you'll need to create a new link.",
  },
  BANNER_ERROR: {
    TITLE: 'Bitly Error',
    MESSAGE:
      "We couldn't complete your request with Bitly. This may be due to usage limits or other restrictions. Please try again, or contact Bitly Support if the issue continues.",
  },
  DELETE_CONFIRMATION: {
    HEADER: 'Delete Link?',
    MESSAGE:
      "Deleting this link will remove its details and click data from Dash Social. This action can't be undone.\n\nTo delete the link permanently, remove it from your Bitly account.",
    ACCEPT_LABEL: 'Delete',
  },
  TRACKING_EVENTS: {
    DELETE_POPUP_OPENED: 'Delete link popup opened',
    LINK_DELETED: 'Link Deleted',
  },
});

export const METRIC_SOURCE = Object.freeze({
  CAMPAIGN_STATS: 'campaign_stats',
  CUSTOM_METRICS: 'custom_metrics',
  DASHBOARDS: 'dashboards',
  CREATOR_INSIGHTS: 'creator_insights',
});

export const OWNED_SUMMARY_DEFAULT_METRICS = Object.freeze([
  {
    source: METRIC_SOURCE.CAMPAIGN_STATS,
    metric: 'number_of_media',
  },
  {
    source: METRIC_SOURCE.CAMPAIGN_STATS,
    metric: 'video_views_v2',
  },
  {
    source: METRIC_SOURCE.CAMPAIGN_STATS,
    metric: 'engagements',
  },
  {
    source: METRIC_SOURCE.CAMPAIGN_STATS,
    metric: 'avg_engagement_rate',
  },
  {
    source: METRIC_SOURCE.CAMPAIGN_STATS,
    metric: 'impressions_v2',
  },
  {
    source: METRIC_SOURCE.CAMPAIGN_STATS,
    metric: 'link_clicks',
  },
]);

export const SENTIMENT_COLORS = Object.freeze({
  positive: TOKENS.COLOR_SENTIMENT_POSITIVE,
  negative: TOKENS.COLOR_SENTIMENT_NEGATIVE,
  neutral: TOKENS.COLOR_SENTIMENT_NEUTRAL,
});

export const ACTIVE_PRODUCT_ORDER_STATUSES = Object.freeze([
  'IN_PROGRESS',
  'ON_HOLD',
  'PARTIALLY_FULFILLED',
  'SCHEDULED',
  'UNFULFILLED',
  'PENDING_FULFILLMENT',
]);

export const VALID_CAMPAIGN_BRAND_MEDIA_TYPES = Object.freeze([
  enumTypes.FACEBOOK_OWNED,
  enumTypes.FACEBOOK_LINK,
  enumTypes.FACEBOOK_TEXT_LINK,
  enumTypes.FACEBOOK_TEXT,
  enumTypes.INSTAGRAM_OWNED,
  enumTypes.INSTAGRAM_OWNED_IGTV,
  enumTypes.INSTAGRAM_STORY,
  enumTypes.PINTEREST_OWNED,
  enumTypes.TIKTOK_OWNED,
  enumTypes.TWITTER_OWNED,
  enumTypes.TWITTER_OWNED_LINK,
  enumTypes.TWITTER_OWNED_TEXT,
  enumTypes.YOUTUBE_OWNED,
  enumTypes.INSTAGRAM_UGC,
  enumTypes.INSTAGRAM_UGC_IGTV,
  enumTypes.INSTAGRAM_STORY_UGC,
]);
